'use strict';

var Helpers = Helpers || {};

Helpers.AccountingOperations = {};

Helpers.AccountingOperations.CalculateValue = function (quantity, unitValue, firstDiscount, secondDiscount, thirdDiscount, vatTax, decimalPlaces) {
    quantity = +quantity || 0;
    unitValue = +unitValue || 0;
    firstDiscount = +firstDiscount || 0;
    secondDiscount = +secondDiscount || 0;
    thirdDiscount = +thirdDiscount || 0;
    vatTax = +vatTax || 0;
    decimalPlaces = +decimalPlaces || 2;

    let totalValue = (quantity * unitValue * (1 - firstDiscount / 100) * (1 - secondDiscount / 100) * (1 - thirdDiscount / 100));

    totalValue = Helpers.AccountingOperations.RoundValue(totalValue, decimalPlaces);
    vatTax = (vatTax < 1) ? vatTax : (vatTax / 100);

    let vatValue = Helpers.AccountingOperations.RoundValue(((totalValue / (1 + vatTax)) * vatTax), decimalPlaces);
    let netValue = Helpers.AccountingOperations.RoundValue((totalValue - vatValue), decimalPlaces);

    let accountingValues = {
        netValue: netValue,
        vatValue: vatValue,
        totalValue: totalValue
    }

    return accountingValues;
};

Helpers.AccountingOperations.RoundValue = function (value, decimalPlaces) {
    decimalPlaces = decimalPlaces || 2;

    let factor = Math.pow(10, decimalPlaces);
    let roundedValue = (Math.round(value * factor) / factor);

    return roundedValue;
};
"use strict";

var Helpers = Helpers || {};
var modules = {};

Helpers.AngularModules = {
    InitializeAngularModules: function (modules) {
        this.modules = modules;
    },
    GetAngularModules: function () {
        return this.modules;
    },
    SetAngularModule: function (module) {
        var key = Object.keys(module)[0];

        if (Helpers.Object.IsUndefinedEmptyOrNull(Helpers.Object.GetObjectByString(key))) {
            return;
        }

        this.modules[key] = module[key];
    }
};
(function () {
    "use strict";
    myApp.service('ArrayOperations', ["$filter", function ($filter) {
        this.Exist = function (array, expression, comparator) {
            var arrayFiltered = $filter('filter')(array, expression, comparator);

            if (!arrayFiltered.length) {
                return false;
            }

            return true;
        };
    }]);

    Array.prototype.remove = function (objectToDelete) {
        var arrayToDelete = [objectToDelete];

        this.removeRange(arrayToDelete);

        return this;
    };

    Array.prototype.removeRange = function (arrayToDelete) {
        var arrayLength = arrayToDelete.length
        var previousItem, previousItemIndex;

        while (arrayLength && this.length) {
            previousItem = arrayToDelete[--arrayLength];

            while ((previousItemIndex = this.indexOf(previousItem)) !== -1) {
                this.splice(previousItemIndex, 1);
            }
        }

        return this;
    };

    Array.prototype.removeIf = function (expression) {
        var arrayToDelete = this.filter(filter => expression(filter))

        this.removeRange(arrayToDelete);

        return this;
    }

    Array.prototype.clear = function () {
        this.length = 0;

        return this;
    };

    Array.prototype.pushRange = function (arrayToAdd) {
        for (var i = 0; i < arrayToAdd.length; i++) {
            this.push(arrayToAdd[i]);
        }
    };

    Array.prototype.max = function (prop) {
        if (!this.length) {
            return undefined;
        }

        var maximum;

        for (var i = 0, _len = this.length; i < _len; i++) {
            var element = this[i];

            if (!maximum) {
                maximum = element[prop];

                continue;
            }

            if (element[prop] > maximum) {
                maximum = element[prop];
            }
        }

        return maximum;
    }

    Array.prototype.sum = function (prop, precision) {
        var total = 0

        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }

        if (precision) {
            total = parseFloat(total.toFixed(precision));
        }

        return total;
    }

    Array.prototype.count = function (prop, value) {
        var count = 0

        for (var i = 0, _len = this.length; i < _len; i++) {
            var element = this[i];

            if (!element[prop]) {
                continue;
            }

            if (element[prop] === value) {
                count++;
            }
        }

        return count;
    }

    Array.prototype.distinct = function (property) {
        var distinctValues = [...new Set(this.map(item => item[property]))];

        return distinctValues;
    }
})();
"use strict";

var Helpers = Helpers || {};
Helpers.BlobOperations = {};

Helpers.BlobOperations.ExtractData = function (blob) {
    var url = URL.createObjectURL(blob);
    var request = new XMLHttpRequest();   
    
    request.open('GET', url, false);
    request.send();

    URL.revokeObjectURL(url);

    return request.responseText;
}

//#region Converts
Helpers.BlobOperations.Converts = {};

Helpers.BlobOperations.Converts.FromFileArray = function (fileArray, blobType) {
    if (!fileArray || !blobType) {
        return;
    }

    const decodeToBinary = atob(fileArray);
    const byteNumbers = new Uint8Array(decodeToBinary.length);

    for (let i = 0; i < decodeToBinary.length; i++) {
        byteNumbers[i] = decodeToBinary.charCodeAt(i);
    }

    const blob = new Blob([byteNumbers], { type: blobType });

    return blob;
};
//#endregion
"use strict";

var Helpers = Helpers || {};
Helpers.BreadCrumbs = {};

Helpers.BreadCrumbs.RemoveBreadCrumbs = function () {
    sessionStorage.removeItem('BreadCrumbs');
};
"use strict";

var Helpers = Helpers || {};
Helpers.Concurrency = {};

Helpers.Concurrency.GetElementHtmlByServerDataContent = function (serverDataContent, deleted) {
    var htmlContent;

    if (deleted) {
        htmlContent = '<span class="InfoTextServer"><span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone"><span class="PopUpTitle">{{:refresh: \'DeletedRegister\' | Translations}}</span></span></span>';

        return htmlContent;
    }

    var completeServerData = '';

    for (var c = 0; c < serverDataContent.length; c++) {
        var item = serverDataContent[c];

        if (angular.isArray(item.data) && item.data.length) {
            var objectHtml = "<ul>";

            for (var s = 0; s < item.data.length; s++) {
                objectHtml += "<li>" + item.data[s] + "</li>";
            }

            objectHtml += "</ul>";
            completeServerData = completeServerData + '<p>' + item.caption + ': ' + objectHtml + '</p>';
        }
        else if ((item.data !== '') && (typeof item.data !== 'undefined')) {
            completeServerData = completeServerData + '<p>' + item.caption + ': ' + item.data + '</p>';
        }
    }

    htmlContent = '<span class="InfoTextServer"><span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone"><span class="PopUpTitle"> {{:refresh: \'ServerData\' | Translations}}</span><br>' + completeServerData + '</span></span>' + '<span id="GoBackMainObject" ng-click="BackServerInformation($event)" class="lnr lnr-undo">';

    return htmlContent;
};

Helpers.Concurrency.PopupConcurrencyData = function () {
    angular.element('.InfoTextServer').off('mouseover').mouseover(function () {
        angular.element('.PopUp', this).css({ 'top': 0, 'right': 30 });
        angular.element('.PopUp', this).removeClass('DisplayNone');
    });

    angular.element('.InfoTextServer').off('mouseout').mouseout(function () {
        angular.element('.PopUp', this).addClass('DisplayNone');
    });
};

"use strict";

var Helpers = Helpers || {};
Helpers.Date = {};

//#region Validates
Helpers.Date.ValidateDayInMonth = function (day, month) {
    if (Helpers.Object.IsUndefinedEmptyOrNull(day) || Helpers.Object.IsUndefinedEmptyOrNull(month)) {
        return true;
    }

    switch (month) {
        case 2:
            if (day > 29) {
                return false;
            }

            return true;
        case 4:
        case 6:
        case 9:
        case 11:
            if (day > 30) {
                return false;
            }

            return true;
        default:
            return true;
    }
};

Helpers.Date.ValidatePeriodStartDateLowerOrEqualEndDate = function (startDate, endDate) {
    startDate = new Date(startDate)
    endDate = new Date(endDate)

    if (startDate > endDate) {
        return false;
    }

    return true;
}
//#endregion

//#region Gets
Helpers.Date.GetDatePartsByDate = function (date) {
    var newDate = new Date(date);

    return {
        year: newDate.getFullYear().toString(),
        month: newDate.getMonth() < 10 ? "0" + newDate.getMonth().toString() : newDate.getMonth().toString(),
        day: newDate.getDate() < 10 ? "0" + newDate.getDate().toString() : newDate.getDate().toString(),
        hour: newDate.getHours() < 10 ? "0" + newDate.getHours().toString() : newDate.getHours().toString(),
        minutes: newDate.getMinutes() < 10 ? "0" + newDate.getMinutes().toString() : newDate.getMinutes().toString(),
        seconds: newDate.getSeconds() < 10 ? "0" + newDate.getSeconds().toString() : newDate.getSeconds().toString()
    };
};

Helpers.Date.GetMaxDate = function (year, month) {
    let date = new Date(year, (month + 1), 0, 23, 59, 59);

    return date;
};

Helpers.Date.GetPreviousDateByMonths = function (date, numberOfMonths) {
    let newDate = new Date(date);
    let month = newDate.getMonth()

    newDate.setMonth(newDate.getMonth() - numberOfMonths);

    while (newDate.getMonth() === month) {
        newDate.setDate(newDate.getDate() - 1);
    }

    return newDate;
};

Helpers.Date.GetDateFromTimeString = function (timeString) {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    let date = new Date();

    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    return date;
};

Helpers.Date.GetToday = function () {
    let today = new Date();

    today.setHours(0, 0, 0, 0);

    return today;
}

Helpers.Date.GetMonthsListBetweenDates = function (startDate, endDate) {
    let monthList = [];

    let startMonth = startDate.getMonth() + 1;
    let startYear = startDate.getFullYear();

    let endMonth = endDate.getMonth() + 1;
    let endYear = endDate.getFullYear();

    while (((startMonth <= endMonth) || (startYear != endYear)) && (startYear <= endYear)) {
        let month = startMonth.toString().padStart(2, 0);

        monthList.push(`${startYear}/${month}`)

        if (startMonth == 12) {
            startMonth = 1;
            startYear++;
        } else {
            startMonth++;
        }
    }

    return monthList;
};

Helpers.Date.GetDaysBetweenDates = function (startDate, endDate, daysOfTheWeekToIgnore, daysToIgnore) {
    let seconds = Helpers.Date.GetSecondsBetweenDates(startDate, endDate, daysOfTheWeekToIgnore, daysToIgnore);

    let days = (seconds / (60 * 60 * 24));

    return days;
};

Helpers.Date.GetHoursBetweenDates = function (startDate, endDate, daysOfTheWeekToIgnore, daysToIgnore) {
    let seconds = Helpers.Date.GetSecondsBetweenDates(startDate, endDate, daysOfTheWeekToIgnore, daysToIgnore);

    let hours = (seconds / (60 * 60));

    return hours;
};

Helpers.Date.GetSecondsBetweenDates = function (startDate, endDate, daysOfTheWeekToIgnore, daysToIgnore) {
    startDate = new Date(startDate);
    endDate = new Date(endDate);

    if (daysOfTheWeekToIgnore || daysToIgnore) {
        daysToIgnore = daysToIgnore || [];
        daysOfTheWeekToIgnore = daysOfTheWeekToIgnore || [];

        let daysAfterFiltering = 0;
        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            const dayOfWeek = currentDate.getDay();

            let isDayValid = !daysOfTheWeekToIgnore.includes(dayOfWeek);

            if (isDayValid) {
                isDayValid = !daysToIgnore.find(dayToIgnore => (currentDate.getDate() === dayToIgnore.getDate()) && (currentDate.getMonth() === dayToIgnore.getMonth()) && (currentDate.getFullYear() === dayToIgnore.getFullYear()));
            }

            if (isDayValid) {
                daysAfterFiltering++;
            }

            currentDate.setDate(currentDate.getDate() + 1);
        }

        return daysAfterFiltering
    }

    let differenceInMilliseconds = (endDate - startDate);
    let seconds = (differenceInMilliseconds / 1000);

    return seconds;
};

Helpers.Date.GetLatestDate = function (...dateArray) {
    dateArray.forEach((date, index) => {
        let isDate = (date instanceof Date);

        if (!isDate) {
            dateArray[index] = new Date(date);
        }
    })

    let latestDate = new Date(Math.max(...dateArray));

    return latestDate;
}

Helpers.Date.GetDateWithDifferenceBetweenDates = function (startDate, endDate) {
    const diffMilli = new Date(endDate) - new Date(startDate);
    const today = Helpers.Date.GetToday();
    const dateWithDifference = new Date(today.getTime() + diffMilli);

    return dateWithDifference;
}
//#endregion

Helpers.Date.FormatSecondsToTimeSpanString = function (totalSeconds, alwaysShowDays, withoutSeconds, withMilliseconds, multiDayDuration) {
    if (isNaN(totalSeconds)) {
        totalSeconds = 0;
    }

    let isNegative = (totalSeconds < 0);
    let valueInTimeFormat = '00:00:00';

    totalSeconds = Math.abs(totalSeconds);

    if (totalSeconds > 0) {
        let days = multiDayDuration ? 0 : Math.floor(totalSeconds / (3600 * 24));

        let hours = Math.floor(multiDayDuration ? (totalSeconds / 3600) : (totalSeconds % (3600 * 24) / 3600));
        let minutes = Math.floor(totalSeconds % 3600 / 60);
        let seconds = Math.floor(totalSeconds % 60);

        let daysToDisplay = (days > 0) ? days.toString().padStart(2, '0') + "." : "";

        let hoursToDisplay;

        if (multiDayDuration) {
            hoursToDisplay = (hours > 0) ? (hours.toString() + (":")) : "00:";
        } else {
            hoursToDisplay = (hours > 0) ? ('0' + hours.toString()).slice(-2) + (":") : "00:";
        }

        let minutesToDisplay = (minutes > 0) ? ('0' + minutes.toString()).slice(-2) + (":") : "00:";
        let secondsToDisplay = (seconds > 0) ? ('0' + seconds.toString()).slice(-2) : "00";

        if (!daysToDisplay && alwaysShowDays) {
            daysToDisplay = '00.';
        }

        valueInTimeFormat = daysToDisplay + hoursToDisplay + minutesToDisplay + secondsToDisplay;

        if (withMilliseconds) {
            let milliseconds = Math.floor((totalSeconds % 1) * 1000);
            let millisecondsToDisplay = "." + milliseconds.toString().padStart(3, '0');

            valueInTimeFormat += millisecondsToDisplay;
        }
    }
    else if (alwaysShowDays) {
        valueInTimeFormat = '00.' + valueInTimeFormat;
    }

    if (withoutSeconds) {
        valueInTimeFormat = valueInTimeFormat.slice(0, -3);
    }

    if (isNegative) {
        valueInTimeFormat = "-" + valueInTimeFormat;
    }

    return valueInTimeFormat;
};

Helpers.Date.FormatSecondsFloatToTimeSpanString = function (totalSeconds) {
    var valueInTimeFormat = new Date(0, 0, 0, 0, 0, 0, 0);

    if (totalSeconds > 0) {
        var days = Math.floor(totalSeconds / (3600 * 24));
        var hours = Math.floor(totalSeconds % (3600 * 24) / 3600);
        var minutes = Math.floor(totalSeconds % 3600 / 60);
        var seconds = Math.floor(totalSeconds % 60);
        var milliseconds = Math.floor((totalSeconds % 1) * 1000);

        valueInTimeFormat = new Date(0, 0, days, hours, minutes, seconds, milliseconds);
    }

    return valueInTimeFormat;
};

Helpers.Date.TimeToTotalSeconds = function (time) {
    if (!time) {
        return 0;
    }

    if (time instanceof Date) {
        var dateParts = Helpers.Date.GetDatePartsByDate(time);

        time = `${dateParts.hour}:${dateParts.minutes}:${dateParts.seconds}`;
    }

    let dateToGetTime = new Date('1970-01-01T00:00:00Z');

    if (time.includes(".")) {
        let [daysPart, timePart] = time.split(".");

        time = timePart;

        dateToGetTime.setDate(Number(daysPart) + 1);
    }

    let [hoursPart, minutesPart, secondsPart] = time.split(":");

    let hoursToAdjust = dateToGetTime.getHours();

    dateToGetTime = new Date(dateToGetTime.setHours(Number(hoursPart || "0") + hoursToAdjust, Number(minutesPart || "0"), Number(secondsPart || "0")));

    let seconds = dateToGetTime.getTime() / 1000;

    return seconds;
};

Helpers.Date.TimeToTotalMinutes = function (time) {
    let totalSeconds = Helpers.Date.TimeToTotalSeconds(time);

    let totalMinutes = (totalSeconds / 60);

    return totalMinutes;
}

Helpers.Date.TicksToDate = function (ticks) {
    const ticksAtEpoch = 621355968000000000;
    const ticksPerMillisecond = 10000;
    const milliseconds = (ticks - ticksAtEpoch) / ticksPerMillisecond;

    return new Date(milliseconds);
};

Helpers.Date.DateToSeconds = function (date) {
    if (!date) {
        return 0;
    }

    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (date instanceof Date) {
        days = date.getDay();
        hours = date.getHours();
        minutes = date.getMinutes();
        seconds = date.getSeconds();

        let totalSeconds = (days * 86400) + (hours * 3600) + (minutes * 60) + seconds;

        return totalSeconds;
    }

    let parts = date.split('.');
    let timeParts;

    if (parts.length === 1) {
        timeParts = parts[0].split(':');
    }
    else if (parts.length === 2) {
        let isDays = (parts[1].split(':').length > 1);

        if (isDays) {
            days = parseInt(parts[0]);
            timeParts = parts[1].split(':');
        }
        else {
            timeParts = parts[0].split(':');
        }
    }
    else if (parts.length === 3) {
        days = parseInt(parts[0]);
        timeParts = parts[1].split(':');
    }

    if (timeParts.length >= 3) {
        hours = parseInt(timeParts[0]);
        minutes = parseInt(timeParts[1]);
        seconds = parseInt(timeParts[2]);
    } else if (timeParts.length == 2) {
        hours = parseInt(timeParts[0]);
        minutes = parseInt(timeParts[1]);
    }

    let totalSeconds = (days * 86400) + (hours * 3600) + (minutes * 60) + seconds;

    return totalSeconds;
};

Helpers.Date.ConvertToString = function (date, format) {
    const newDate = new Date(date);

    format = format || 'yyyy-MM-dd HH:mm:ss';

    const replacements = {
        'yyyy': newDate.getFullYear(),
        'MM': String(newDate.getMonth() + 1).padStart(2, '0'),
        'dd': String(newDate.getDate()).padStart(2, '0'),
        'HH': String(newDate.getHours()).padStart(2, '0'),
        'mm': String(newDate.getMinutes()).padStart(2, '0'),
        'ss': String(newDate.getSeconds()).padStart(2, '0')
    };

    const dateInString = format.replace(/yyyy|MM|dd|HH|mm|ss/g, match => replacements[match]);

    return dateInString;
};

Helpers.Date.AddMinutes = function (date, minutesToAdd) {
    let isDate = (date instanceof Date);

    if (!isDate) {
        date = new Date(date);
    }

    let timeToAdd = (minutesToAdd * 60000);

    let newDate = new Date(date.getTime() + timeToAdd);

    return newDate;
}

Helpers.Date.GetDateWithoutTime = function (date) {
    let dateWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    return dateWithoutTime;
}
"use strict";

var Helpers = Helpers || {};

Helpers.DevExtreme = Helpers.DevExtreme || {};

Helpers.DevExtreme.Codes = {
    totalFooter: 'totalFooter'
};

//#region Select Box
Helpers.DevExtreme.SelectBox = {};

Helpers.DevExtreme.SelectBox.GetInstance = function (selectBoxName) {
    try {
        var selectBoxInstance = angular.element("#" + selectBoxName).dxSelectBox("instance");

        return selectBoxInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.SelectBox.ReloadDataSource = function (selectBoxInstance, selectBoxName, selectBoxNewValue) {
    if (!selectBoxInstance) {
        return;
    }

    selectBoxInstance.option("value", null);

    angular.element("#" + selectBoxName).dxSelectBox("getDataSource").reload();

    if (selectBoxNewValue) {
        selectBoxInstance.option("value", selectBoxNewValue);
    }
};
//#endregion

//#region Pivot Grid
Helpers.DevExtreme.GetPivotGridInstance = function (pivotGridName) {
    try {
        var pivotGridInstance = angular.element("#" + pivotGridName).dxPivotGrid("instance");

        return pivotGridInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.GetPivotGridState = function (pivotGridName) {
    try {
        var pivotGridInstance = Helpers.DevExtreme.GetPivotGridInstance(pivotGridName);
        var pivotGridState = pivotGridInstance.getDataSource().state();

        return pivotGridState;
    } catch (_exception) { }
};

Helpers.DevExtreme.SetPivotGridState = function (pivotGridName, pivotGridState) {
    var pivotGridInstance = Helpers.DevExtreme.GetPivotGridInstance(pivotGridName);

    if (pivotGridInstance) {
        pivotGridInstance.getDataSource().state(pivotGridState);
    }
};

Helpers.DevExtreme.ResetPivotGrid = function (pivotGridName, state) {
    if (!state) {
        state = {};
    }

    Helpers.DevExtreme.SetPivotGridState(pivotGridName, state);
};

Helpers.DevExtreme.GetSchedulerInstance = function (chartName) {
    try {
        var schedulerInstance = angular.element("#" + chartName).dxScheduler("instance");

        return schedulerInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.GetSelectBoxInstance = function (selectBoxName) {
    try {
        var selectBoxInstance = angular.element("#" + selectBoxName).dxSelectBox("instance");

        return selectBoxInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.PivotGridSetIsMeasureFalseWhenUndefined = function (fields) {
    for (var i = 0; i < fields.length; i++) {
        var field = fields[i];

        if (!field.isMeasure) {
            field.isMeasure = false;
        }
    }
};

Helpers.DevExtreme.CreateDatePartsColumnPivotGrid = function (dataFieldName, dataFieldWeekName, displayFolderName, caption, dateFormat) {
    var captionToConsider = displayFolderName;
    var yearTranslation = Helpers.Translations.Year || "Year";
    var quarterTranslation = Helpers.Translations.Quarter || "Quarter";
    var monthTranslation = Helpers.Translations.Month || "Month";
    var dayTranslation = Helpers.Translations.Day || "Day";
    var weekTranslation = Helpers.Translations.Week || "Week";

    if (caption) {
        captionToConsider = caption;
    }

    var gridTimeColumns = [{
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "date",
        groupInterval: "year",
        caption: yearTranslation + " (" + captionToConsider + ")"
    }, {
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "date",
        groupInterval: "quarter",
        caption: quarterTranslation + " (" + captionToConsider + ")"
    }, {
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "date",
        groupInterval: "month",
        caption: monthTranslation + " (" + captionToConsider + ")"
    }, {
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "date",
        selector: function (rowData) {
            var date = new Date(rowData[dataFieldName]);
            let dayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

            return dayDate;
        },
        format: "dd",
        groupInterval: "day",
        caption: dayTranslation + " (" + captionToConsider + ")"
    }, {
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "date",
        format: dateFormat || myApplication.dateFormatToDisplay,
        caption: captionToConsider
    }];

    if (dataFieldWeekName) {
        var weekColumn = {
            dataField: dataFieldWeekName,
            displayFolder: displayFolderName,
            dataType: "number",
            caption: weekTranslation + " (" + captionToConsider + ")"
        }

        gridTimeColumns.splice(3, 0, weekColumn);
    }

    return gridTimeColumns;
};

Helpers.DevExtreme.CreateTimePartsColumnPivotGrid = function (dataFieldName, displayFolderName, caption) {
    var captionToConsider = displayFolderName;
    var secondsTranslation = Helpers.Translations.Seconds || "Seconds";
    var minutesTranslation = Helpers.Translations.Minutes || "Minutes";
    var hoursTranslation = Helpers.Translations.Hours || "Hours";

    if (caption) {
        captionToConsider = caption;
    }

    var gridTimeColumns = [{
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "number",
        caption: captionToConsider + " (" + secondsTranslation + ")",
        format: Helpers.DevExtreme.FormatDecimal(3),
        summaryType: "sum",
        isMeasure: true
    }, {
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "number",
        caption: captionToConsider + " (" + minutesTranslation + ")",
        summaryType: "sum",
        customizeText: function (e) {
            if (!e.value) {
                return;
            }

            if (isNaN(e.value)) {
                return "";
            }

            var timeInMinutes = e.value / 60;
            var formattedTime = timeInMinutes.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, " ");

            return formattedTime;
        },
        isMeasure: true
    }, {
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "number",
        caption: captionToConsider + " (" + hoursTranslation + ")",
        summaryType: "sum",
        customizeText: function (e) {
            if (!e.value) {
                return;
            }

            if (isNaN(e.value)) {
                return;
            }

            var timeInHours = e.value / 60 / 60;
            var formattedTime = timeInHours.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, " ");

            return formattedTime;
        },
        isMeasure: true
    }, {
        dataField: dataFieldName,
        displayFolder: displayFolderName,
        dataType: "number",
        caption: captionToConsider,
        summaryType: "sum",
        isMeasure: true,
        customizeText: function (e) {
            if (!e.value) {
                return;
            }

            var textData = Helpers.Date.FormatSecondsToTimeSpanString(Number(e.value));

            return textData;
        },
        area: "data"
    }];

    return gridTimeColumns;
};

Helpers.DevExtreme.CreateTextColumnPivotGrid = function (dataFieldName, caption, displayFolderName, columnPropertiesToAdd) {
    displayFolderName = displayFolderName || undefined;

    let columnForTextField = {
        caption: caption,
        dataField: dataFieldName,
        dataType: 'string',
        displayFolder: displayFolderName
    };

    Helpers.Object.SetObjectProperties(columnForTextField, columnPropertiesToAdd);

    return columnForTextField;
};

Helpers.DevExtreme.CreateDateColumnPivotGrid = function (dataFieldName, caption, displayFolderName, format, columnPropertiesToAdd) {
    displayFolderName = displayFolderName || undefined;
    format = format || myApplication.dateFormatToDisplay;

    let columnnForDateField = {
        caption: caption,
        dataField: dataFieldName,
        dataType: 'date',
        displayFolder: displayFolderName,
        format: format
    };

    Helpers.Object.SetObjectProperties(columnnForDateField, columnPropertiesToAdd);

    return columnnForDateField;
};

Helpers.DevExtreme.CreateNumberColumnPivotGrid = function (dataFieldName, caption, displayFolderName, isMeasure, columnPropertiesToAdd) {
    displayFolderName = displayFolderName || undefined;

    let columnForNumberField = {
        caption: caption,
        dataField: dataFieldName,
        dataType: 'number',
        displayFolder: displayFolderName,
        isMeasure: isMeasure
    };

    if (isMeasure) {
        columnForNumberField.summaryType = 'sum';
    }

    Helpers.Object.SetObjectProperties(columnForNumberField, columnPropertiesToAdd);

    return columnForNumberField;
};

Helpers.DevExtreme.CreatePercentColumnPivotGrid = function (dataFieldName, caption, displayFolderName, isMeasure, columnPropertiesToAdd) {
    displayFolderName = displayFolderName || undefined;

    let columnForNumberField = {
        caption: caption,
        dataField: dataFieldName,
        format: Helpers.DevExtreme.FormatPercent(2),
        dataType: 'number',
        displayFolder: displayFolderName,
        isMeasure: isMeasure
    };

    if (isMeasure) {
        columnForNumberField.summaryType = 'sum';
    }

    Helpers.Object.SetObjectProperties(columnForNumberField, columnPropertiesToAdd);

    return columnForNumberField;
};

Helpers.DevExtreme.CreateBooleanColumnPivotGrid = function (dataFieldName, caption, displayFolderName, columnPropertiesToAdd) {
    var columnForBoolean = {
        caption: caption,
        dataField: dataFieldName,
        dataType: 'boolean',
        displayFolder: displayFolderName,
        customizeText: function (cellInfo) {
            return cellInfo.value ? Helpers.Translations.Yes : Helpers.Translations.No;
        }
    };

    Helpers.Object.SetObjectProperties(columnForBoolean, columnPropertiesToAdd);

    return columnForBoolean;
};

Helpers.DevExtreme.GetPivotGridSummaryDisplayModes = function () {
    var summaryDisplayModes = [
        { text: Helpers.Translations.SummaryModeAbsoluteVariation, value: 'absoluteVariation' },
        { text: Helpers.Translations.SummaryModePercentVariation, value: 'percentVariation' },
        { text: Helpers.Translations.SummaryModePercentOfColumnTotal, value: 'percentOfColumnTotal' },
        { text: Helpers.Translations.SummaryModePercentOfRowTotal, value: 'percentOfRowTotal' },
        { text: Helpers.Translations.SummaryModePercentOfColumnGrandTotal, value: 'percentOfColumnGrandTotal' },
        { text: Helpers.Translations.SummaryModePercentOfRowGrandTotal, value: 'percentOfRowGrandTotal' },
        { text: Helpers.Translations.SummaryModePercentOfGrandTotal, value: 'percentOfGrandTotal' },
    ];

    return summaryDisplayModes;
};

Helpers.DevExtreme.SetPivotGridColumnSummaryDisplayModes = function (columns, datafield, caption) {
    var format;
    var summaryType;
    var columnCaption;
    var summaryDisplayMode;
    var displayFolder = caption + '(' + (Helpers.Translations.Summary || 'Análise') + ')';

    for (var i = 0; i < 7; i++) {
        switch (i) {
            case 0:
                columnCaption = caption + ' (' + (Helpers.Translations.SummaryModeAbsoluteVariation || 'Desvio') + ')';
                summaryDisplayMode = 'absoluteVariation';

                var originalColumn = columns.find(find => (find.dataField === datafield));

                if (originalColumn) {
                    format = originalColumn.format;
                    summaryType = originalColumn.summaryType;
                } else {
                    format = Helpers.DevExtreme.FormatDecimal(5);
                    summaryType = "sum";
                }

                break;

            case 1:
                columnCaption = caption + ' (' + (Helpers.Translations.SummaryModePercentVariation || '% Desvio') + ')';
                summaryDisplayMode = 'percentVariation';
                format = Helpers.DevExtreme.FormatPercent(2);

                break;

            case 2:
                columnCaption = caption + ' (' + (Helpers.Translations.SummaryModePercentOfColumnTotal || '% Total Coluna') + ')';
                summaryDisplayMode = 'percentOfColumnTotal';
                format = Helpers.DevExtreme.FormatPercent(2);

                break;

            case 3:
                columnCaption = caption + ' (' + (Helpers.Translations.SummaryModePercentOfRowTotal || '% Total Linha') + ')';
                summaryDisplayMode = 'percentOfRowTotal';
                format = Helpers.DevExtreme.FormatPercent(2);

                break;

            case 4:
                columnCaption = caption + ' (' + (Helpers.Translations.SummaryModePercentOfColumnGrandTotal || '% Total Geral Colunas') + ')';
                summaryDisplayMode = 'percentOfColumnGrandTotal';
                format = Helpers.DevExtreme.FormatPercent(2);

                break;

            case 5:
                columnCaption = caption + ' (' + (Helpers.Translations.SummaryModePercentOfRowGrandTotal || '% Total Geral Linhas') + ')';
                summaryDisplayMode = 'percentOfRowGrandTotal';
                format = Helpers.DevExtreme.FormatPercent(2);

                break;

            default:
                columnCaption = caption + ' (' + (Helpers.Translations.SummaryModePercentOfGrandTotal || '% Total Geral') + ')';
                summaryDisplayMode = 'percentOfGrandTotal';
                format = Helpers.DevExtreme.FormatPercent(2);

                break;
        }

        var newColumn = {
            dataField: datafield,
            caption: columnCaption,
            displayFolder: displayFolder,
            format: format,
            summaryType: summaryType,
            isMeasure: true,
            summaryDisplayMode: summaryDisplayMode
        };

        columns.push(newColumn);
    }
};

Helpers.DevExtreme.SetDefaultConfigurationsPivotGrid = function (grid, fileName, storageKey) {
    if (!grid.height) {
        var gridHeight = Helpers.DevExtreme.GetObjectHeight(-50, null, null);

        grid.height = gridHeight;
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "allowSorting", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "allowSortingBySummary", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "allowFiltering", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "allowExpandAll", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "showBorders", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "showRowTotals", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "showRowGrandTotals", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "showColumnTotals", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "showColumnGrandTotals", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "rowHeaderLayout", "standard");
    Helpers.Object.SetPropertyValueIfUndefined(grid, "fieldChooser", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.fieldChooser, "applyChangesMode", "onDemand");
    Helpers.Object.SetPropertyValueIfUndefined(grid.fieldChooser, "title", Helpers.Translations.TableOptions);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "onCellPrepared", function (e) {
        Helpers.DevExtreme.PivotGrid.FormatWeekendAndZeroTimeCells(e);
    });

    if (grid.dataSource) {
        Helpers.Object.SetPropertyValueIfUndefined(grid.dataSource, "retrieveFields", false);
    }

    if (fileName) {
        Helpers.Object.SetPropertyValueIfUndefined(grid, "export", {});
        Helpers.Object.SetPropertyValueIfUndefined(grid.export, "enabled", true);
        Helpers.Object.SetPropertyValueIfUndefined(grid,
            "onExporting",
            Helpers.DevExtreme.PivotGrid.OnExporting(fileName));
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "headerFilter", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.headerFilter, "allowSearch", true);

    if (storageKey) {
        Helpers.Object.SetPropertyValueIfUndefined(grid, "stateStoring", {});
        Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "enabled", true);
        Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "storageKey", storageKey);
    }

    if (!grid.fieldPanel) {
        Helpers.Object.SetPropertyValueIfUndefined(grid, "fieldPanel", {});
        Helpers.Object.SetPropertyValueIfUndefined(grid.fieldPanel, "visible", true);
        Helpers.Object.SetPropertyValueIfUndefined(grid.fieldPanel, "showRowFields", false);
        Helpers.Object.SetPropertyValueIfUndefined(grid.fieldPanel, "showColumnFields", false);
        Helpers.Object.SetPropertyValueIfUndefined(grid.fieldPanel, "showDataFields", false);
    }

    grid.onContextMenuPreparing = function (e) {
        e.items = e.items || [];

        for (let i = 0; i < e.items.length; i++) {
            let item = e.items[i];
            if (item && item.text && (typeof item.text === 'string')) {
                var match = item.text.match(/^Sort (.+) by this (column|row)$/i);

                if (match) {
                    var fieldName = match[1];
                    var areaName = match[2];
                    var template = Helpers.Translations.SortFieldByThis;
                    let areaNameTranslation = Helpers.Translations[areaName];

                    item.text = template.replace("{0}", fieldName).replace("{1}", areaNameTranslation);
                }
            }
        }

        let showRowTotals = e.component.option('showRowTotals');
        let showColumnTotals = e.component.option('showColumnTotals');

        e.items.push({
            text: showRowTotals ? Helpers.Translations.HideRowTotals : Helpers.Translations.ShowRowTotals,
            beginGroup: true,
            onItemClick: function () {
                var newState = !showRowTotals;

                e.component.beginUpdate();
                e.component.option({
                    showRowTotals: newState,
                    showRowGrandTotals: newState
                });

                e.component.endUpdate();
            }
        });

        e.items.push({
            text: showColumnTotals ? Helpers.Translations.HideColumnTotals : Helpers.Translations.ShowColumnTotals,
            onItemClick: function () {
                var newState = !showColumnTotals;

                e.component.beginUpdate();
                e.component.option({
                    showColumnTotals: newState,
                    showColumnGrandTotals: newState
                });

                e.component.endUpdate();
            }
        });
    };

    var fields = grid.dataSource.fields;
    Helpers.DevExtreme.PivotGridSetIsMeasureFalseWhenUndefined(fields);

    Helpers.DevExtreme.SetDefaultTextsPivotGrid(grid);
};

Helpers.DevExtreme.SetDefaultTextsPivotGrid = function (grid) {
    if (!Helpers.Translations.NoDataFound) {
        return;
    }

    if (grid.fieldChooser) {
        Helpers.Object.SetPropertyValueIfUndefined(grid.fieldChooser, "texts", {});
        grid.fieldChooser.texts.allFields = Helpers.Translations.AllFields;
        grid.fieldChooser.texts.columnFields = Helpers.Translations.ColumnFields;
        grid.fieldChooser.texts.dataFields = Helpers.Translations.DataFields;
        grid.fieldChooser.texts.filterFields = Helpers.Translations.FilterFields;
        grid.fieldChooser.texts.rowFields = Helpers.Translations.RowFields;
        grid.fieldChooser.texts.fromFilter = Helpers.Translations.FromFilter;
        grid.fieldChooser.texts.toFilter = Helpers.Translations.ToFilter;
        grid.fieldChooser.texts.applyFilter = Helpers.Translations.ApplyFilter;
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "texts", {});

    grid.texts.noData = Helpers.Translations.NoDataFound;
    grid.texts.grandTotal = Helpers.Translations.GrandTotal;
    grid.texts.exportToExcel = Helpers.Translations.ExportExcel;
    grid.texts.dataNotAvailable = Helpers.Translations.DataNotAvailable;
    grid.texts.showFieldChooser = Helpers.Translations.ShowFieldChooser;
    grid.texts.collapseAll = Helpers.Translations.CollapseAll;
    grid.texts.expandAll = Helpers.Translations.ExpandAll;

    if (grid.fieldPanel.visible) {
        Helpers.Object.SetPropertyValueIfUndefined(grid.fieldPanel, "texts", {});
        grid.fieldPanel.texts.columnFieldArea = Helpers.Translations.DropColumnFields;
        grid.fieldPanel.texts.dataFieldArea = Helpers.Translations.DropDataFields;
        grid.fieldPanel.texts.filterFieldArea = Helpers.Translations.DropFilterFields;
        grid.fieldPanel.texts.rowFieldArea = Helpers.Translations.DropRowFields;
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "font", myApplication.gridFont);
};

Helpers.DevExtreme.PivotGrid = {
    OnExporting: function (fileName) {
        if (!DevExpress.excelExporter.exportPivotGrid) {
            return;
        }

        var onExporting = function (e) {
            if (!fileName) {
                fileName = "Data";
            }

            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet(fileName);

            DevExpress.excelExporter.exportPivotGrid({
                worksheet: worksheet,
                component: e.component,
                mergeColumnFieldValues: false,
                mergeRowFieldValues: false
            }).then(function () {
                workbook.xlsx.writeBuffer().then(function (buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');
                });
            });

            e.cancel = true;
        };

        return onExporting;
    },
    GetPivotGridDrillDownColumns: function (grid) {
        if (!grid.dataSource) {
            return;
        }

        var fieldsToDrillDown = grid.dataSource.fields.filter(filter => filter.isDrillDown);

        if (!fieldsToDrillDown || !fieldsToDrillDown.length) {
            return;
        }

        fieldsToDrillDown = angular.copy(fieldsToDrillDown);

        fieldsToDrillDown.forEach(function (field) {
            delete field.isMeasure;
            delete field.area;
            delete field.summaryType;
            delete field.displayFolder;
        });

        return fieldsToDrillDown;
    },
    SetDrillDown: function ($scope, grid) {
        var fieldsToDrillDown = grid.dataSource.fields.filter(filter => !filter.isMeasure && !filter.groupInterval);

        fieldsToDrillDown.pushRange(Helpers.DevExtreme.PivotGrid.GetPivotGridDrillDownColumns(grid));

        if (fieldsToDrillDown && fieldsToDrillDown.length) {
            var height = grid.height * 0.8;

            $scope.DataGridOptions = {
                bindingOptions: {
                    dataSource: {
                        dataPath: 'drillDownDataSource',
                        deep: false,
                    },
                },
                onInitialized: function (e) {
                    $scope.drillDownDataGrid = e.component;
                },
                width: '100%',
                height: height - 80,
                columns: fieldsToDrillDown,
            };

            $scope.PopupOptions = {
                width: '90%',
                height: height,
                onShown: function () {
                    $scope.drillDownDataGrid.updateDimensions();
                    $scope.drillDownDataGrid.clearFilter();
                },
                bindingOptions: {
                    title: 'popupTitle',
                    visible: 'popupVisible',
                },
            };

            Helpers.DevExtreme.SetDefaultConfigurationsDashboardGrid($scope.DataGridOptions);
        }

        grid.onCellClick = function (e) {
            if (e.area === 'data') {
                const pivotGridDataSource = e.component.getDataSource();
                const rowPathLength = e.cell.rowPath.length;
                const rowPathName = e.cell.rowPath[rowPathLength - 1];
                const popupTitle = `${rowPathName || 'Total'} ` + Helpers.Translations.DrillDownData;

                $scope.drillDownDataSource = pivotGridDataSource.createDrillDownDataSource(e.cell);
                $scope.popupTitle = popupTitle;
                $scope.popupVisible = true;
            }
        }
    },
    SetFieldArea: function (fields, dataField, groupInterval, area) {
        let field = fields.find(find => (find.dataField === dataField) && (!groupInterval || (find.groupInterval === groupInterval)));

        field.area = area;
    },
    CalculateCustomSummaryForCountDistinct: function (options) {
        if (options.summaryProcess == 'start') {
            options.totalValue = 0;
            options.distinctValues = [];
        }
        else if (options.summaryProcess == 'calculate') {
            if ($.inArray(options.value, options.distinctValues) == -1) {
                options.distinctValues.push(options.value);
                options.totalValue += 1;
            }
        }
        else if (options.summaryProcess == 'finalize') {
            options.distinctValues = [];
        }
    },
    FormatWeekendAndZeroTimeCells: function (e) {
        var isWeekend = false;

        if ((e.area === "row") || (e.area === "column")) {
            if (e.cell && e.cell.value instanceof Date) {
                var dayOfWeek = e.cell.value.getDay();

                if (dayOfWeek === 0 || dayOfWeek === 6) {
                    isWeekend = true;
                }
            }
        } else if (e.area === "data") {
            if (e.cell && e.cell.rowPath) {
                for (var i = 0; i < e.cell.rowPath.length; i++) {
                    if (e.cell.rowPath[i] instanceof Date) {
                        var dayOfWeekRow = e.cell.rowPath[i].getDay();

                        if (dayOfWeekRow === 0 || dayOfWeekRow === 6) {
                            isWeekend = true;
                            break;
                        }
                    }
                }
            }

            if (!isWeekend && e.cell && e.cell.columnPath) {
                for (var j = 0; j < e.cell.columnPath.length; j++) {
                    if (e.cell.columnPath[j] instanceof Date) {
                        var dayOfWeekCol = e.cell.columnPath[j].getDay();

                        if ((dayOfWeekCol === 0) || (dayOfWeekCol === 6)) {
                            isWeekend = true;
                            break;
                        }
                    }
                }
            }
        }

        if (e.cell && !e.cell.value) {
            var cellText = e.cellElement.text().trim();

            if (cellText === '00:00:00' || cellText === '00:00') {
                e.cellElement.css("color", "red");
            }
        }

        if (isWeekend) {
            e.cellElement.css("background-color", "#e0e0e0");
        }
    }
};
//#endregion

//#region Grid
Helpers.DevExtreme.DataGrid = {
    SetCustomDataSource: function (gridName, primaryKey, data) {
        data = data || [];

        let gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);

        if (data.length) {
            let possibleKeys = [primaryKey];
            let key = possibleKeys.find(find => data[0].hasOwnProperty(find));

            if (!key) {
                key = '__tempKey';
                data = data.map(map => {
                    let currentItem = {
                        __tempKey: Helpers.Guid.GenerateRandom(),
                        ...map
                    }

                    return currentItem;
                });
            }

            let store = new DevExpress.data.ArrayStore({
                key: key,
                data: data
            });

            gridInstance.option({ dataSource: { store: store }, keyExpr: key });
        }
        else {
            gridInstance.option('dataSource', []);
        }
    },
    FocusFilterCell: function (grid, columnName, columnIndex) {
        if (!grid) {
            return;
        }

        var filterInputs = grid.element().find('.dx-datagrid-filter-row .dx-texteditor-input');
        var targetInput = null;

        if (columnName) {
            columnIndex = grid.columnOption(columnName, "index");

            targetInput = filterInputs.eq(columnIndex);
        } else if (filterInputs.length > columnIndex) {
            targetInput = filterInputs.eq(1);
        } else if (filterInputs.length === 1) {
            targetInput = filterInputs.eq(0);
        }

        if (targetInput && targetInput.length) {
            targetInput.focus();
        }
    }
}

Helpers.DevExtreme.GetGridInstance = function (gridName) {
    try {
        var gridInstance = angular.element("#" + gridName).dxDataGrid("instance");

        return gridInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.GetGridState = function (gridName) {
    try {
        var gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);
        var gridState = gridInstance.state();

        return gridState;
    } catch (_exception) { }
};

Helpers.DevExtreme.SetGrid = function (elementId, grid) {
    $("#" + elementId).dxDataGrid(grid);
};

Helpers.DevExtreme.SetGridState = function (gridName, gridState) {
    var gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);

    if (gridInstance) {
        gridInstance.state(gridState);
    }
};

Helpers.DevExtreme.SetDataGridPageSize = function (gridInstance, gridHeight, minimumAmountOfRows, withSummary) {
    if (!gridInstance) {
        return;
    }

    var amountOfRows = 0;
    var rowHeight = 38;
    var pageSizes = [];
    var amountOfRowsToSet;

    if (!gridHeight) {
        amountOfRows = 12;
    } else {
        amountOfRows = Math.floor(gridHeight / rowHeight);
    }

    if (amountOfRows > 2) {
        amountOfRows -= 2;
    }

    if (withSummary && (amountOfRows > 2)) {
        amountOfRows -= 2;
    }

    if (minimumAmountOfRows && (minimumAmountOfRows > amountOfRows)) {
        amountOfRows = minimumAmountOfRows;
    }

    Helpers.Object.SetPropertyValueIfUndefined(gridInstance, "paging", {});
    Helpers.Object.SetPropertyValueIfUndefined(gridInstance.paging, "pageSize", amountOfRows);
    Helpers.Object.SetPropertyValueIfUndefined(gridInstance.paging, "enabled", true);

    Helpers.Object.SetPropertyValueIfUndefined(gridInstance, "pager", {});
    Helpers.Object.SetPropertyValueIfUndefined(gridInstance.pager, "showInfo", true);
    Helpers.Object.SetPropertyValueIfUndefined(gridInstance.pager, "visible", true);

    pageSizes.push(amountOfRows)
    amountOfRowsToSet = amountOfRows + Math.floor(amountOfRows / 2);
    pageSizes.push(amountOfRowsToSet);
    amountOfRowsToSet = amountOfRows * 2;
    pageSizes.push(amountOfRowsToSet);

    if (gridInstance.paging.enabled) {
        Helpers.Object.SetPropertyValueIfUndefined(gridInstance.pager, "showPageSizeSelector", true);
        Helpers.Object.SetPropertyValueIfUndefined(gridInstance.pager, "allowedPageSizes", pageSizes);
        Helpers.Object.SetPropertyValueIfUndefined(gridInstance.pager, "showNavigationButtons", true);
    }
};

Helpers.DevExtreme.SetDefaultConfigurationsDashboardGrid = function (grid, storageKey) {
    Helpers.DevExtreme.SetDefaultConfigurationsGrid(grid, true, null, null, null, true);

    Helpers.Object.SetPropertyValueIfUndefined(grid, "pager", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.pager, "showInfo", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid.pager, "visible", true);

    Helpers.DevExtreme.SetStateStoring(grid, storageKey, false);
};

Helpers.DevExtreme.SetDefaultConfigurationsGrid = function (grid, ignoreSetHeight, storageKey, minimumAmountOfRowsToPageSize, includeFiltersInStorageKey, isBasicGrid) {
    if (!grid.height && !ignoreSetHeight) {
        var gridHeight = Helpers.DevExtreme.GetObjectHeight(40, null, null);

        grid.height = gridHeight;
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "editing", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.editing, "mode", "batch");
    Helpers.Object.SetPropertyValueIfUndefined(grid.editing, "allowAdding", false);
    Helpers.Object.SetPropertyValueIfUndefined(grid.editing, "allowUpdating", false);
    Helpers.Object.SetPropertyValueIfUndefined(grid.editing, "allowDeleting", false);

    Helpers.Object.SetPropertyValueIfUndefined(grid, "showBorders", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "rowAlternationEnabled", true);

    Helpers.Object.SetPropertyValueIfUndefined(grid, "sorting", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.sorting, "mode", "multiple");

    Helpers.Object.SetPropertyValueIfUndefined(grid, "searchPanel", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.searchPanel, "visible", false);

    Helpers.Object.SetPropertyValueIfUndefined(grid, "filterRow", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.filterRow, "visible", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid.filterRow, "applyFilter", "auto");

    if (grid.filterRow.visible && !isBasicGrid) {
        Helpers.Object.SetPropertyValueIfUndefined(grid, "filterPanel", {});
        Helpers.Object.SetPropertyValueIfUndefined(grid.filterPanel, "visible", true);
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "loadPanel", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.loadPanel, "enabled", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid.loadPanel, "text", Helpers.Translations.Loading);

    //Helpers.Object.SetPropertyValueIfUndefined(grid, "columnFixing", {});
    //Helpers.Object.SetPropertyValueIfUndefined(grid.columnFixing, "enabled", true);

    Helpers.Object.SetPropertyValueIfUndefined(grid, "export", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid, "headerFilter", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.headerFilter, "visible", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid.headerFilter, "search", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.headerFilter.search, "enabled", true);

    Helpers.Object.SetPropertyValueIfUndefined(grid, "allowColumnResizing", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "allowColumnReordering", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "columnAutoWidth", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid, "columnResizingMode", "widget");

    if (!isBasicGrid) {
        Helpers.DevExtreme.SetDataGridPageSize(grid, grid.height, minimumAmountOfRowsToPageSize);
    }

    if (grid.columns.length > 15) {
        Helpers.Object.SetPropertyValueIfUndefined(grid, "rowRenderingMode", "virtual");
        Helpers.Object.SetPropertyValueIfUndefined(grid, "columnRenderingMode", "virtual");
    }

    Helpers.DevExtreme.SetOnOptionChangedForEditingChanges(grid);
    Helpers.DevExtreme.SetStateStoring(grid, storageKey, includeFiltersInStorageKey);

    if (grid.columns && !isBasicGrid) {
        var customizeColumns = Helpers.DevExtreme.CustomizeColumns(grid.columns);

        Helpers.Object.SetPropertyValueIfUndefined(grid.columns, "customizeColumns", customizeColumns);

        var hasAllowHidingColumns = GetHasAllowHidingColumns(grid.columns);

        if (hasAllowHidingColumns) {
            Helpers.Object.SetPropertyValueIfUndefined(grid, "columnChooser", {});
            Helpers.Object.SetPropertyValueIfUndefined(grid.columnChooser, "enabled", true);
            Helpers.Object.SetPropertyValueIfUndefined(grid.columnChooser, "mode", "select");
            Helpers.Object.SetPropertyValueIfUndefined(grid.columnChooser, "sortOrder", "asc");
            Helpers.Object.SetPropertyValueIfUndefined(grid.columnChooser, "width", "350");
            Helpers.Object.SetPropertyValueIfUndefined(grid.columnChooser, "height", "400");

            if (storageKey) {
                Helpers.DevExtreme.SetGridColumnsStateStoring(grid, storageKey);
            }
        }
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "dataSource", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.dataSource, "langParams", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.dataSource.langParams, "collatorOptions", { sensitivity: 'base' });

    Helpers.Object.SetPropertyValueIfUndefined(grid, "summary", {});

    Helpers.DevExtreme.Grid.RemoveUnusedSummaries(grid.summary.totalItems, grid.columns);
    Helpers.DevExtreme.Grid.RemoveUnusedSummaries(grid.summary.groupItems, grid.columns);

    Helpers.DevExtreme.SetDefaultTextsGrid(grid);
};

function GetHasAllowHidingColumns(columns) {
    for (const column of columns) {
        if (column.allowHiding === true) {
            return true;
        }

        if (column.columns) {
            let innerColumnAllowHiding = GetHasAllowHidingColumns(column.columns);

            if (innerColumnAllowHiding) {
                return true;
            }
        }
    }
}

Helpers.DevExtreme.SetStateStoring = function (grid, storageKey, includeFiltersInStorageKey) {
    if (!storageKey) {
        Helpers.Object.SetPropertyValueIfUndefined(grid, "stateStoring", {});
        Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "enabled", false);

        return;
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "stateStoring", {});
    Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "enabled", true);
    Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "type", "custom");
    Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "storageKey", storageKey);

    Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "customLoad", function () {
        var state = JSON.parse(localStorage.getItem(storageKey));

        if (!state || !grid.columns) {
            return state;
        }

        if (state.columns) {
            for (var i = state.columns.length - 1; i >= 0; i--) {
                var stateColumn = state.columns[i];
                var columnExists = grid.columns.find(function (column) {
                    var gridDataField = (typeof column === "string") ? column : column.dataField;
                    var gridName = (typeof column === "string") ? null : column.name;

                    let columnMatch = ((gridDataField && stateColumn.dataField) && (gridDataField === stateColumn.dataField)) || ((gridName && stateColumn.name) && (gridName === stateColumn.name));

                    return columnMatch;
                });

                if (!columnExists) {
                    state.columns.splice(i, 1);
                }
            }
        }

        if (state.filterValue) {
            try {
                if ((typeof DevExpress !== "undefined") && DevExpress.ui && DevExpress.ui.dxFilterBuilder) {
                    var filterBuilderFields = grid.columns.map(function (column) {
                        if (typeof column === "string") {
                            let filterOperation = { dataField: column };

                            return filterOperation;
                        }

                        let filterOperations = {
                            dataField: column.dataField,
                            dataType: column.dataType || "string",
                            caption: column.caption,
                            lookup: column.lookup,
                            filterOperations: column.filterOperations || [
                                "=", "<>", "<", "<=", ">", ">=",
                                "contains", "notcontains", "startswith", "endswith",
                                "anyof", "noneof"
                            ]
                        };

                        return filterOperations;
                    });

                    var filterBuilder = new DevExpress.ui.dxFilterBuilder(document.createElement("div"), {
                        fields: filterBuilderFields,
                        value: state.filterValue
                    });

                    if (filterBuilder && (typeof filterBuilder.dispose === "function")) {
                        filterBuilder.dispose();
                    }
                }
            } catch (e) {
                state.filterValue = null;
            }
        }

        return state;
    });

    Helpers.Object.SetPropertyValueIfUndefined(grid.stateStoring, "customSave", function (state) {
        if (state) {
            state.searchText = null;

            if (!includeFiltersInStorageKey && state.columns) {
                for (let i = 0; i < state.columns.length; i++) {
                    delete state.columns[i].filterValue;
                    delete state.columns[i].searchPanel;
                    delete state.columns[i].filterValues;
                    delete state.columns[i].filterType;
                }
            }
        }

        localStorage.setItem(storageKey, JSON.stringify(state));
    });

};

Helpers.DevExtreme.SetGridColumnsStateStoring = function (grid, storageKey) {
    var state = JSON.parse(localStorage.getItem(storageKey));

    if (!state) {
        return;
    }

    SetGridColumnsStateStoringVisibility(grid.columns, state);
}

function SetGridColumnsStateStoringVisibility(columns, stateStoring) {
    var stateColumns = stateStoring.columns;
    var columnsToCheck = columns.filter(filter => (filter.allowHiding === true));

    columnsToCheck.forEach(function (column) {
        var columnInStateStoring = stateColumns.find(find => (find.dataField && (find.dataField === column.dataField)) || (find.name && (find.name === column.name)));

        if (column.columns) {
            SetGridColumnsStateStoringVisibility(column.columns, stateStoring);
        }

        if (!columnInStateStoring) {
            return;
        }

        column.visible = columnInStateStoring.visible;
    });
}

Helpers.DevExtreme.SetOnOptionChangedForEditingChanges = function (grid) {
    let existingOnOptionChanged = grid.onOptionChanged;

    grid.onOptionChanged = function (e) {
        if (existingOnOptionChanged && typeof (existingOnOptionChanged === 'function')) {
            existingOnOptionChanged(e);
        }

        if ((e.fullName === "editing.changes") && e.value && e.component) {
            let keyExpr = e.component.option('keyExpr');

            if (!keyExpr) {
                let dataSource = e.component.getDataSource();

                if (dataSource) {
                    keyExpr = dataSource.key();
                }
            }

            e.value.forEach(function (change) {
                if (((change.type === 'update') || (change.type === 'remove')) && !change.oldData) {
                    let visibleRows = e.component.getVisibleRows();
                    let foundRow = visibleRows.find(row => (row.key === change.key) && (row.rowType === 'data'));

                    if (foundRow && foundRow.data) {
                        change.oldData = angular.copy(foundRow.data);
                    } else {
                        let dataSource = e.component.getDataSource();

                        if (dataSource) {
                            let items = dataSource.items();
                            let foundItem = items.find(find => (keyExpr && (find[keyExpr] === change.key)));

                            if (foundItem) {
                                change.oldData = angular.copy(foundItem);
                            } else {
                                let store = dataSource.store();

                                if (store && store._array) {
                                    let itemInStore = store._array.find(find => (keyExpr && (find[keyExpr] === change.key)));

                                    if (itemInStore) {
                                        change.oldData = angular.copy(itemInStore);
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }
    };
};

Helpers.DevExtreme.SetDefaultTextsGrid = function (grid) {
    grid.noDataText = Helpers.Translations.NoDataFound;

    let filterOperationsDescriptions = {
        between: Helpers.Translations.Between,
        contains: Helpers.Translations.Contains,
        endsWith: Helpers.Translations.EndsWith,
        equal: Helpers.Translations.Equal,
        greaterThan: Helpers.Translations.GreaterThan,
        greaterThanOrEqual: Helpers.Translations.GreaterThanOrEqual,
        isBlank: Helpers.Translations.IsBlank,
        isNotBlank: Helpers.Translations.IsNotBlank,
        lessThan: Helpers.Translations.LessThan,
        lessThanOrEqual: Helpers.Translations.LessThanOrEqual,
        notContains: Helpers.Translations.NotContains,
        notEqual: Helpers.Translations.NotEqual,
        startsWith: Helpers.Translations.StartsWith
    }

    if (grid.filterRow) {
        grid.filterRow.applyFilterText = Helpers.Translations.ApplyGridFilter;
        grid.filterRow.betweenEndText = Helpers.Translations.BetweenEnd;
        grid.filterRow.betweenStartText = Helpers.Translations.BetweenStart;
        grid.filterRow.resetOperationText = Helpers.Translations.Reset;
        grid.filterRow.showAllText = Helpers.Translations.All;

        Helpers.Object.SetPropertyValueIfUndefined(grid.filterRow, "operationDescriptions", {});

        grid.filterRow.operationDescriptions = filterOperationsDescriptions;

        DevExpress.localization.loadMessages({
            "en": {
                "dxFilterBuilder-addCondition": Helpers.Translations.FilterBuilderAddCondition,
                "dxFilterBuilder-addGroup": Helpers.Translations.FilterBuilderAddGroup,
                "dxFilterBuilder-filterOperationAnyOf": Helpers.Translations.IsAnyOf,
                "dxFilterBuilder-filterOperationNoneOf": Helpers.Translations.IsNoneOf
            }
        });
    }

    if (grid.filterPanel && grid.filterPanel.visible) {
        Helpers.Object.SetPropertyValueIfUndefined(grid.filterPanel, "texts", {});

        grid.filterPanel.texts.clearFilter = Helpers.Translations.ClearFilter;
        grid.filterPanel.texts.createFilter = Helpers.Translations.CreateFilter;
        grid.filterPanel.texts.filterEnabledHint = Helpers.Translations.FilterEnable;
        Helpers.Object.SetPropertyValueIfUndefined(grid, "filterBuilderPopup", {});
        Helpers.Object.SetPropertyValueIfUndefined(grid.filterBuilderPopup, "title", Helpers.Translations.FilterBuilderTitle);
        Helpers.Object.SetPropertyValueIfUndefined(grid, "filterBuilder", {});

        let groupOperationDescriptions = {
            and: Helpers.Translations.And,
            notAnd: Helpers.Translations.NotAnd,
            notOr: Helpers.Translations.NotOr,
            or: Helpers.Translations.Or,
        };

        Helpers.Object.SetPropertyValueIfUndefined(grid.filterBuilder, "groupOperationDescriptions", groupOperationDescriptions);
        Helpers.Object.SetPropertyValueIfUndefined(grid.filterBuilder, "filterOperationDescriptions", filterOperationsDescriptions);
    }

    if (grid.headerFilter) {
        Helpers.Object.SetPropertyValueIfUndefined(grid.headerFilter, "texts", {});

        grid.headerFilter.texts.cancel = Helpers.Translations.Cancel;
        grid.headerFilter.texts.ok = Helpers.Translations.OK;
        grid.headerFilter.texts.emptyValue = Helpers.Translations.EmptyValue;

        DevExpress.localization.loadMessages({
            "en": {
                "Search": Helpers.Translations.Search,
                "dxDataGrid-ariaSelectAll": Helpers.Translations.SelectAll,
                "dxDataGrid-headerFilterEmptyValue": Helpers.Translations.Blanks,
            }
        });
    }

    if (grid.grouping && (typeof grid.grouping === 'object')) {
        Helpers.Object.SetPropertyValueIfUndefined(grid.grouping, "texts", {});

        grid.grouping.texts.groupByThisColumn = Helpers.Translations.GroupByThisColumn;
        grid.grouping.texts.groupContinuesMessage = Helpers.Translations.GroupContinuesMessage;
        grid.grouping.texts.ungroup = Helpers.Translations.Ungroup;
        grid.grouping.texts.ungroupAll = Helpers.Translations.UngroupAll;
    }

    if (grid.columnFixing) {
        Helpers.Object.SetPropertyValueIfUndefined(grid.columnFixing, "texts", {});

        grid.columnFixing.texts.fix = Helpers.Translations.Fix;
        grid.columnFixing.texts.leftPosition = Helpers.Translations.LeftPosition;
        grid.columnFixing.texts.rightPosition = Helpers.Translations.RightPosition;
        grid.columnFixing.texts.unfix = Helpers.Translations.Unfix;
    }

    if (grid.searchPanel) {
        grid.searchPanel.placeholder = Helpers.Translations.Search;
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "sorting", {});

    grid.sorting.ascendingText = Helpers.Translations.Ascending;
    grid.sorting.clearText = Helpers.Translations.ClearSorting;
    grid.sorting.descendingText = Helpers.Translations.Descending;

    if (grid.pager) {
        grid.pager.infoText = Helpers.Translations.PageOfItems;
    }

    if (grid.columnChooser) {
        grid.columnChooser.title = Helpers.Translations.ColumnChooser;
    }

    Helpers.Object.SetPropertyValueIfUndefined(grid, "font", myApplication.gridFont);
};

Helpers.DevExtreme.SetSummaryTexts = function (summary) {
    Helpers.Object.SetPropertyValueIfUndefined(summary, "texts", {});

    summary.texts.avg = Helpers.Translations.GridAverage;
    summary.texts.avgOtherColumn = Helpers.Translations.GridAverageOtherColumn;
    summary.texts.count = Helpers.Translations.GridCounter;
    summary.texts.max = Helpers.Translations.GridMaximum;
    summary.texts.maxOtherColumn = Helpers.Translations.GridMaximumOtherColumn;
    summary.texts.min = Helpers.Translations.GridMinimum;
    summary.texts.minOtherColumn = Helpers.Translations.GridMinimumOtherColumn;
    summary.texts.sum = Helpers.Translations.GridSum;
    summary.texts.sumOtherColumn = Helpers.Translations.GridSumOtherColumn;
}

Helpers.DevExtreme.SetOnContextMenuPreparing = function (e, itemValues) {
    itemValues = itemValues || ['sum', 'avg', 'min', 'max', 'count'];

    if (e.field && (e.field.area === 'data')) {
        var changeSummaryType = function (clickedItem) {
            var dataSource = e.component.getDataSource();

            dataSource.field(e.field.index, {
                summaryType: clickedItem.itemData.value,
                caption: captionOperation(e.field.caption, clickedItem.itemData.text)
            });

            e.component._options.texts.grandTotal = clickedItem.itemData.text;

            dataSource.load();
        };

        var captionOperation = function (caption, newOperation) {
            var captionLastWord = caption.split(" ").pop();
            var oldOperation = items.find(item => ("(" + item.text + ")") === captionLastWord);

            if (oldOperation) {
                caption = caption.replace("(" + oldOperation.text + ")", "(" + newOperation + ")");
            } else {
                caption += " (" + newOperation + ")";
            }

            return caption;
        }

        var items = [];

        if (itemValues.includes('sum')) {
            items.push({ text: Helpers.Translations.Sum, value: 'sum', onItemClick: changeSummaryType });
        }

        if (itemValues.includes('avg')) {
            items.push({ text: Helpers.Translations.Average, value: 'avg', onItemClick: changeSummaryType });
        }

        if (itemValues.includes('min')) {
            items.push({ text: Helpers.Translations.Minimum, value: 'min', onItemClick: changeSummaryType });
        }

        if (itemValues.includes('max')) {
            items.push({ text: Helpers.Translations.Maximum, value: 'max', onItemClick: changeSummaryType });
        }

        if (itemValues.includes('count')) {
            items.push({ text: Helpers.Translations.Counter, value: 'count', onItemClick: changeSummaryType });
        }

        Array.prototype.push.apply(e.items, items)
    }
};

Helpers.DevExtreme.ExportToExcelGrid = function (gridName, saveEditData, company) {
    var gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);

    if (saveEditData && gridInstance.hasEditData()) {
        gridInstance.saveEditData().done(function () {
            gridInstance.exportToExcel();
        })

        return;
    }

    Helpers.DevExtreme.Grid.ExportToExcel(gridName, company);
};

Helpers.DevExtreme.ExportGridToPdf = function (gridName, company, saveEditData) {
    var gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);

    if (saveEditData && gridInstance.hasEditData()) {
        gridInstance.saveEditData().done(function () {
            Helpers.DevExtreme.Grid.ExportToPdf(gridName);
        })

        return;
    }

    Helpers.DevExtreme.Grid.ExportToPdf(gridName, company);
};

Helpers.DevExtreme.OpenColumnChooser = function (gridName) {
    var gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);

    gridInstance.showColumnChooser();
};

Helpers.DevExtreme.OnExporting = function (fontSize, textRotation, autoColumnWidth, numberOfRowsInHeader) {
    var onExporting = function (e) {
        var fileName = e.fileName;
        var workbook = new ExcelJS.Workbook();
        var worksheet = workbook.addWorksheet(fileName);

        var columnsToHide = e.component.getVisibleColumns();

        if (columnsToHide.length) {
            columnsToHide = columnsToHide.filter(filter => (filter.allowExporting === false));

            if (columnsToHide.length) {
                e.component.beginUpdate();

                columnsToHide.forEach(function (column) {
                    e.component.columnOption(column.dataField, 'visible', false);
                });
            }
        }

        DevExpress.excelExporter.exportDataGrid({
            worksheet: worksheet,
            component: e.component,
            customizeCell: function (options) {
                var gridCell = options.gridCell;
                var excelCell = options.excelCell;

                if (fontSize) {
                    excelCell.style.font = excelCell.style.font || {};
                    excelCell.style.font.size = fontSize;
                }

                if (textRotation && !gridCell.column.hasColumns && (gridCell.rowType === 'header')) {
                    excelCell.style.alignment = { textRotation: textRotation, vertical: 'middle', horizontal: 'center' };
                }

                if (gridCell.column.hiddenInExcell) {
                    excelCell._column.hidden = true;
                }

                if ((gridCell.rowType === 'data') && gridCell.column.isPicture && gridCell.value) {
                    excelCell.value = undefined;

                    const image = workbook.addImage({
                        base64: gridCell.value,
                        extension: 'jpeg'
                    });

                    worksheet.getRow(excelCell.row).height = 90;
                    worksheet.addImage(image, {
                        tl: { col: excelCell.col - 1, row: excelCell.row - 1 },
                        br: { col: excelCell.col, row: excelCell.row },
                    });
                }
            }
        }).then(function () {
            worksheet.columns.forEach(function (column) {
                if (autoColumnWidth !== true) {
                    return;
                }

                var maxLength = 0;
                var minWidth = 5;

                column["eachCell"]({ includeEmpty: true }, function (cell) {
                    if (cell._row._number >= numberOfRowsInHeader) {
                        if (cell.value instanceof Date) {
                            maxLength = 20;
                        }
                        else {
                            var columnLength = cell.value ? cell.value.toString().length : minWidth;

                            if (cell.style.alignment && (cell.style.alignment.textRotation === 90)) {
                                columnLength = minWidth;
                            }
                        }

                        if (columnLength > maxLength) {
                            maxLength = columnLength;
                        }
                    }
                });

                column.width = (maxLength < minWidth) ? minWidth : maxLength;
            });
        }).then(function () {
            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');
            });
        }).then(function () {
            if (columnsToHide.length) {
                columnsToHide.forEach(function (column) {
                    e.component.columnOption(column.dataField, 'visible', true);
                });

                e.component.endUpdate();
            }
        });

        e.cancel = true;
    };

    return onExporting;
};

Helpers.DevExtreme.ChangeColumnOption = function (columns, dataField, option, value) {
    if (!columns) {
        return;
    }

    let findColumn = null;

    columns.find(find => {
        if (find.dataField && (find.dataField === dataField)) {
            findColumn = find;

            return true;
        }

        if (find.columns) {
            findColumn = find.columns.find(secondFind => (secondFind.dataField === dataField));

            if (findColumn) {
                return true;
            }
        }
    });

    if (findColumn) {
        findColumn[option] = value;
    }
};

Helpers.DevExtreme.GetEditData = function (grid, e, typesToFilter) {
    var editData;
    var controller;

    if (grid) {
        controller = grid.getController('editing');
    }
    else {
        if (e.component) {
            controller = e.component.getController('editing');
        } else {
            controller = e.getController('editing');
        }
    }

    if (controller._editData) {
        editData = controller._editData;
    } else {
        if (!grid) {
            controller = e;
        }

        if (controller.component) {
            editData = controller.component.option("editing.changes");
        } else {
            editData = controller.option("editing.changes");
        }
    }

    if (typesToFilter) {
        editData = editData.filter(where => typesToFilter.includes(where.type));
    }

    editData = editData.map(item => {
        if (item.data) {
            for (let key in item.data) {
                if (item.data[key] instanceof Date) {
                    let dateInString = Helpers.Date.ConvertToString(item.data[key]);

                    item.data[key] = dateInString;
                }
            }
        }

        return item;
    });

    return editData;
};

Helpers.DevExtreme.Grid = {
    GetEditData: function (grid, e, typesToFilter) {
        let editData = Helpers.DevExtreme.GetEditData(grid, e, typesToFilter);

        return editData;
    },
    HasChanges: function (gridName) {
        var gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);
        var hasChanges = gridInstance.hasEditData();

        return hasChanges;
    },
    GetOldDataEditedRow: function (editedRow) {
        if ((editedRow.type !== "update") && (editedRow.type !== "remove")) {
            return undefined;
        }

        var oldData = editedRow.oldData;

        if (!oldData) {
            oldData = editedRow.key;
        }

        return oldData;
    },
    GetInsertedRowByKey: function (grid, key) {
        var rowIndex;
        var typesToFilter = ["insert"];
        var gridEditData = this.GetEditData(grid, null, typesToFilter);
        var rowEditData = gridEditData.find(find => find.data && (find.data.__KEY__ === key));

        if (rowEditData) {
            rowIndex = grid.getRowIndexByKey(rowEditData.key);
        }

        return rowIndex;
    },
    RemoveEditData: function (grid, applyCancelEditData, applyRefresh) {
        if (applyCancelEditData === true) {
            grid.cancelEditData();
        }

        var controller = grid.getController('editing');

        if (controller._editData) {
            controller._editData = [];
        } else {
            // TODO :: Falta-me ver como limpo na nova versão as changes?
            //editData = e.component.option("editing.changes");
        }

        if (applyRefresh === true) {
            grid.refresh();
        }
    },
    ValidateData: function (gridName) {
        let gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);

        if (!gridInstance) {
            let promise = Promise.reject();

            return promise;
        }

        let promise = new Promise((resolve) => {
            gridInstance.getController('validating').validate(true).done(function (result) {
                if (result) {
                    resolve();
                }

                reject();
            }).fail(function () {
                reject();
            });
        });

        return promise;
    },
    ExportToExcel: function (gridName, company) {
        let gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);
        let columns = gridInstance.option("columns");
        let exportToExcelOptions = gridInstance.option("exportToExcelOptions") || {};

        var fileName = gridInstance.option("export.fileName") || 'data';
        var workbook = new ExcelJS.Workbook();
        var worksheet = workbook.addWorksheet(fileName);

        let hasColumnsToForceExport = Helpers.DevExtreme.ChangeVisibleIfForceExporting(gridInstance, columns, true);

        var columnsToHide = gridInstance.getVisibleColumns();

        if (columnsToHide.length) {
            columnsToHide = columnsToHide.filter(filter => (filter.allowExporting === false));

            if (columnsToHide.length) {
                gridInstance.beginUpdate();

                columnsToHide.forEach(function (column) {
                    gridInstance.columnOption(column.dataField, 'visible', false);
                });
            }
        }

        let dataStartRow = 1;

        if (company) {
            let date = Helpers.Date.ConvertToString(new Date());

            worksheet.getCell('A1').value = company.Name;
            worksheet.getCell('A1').font = {
                bold: true,
                size: 14
            };
            worksheet.getCell('A1').alignment = {
                vertical: 'middle',
                horizontal: 'left'
            };

            worksheet.getCell('A2').value = `Data de exportação: ${date}`;
            worksheet.getCell('A2').font = {
                italic: true,
                size: 10
            };
            worksheet.getCell('A2').alignment = {
                vertical: 'middle',
                horizontal: 'left'
            };

            dataStartRow = 4;
        }

        DevExpress.excelExporter.exportDataGrid({
            worksheet: worksheet,
            component: gridInstance,
            topLeftCell: {
                row: dataStartRow,
                column: 1
            },
            autoFilterEnabled: true,
            customizeCell: function (options) {
                var gridCell = options.gridCell;
                var excelCell = options.excelCell;

                if (exportToExcelOptions.fontSize) {
                    excelCell.style.font = excelCell.style.font || {};
                    excelCell.style.font.size = exportToExcelOptions.fontSize;
                }

                if (exportToExcelOptions.textRotation && !gridCell.column.hasColumns && (gridCell.rowType === 'header')) {
                    excelCell.style.alignment = {
                        textRotation: exportToExcelOptions.textRotation,
                        vertical: 'middle',
                        horizontal: 'center'
                    };
                }

                if (gridCell.column.hiddenInExcell) {
                    excelCell._column.hidden = true;
                }

                if ((gridCell.rowType === 'data') && gridCell.column.isPicture && gridCell.value) {
                    excelCell.value = undefined;

                    const image = workbook.addImage({
                        base64: gridCell.value,
                        extension: 'jpeg'
                    });

                    worksheet.getRow(excelCell.row).height = 90;
                    worksheet.addImage(image, {
                        tl: { col: excelCell.col - 1, row: excelCell.row - 1 },
                        br: { col: excelCell.col, row: excelCell.row },
                    });
                }
            }
        }).then(function () {
            worksheet.columns.forEach(function (column) {
                if (exportToExcelOptions.autoColumnWidth !== true) {
                    return;
                }

                var maxLength = 0;
                var minWidth = 5;

                column["eachCell"]({ includeEmpty: true }, function (cell) {
                    if (cell._row._number >= exportToExcelOptions.numberOfRowsInHeader) {
                        if (cell.value instanceof Date) {
                            maxLength = 20;
                        }
                        else {
                            var columnLength = cell.value ? cell.value.toString().length : minWidth;

                            if (cell.style.alignment && (cell.style.alignment.textRotation === 90)) {
                                columnLength = minWidth;
                            }
                        }

                        if (columnLength > maxLength) {
                            maxLength = columnLength;
                        }
                    }
                });

                column.width = (maxLength < minWidth) ? minWidth : maxLength;
            });
        }).then(function () {
            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');
            });
        }).then(function () {
            if (columnsToHide.length || hasColumnsToForceExport) {
                columnsToHide.forEach(function (column) {
                    gridInstance.columnOption(column.dataField, 'visible', true);
                });

                gridInstance.endUpdate();

                Helpers.DevExtreme.ChangeVisibleIfForceExporting(gridInstance, columns, false);
            }
        });
    },
    ExportToPdf: function (gridName, company) {
        let gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);
        let columns = gridInstance.option("columns");
        let pdfSize = Math.max(0, 4 - Math.floor(columns.length / 6));
        var fileName = gridInstance.option("export.fileName") || 'data';
        const pdf = new jspdf.jsPDF("l", undefined, "a" + pdfSize);
        let sumText = Helpers.Translations.GridSum || "Sum: ";

        const summaryLabelsToRemove = [
            sumText.replace('{0}', '').trim()
        ];

        DevExpress.pdfExporter.exportDataGrid({
            jsPDFDocument: pdf,
            component: gridInstance,

            onRowExporting: (e) => {
                const hasImage = e.rowCells.some(rowCell => (rowCell.text && rowCell.text.startsWith("data:image")));


                if (hasImage) {
                    e.rowHeight = 20;
                }
            },
            customizeCell: function (e) {
                if (e.gridCell.rowType === Helpers.DevExtreme.Codes.totalFooter) {
                    if (e.pdfCell.text) {
                        summaryLabelsToRemove.forEach(label => {
                            if (e.pdfCell.text.startsWith(label)) {
                                e.pdfCell.text = e.pdfCell.text.replace(label, '').trim();
                            }
                        });
                    }
                }
            },
            customDrawCell: function (e) {
                var gridCell = e.gridCell;

                if ((gridCell.rowType === 'data') && gridCell.column.isPicture && gridCell.value) {
                    var img = new Image();
                    img.src = gridCell.value;

                    pdf.addImage(img, 'JPEG', e.rect.x, e.rect.y, e.rect.w, e.rect.h, undefined, 'FAST')

                    e.cancel = true;
                }
            }
        }).then(function () {
            var totalPages = pdf.internal.getNumberOfPages();
            let companyName = company.Name || company;

            for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
                pdf.setPage(pageNumber);
                pdf.text(fileName, 10, 10);
                pdf.setFontSize(9);
                pdf.text(companyName, 10, pdf.internal.pageSize.getHeight() - 7);
                pdf.text(Helpers.Date.ConvertToString(new Date()), pdf.internal.pageSize.getWidth() - 40, 10);

                let pageOfPage = Helpers.Translations.PageOfPage || 'Página {0} de {1}';
                let pageText = pageOfPage.replace("{0}", pageNumber).replace("{1}", totalPages);

                pdf.text(pageText, pdf.internal.pageSize.getWidth() - 30, pdf.internal.pageSize.getHeight() - 7);
            }

            pdf.save(fileName + '.pdf');
        });
    },
    CellTemplate: {
        CreateProgressBar: function (container, value) {
            if (!value) {
                return;
            }

            var progressBar = $('<div>')
                .addClass('dx-progressbar')
                .dxProgressBar({
                    min: 0,
                    max: 100,
                    value: value,
                    showStatus: false,
                    onContentReady: function (e) {
                        if (value >= 100) {
                            e.element.find('.dx-progressbar-range').addClass('ProgressBarSuccess');
                        }
                    }
                })
                .appendTo(container);

            $('<div>')
                .appendTo(progressBar)
                .dxTooltip({
                    target: progressBar,
                    showEvent: "mouseenter",
                    hideEvent: "mouseleave",
                    contentTemplate: function () {
                        var content = 'Progress: ' + value.toFixed(2) + '%';

                        return content;
                    }
                });
        },
        CreateDifferencePercentage: function (container, value) {
            if (!value || isNaN(value)) {
                return;
            }

            var colorClass = 'Red';
            var iconClass = 'dx-icon-spindown';

            if (value > 0) {
                colorClass = 'Green';
                iconClass = 'dx-icon-spinup';
            }

            if (value === Infinity) {
                value = '∞';
            }
            else if (value === -Infinity) {
                value = '-∞';
            }
            else {
                value = Helpers.FormatOperations.ToPercentage(value);
            }

            var element = '<span class="' + colorClass + '"><span class="VerticalAlignMiddleNoWebkit ' + iconClass + '"></span>' + value + '</span>';

            angular.element(element).appendTo(container);
        }
    },
    CheckFilteredValue: function (filterValue, cellValue) {
        if (!cellValue) {
            return false;
        };

        let normalizedCellValue = Helpers.Strings.RemoveAccents(cellValue).toLowerCase();
        let normalizedFilterValue = Helpers.Strings.RemoveAccents(filterValue).toLowerCase();
        let validRow = normalizedCellValue.includes(normalizedFilterValue);

        return validRow;
    },
    GenerateTimeObjectWithModal: function ($scope, $compile, $timeout, gridName, container, options, column, showSeconds) {
        var time = options.data.Time;

        if (Helpers.Object.IsUndefinedEmptyOrNull(time)) {
            time = '0.00:00:00';
        }
        else if (time.length === 8) {
            time = "0." + time;
            options.data.Time = time;
        }

        var daysTranslation = Helpers.Translations.Days;
        var emptyTime = showSeconds ? "00h 00m 00s" : "00h 00m";

        let inputText;

        if (time) {
            inputText = "";

            let [days, hours, minutes, seconds, milliseconds] = GetTimeParts(time);

            if (days > 0) {
                inputText += days + " " + daysTranslation + " ";
            }

            inputText += hours + "h " + minutes + "m ";

            if (showSeconds) {
                inputText += seconds + "s ";

                if (milliseconds > 0) {
                    inputText += milliseconds + "ms";
                }
            }
        } else {
            inputText = emptyTime;
        }

        $('<a/>').html('<span class="ParentContentWithMagnifier Fullwidth"><span class="ContentWithMagnifier TextAlignCenter">' + inputText + '</span><i class="lnr lnr-clock"></i></span>')
            .on('dxclick', function () {
                if (!angular.element(this).parent('td').hasClass('Disabled')) {
                    $scope.TimePickerInfo = { rowIndex: options.rowIndex };

                    OpenTimePicker(time);
                }
            }).appendTo(container);

        $compile(container)($scope);

        function OpenTimePicker(time) {
            let modal = {
                Element: 'TimePickerModal',
                Width: '25%'
            }

            let [days, hours, minutes, seconds, milliseconds] = GetTimeParts(time);

            $scope.TimePickerDays = days;

            $scope.TimePickerTime = new Date(0, 0, 0, Number(hours), Number(minutes), Number(seconds), Number(milliseconds));

            Helpers.Dialog.OpenSwebModal(modal, $timeout, $compile, $scope);

            $scope.TimeBoxOptions = {
                type: "time",
                displayFormat: "HH:mm:ss.SSS",
                useMaskBehavior: true,
                showDropDownButton: false,
                bindingOptions: {
                    value: "TimePickerTime"
                }
            };
        }

        $scope.CloseTimePicker = function () {
            Helpers.Dialog.CloseSwebModal('TimePickerModal');
        }

        $scope.SaveTime = function () {
            angular.element('#TimePicker').trigger("change");

            if ($scope.TimePickerTime) {
                let grid = GetInstance();

                const hours = String($scope.TimePickerTime.getHours()).padStart(2, "0");
                const minutes = String($scope.TimePickerTime.getMinutes()).padStart(2, "0");
                const seconds = String($scope.TimePickerTime.getSeconds()).padStart(2, "0");
                const milliseconds = String($scope.TimePickerTime.getMilliseconds()).padStart(3, "0");

                let newTime = ($scope.TimePickerDays || 0) + "." + `${hours}:${minutes}:${seconds}.${milliseconds}`;

                grid.cellValue($scope.TimePickerInfo.rowIndex, column, newTime);

                $scope.CloseTimePicker();
            }
        };

        $scope.ClearTime = function () {
            let newTime = showSeconds ? "0.00:00:00" : "0.00:00";
            let grid = GetInstance();

            grid.cellValue($scope.TimePickerInfo.rowIndex, "Time", newTime);

            $scope.CloseTimePicker();
        };

        function GetTimeParts(time) {
            let [daysPart, rest, milliseconds] = time.split('.');

            if (time.indexOf(".") > time.indexOf(":")) {
                milliseconds = rest;
                rest = daysPart;
            }

            let [hours, minutes, seconds] = rest.split(':');

            let days = Number(daysPart);

            return [days, hours, minutes, seconds, milliseconds ? milliseconds.substring(0, 3) : 0]
        }

        function GetInstance() {
            let isTreeList = angular.element("#" + gridName).hasClass('dx-treelist');
            let gridInstance;

            if (isTreeList) {
                gridInstance = Helpers.DevExtreme.GetTreeListInstance(gridName);
            } else {
                gridInstance = Helpers.DevExtreme.GetGridInstance(gridName);
            }

            return gridInstance;
        }
    },
    RemoveUnusedSummaries: function (summaries, columns) {
        if (!summaries) {
            return;
        }

        let columnNames = [];

        GetAllColumnDataFields(columnNames, columns);

        summaries = summaries.filter(filter => columnNames.includes(filter.column) || columnNames.includes(filter.showInColumn));
    }
}

function GetAllColumnDataFields(columnNames, columns) {
    columns.forEach(column => {
        if (!column) {
            return;
        }

        if (column.columns) {
            GetAllColumnDataFields(columnNames, column.columns);

            return;
        }

        columnNames.push(column.dataField);
    })
}
//#endregion

//#region Chart
Helpers.DevExtreme.GetChartInstance = function (chartName) {
    try {
        var chartInstance = angular.element("#" + chartName).dxChart("instance");

        return chartInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.SetDataSourceByChartId = function (chartId, dataSource, applyRefresh) {
    var chartInstance = Helpers.DevExtreme.GetChartInstance(chartId);

    Helpers.DevExtreme.SetDataSource(chartInstance, dataSource, applyRefresh);
}

Helpers.DevExtreme.SetSeriesByChartId = function (chartId, dataSource, applyRefresh) {
    var chartInstance = Helpers.DevExtreme.GetChartInstance(chartId);

    Helpers.DevExtreme.SetSeries(chartInstance, dataSource, applyRefresh);
}

Helpers.DevExtreme.SetDefaultConfigurationsBarChart = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart, "commonSeriesSettings", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.commonSeriesSettings, "type", "bar");
    Helpers.Object.SetPropertyValueIfUndefined(chart, "legend", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "valueAxis", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis, "grid", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis.grid, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "animation", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.animation, "enabled", true);

    if (chart.customPalette) {
        Helpers.Object.SetPropertyValueIfUndefined(chart, "customizePoint", function (pointInfo) {
            return Helpers.DevExtreme.Color.GetColorForChart(pointInfo.argument, chart.customPalette)
        });
    }

    Helpers.DevExtreme.SetBasicChartTooltip(chart);
}

Helpers.DevExtreme.SetDefaultConfigurationsStackedBarChart = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart, "commonSeriesSettings", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.commonSeriesSettings, "type", 'stackedbar');
    Helpers.Object.SetPropertyValueIfUndefined(chart, "legend", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "valueAxis", []);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "animation", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.animation, "enabled", true);

    chart.valueAxis.forEach(serie => {
        Helpers.Object.SetPropertyValueIfUndefined(serie, "grid", {});
        Helpers.Object.SetPropertyValueIfUndefined(serie.grid, "visible", false);
    });

    Helpers.DevExtreme.SetBasicChartTooltip(chart);
}

Helpers.DevExtreme.SetBasicChartTooltip = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart, "tooltip", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.tooltip, "enabled", true);
    Helpers.Object.SetPropertyValueIfUndefined(chart.tooltip, "customizeTooltip", function (pointInfo) {
        let toolTip = { text: "<div class='Bold'>" + pointInfo.argument + "</div><br>" + pointInfo.value };

        return toolTip;
    });
}
//#endregion

//#region Line Chart
Helpers.DevExtreme.SetDefaultConfigurationsLineChart = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "type", "line");
    Helpers.Object.SetPropertyValueIfUndefined(chart, "legend", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "argumentAxis", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis, "label", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis, "valueMarginsEnabled", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis.label, "overlappingBehavior", "rotate");
    Helpers.Object.SetPropertyValueIfUndefined(chart, "valueAxis", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis, "grid", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis.grid, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "animation", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.animation, "enabled", true);

    Helpers.DevExtreme.SetBasicChartTooltip(chart);
};
//#endregion

//#region Pie Chart
Helpers.DevExtreme.GetPieChartInstance = function (chartName) {
    try {
        var pieChartInstance = angular.element("#" + chartName).dxPieChart("instance");

        return pieChartInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.SetDataSourceByPieChartId = function (pieChartId, dataSource, applyRefresh) {
    var pieChartInstance = Helpers.DevExtreme.GetPieChartInstance(pieChartId);

    Helpers.DevExtreme.SetDataSource(pieChartInstance, dataSource, applyRefresh);
}

Helpers.DevExtreme.SetDefaultConfigurationsPieChart = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "type", "pie");
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "label", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.label, "visible", true);
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.label, "connector", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.label.connector, "visible", true);
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "smallValuesGrouping", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.smallValuesGrouping, "mode", 'topN');
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.smallValuesGrouping, "topCount", 10);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "legend", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "animation", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.animation, "enabled", true);
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "customizeText", function (pointInfo) {
        if (pointInfo.pointName == "others") {
            pointInfo.pointName = Helpers.Translations.Others;
        }

        return pointInfo.pointName;
    });
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "horizontalAlignment", 'top');
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "verticalAlignment", 'right');

    if (chart.customPalette) {
        Helpers.Object.SetPropertyValueIfUndefined(chart, "customizePoint", function (pointInfo) {
            return Helpers.DevExtreme.Color.GetColorForChart(pointInfo.argument, chart.customPalette)
        });
    }

    Helpers.DevExtreme.SetBasicPieChartTooltip(chart);
};

Helpers.DevExtreme.SetDefaultConfigurationsDoughnutChart = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "type", "doughnut");
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "label", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.label, "visible", true);
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.label, "connector", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.label.connector, "visible", true);
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "smallValuesGrouping", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.smallValuesGrouping, "mode", 'topN');
    Helpers.Object.SetPropertyValueIfUndefined(chart.series.smallValuesGrouping, "topCount", 10);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "legend", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart, "animation", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.animation, "enabled", true);

    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "customizeText", function (pointInfo) {
        if (pointInfo.pointName == "others") {
            pointInfo.pointName = Helpers.Translations.Others;
        }

        return pointInfo.pointName;
    });
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "horizontalAlignment", 'top');
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "verticalAlignment", 'right');

    Helpers.DevExtreme.SetBasicPieChartTooltip(chart);
};

Helpers.DevExtreme.SetBasicPieChartTooltip = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart, "tooltip", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.tooltip, "font", myApplication.gridFont);
    Helpers.Object.SetPropertyValueIfUndefined(chart.tooltip, "enabled", true);
    Helpers.Object.SetPropertyValueIfUndefined(chart.tooltip, "customizeTooltip", function (pointInfo) {
        let percentage = (pointInfo.percent * 100).toFixed(2);

        var toolTip = { text: "<div class='Bold'>" + pointInfo.argument + "</div><br>" + percentage + " %<br>" };

        return toolTip;
    });
}
//#endregion

//#region Area Chart
Helpers.DevExtreme.SetDefaultConfigurationsAreaChart = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart.series, "type", "area");
    Helpers.Object.SetPropertyValueIfUndefined(chart, "legend", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "argumentAxis", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis, "label", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis, "valueMarginsEnabled", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis.label, "overlappingBehavior", "rotate");
    Helpers.Object.SetPropertyValueIfUndefined(chart, "valueAxis", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis, "grid", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis.grid, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "animation", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.animation, "enabled", true);

    Helpers.DevExtreme.SetBasicChartTooltip(chart);
};

Helpers.DevExtreme.SetDefaultConfigurationsStackedAreaChart = function (chart) {
    Helpers.Object.SetPropertyValueIfUndefined(chart, "commonSeriesSettings", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.commonSeriesSettings, "type", 'stackedArea');
    Helpers.Object.SetPropertyValueIfUndefined(chart, "legend", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.legend, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "argumentAxis", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis, "label", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis, "valueMarginsEnabled", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart.argumentAxis.label, "overlappingBehavior", "rotate");
    Helpers.Object.SetPropertyValueIfUndefined(chart, "valueAxis", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis, "grid", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.valueAxis.grid, "visible", false);
    Helpers.Object.SetPropertyValueIfUndefined(chart, "animation", {});
    Helpers.Object.SetPropertyValueIfUndefined(chart.animation, "enabled", true);

    Helpers.DevExtreme.SetBasicChartTooltip(chart);
};
//#endregion

//#region Bar Gauge Chart
Helpers.DevExtreme.Gauge = {
    GetInstance: function (chartName) {
        try {
            var gaugeChartInstance = angular.element("#" + chartName).dxBarGauge("instance");

            return gaugeChartInstance;
        } catch (_exception) { }
    }
};
//#endregion 

//#region Tree Map
Helpers.DevExtreme.TreeMap = {
    GetInstance: function (treeMapId) {
        try {
            let treeMapInstance = angular.element("#" + treeMapId).dxTreeMap("instance");

            return treeMapInstance;
        } catch (_exception) { }
    },
    GoBack: function (e) {
        $(e.target).data('node').drillDown();
    },
    SetDataSource: function (treeMapInstance, dataSource) {
        if (!treeMapInstance) {
            return;
        }

        treeMapInstance.option('dataSource.store', dataSource);
    },
    SetDataSourceById: function (treeMapId, dataSource) {
        let treeMapInstance = this.GetInstance(treeMapId);

        this.SetDataSource(treeMapInstance, dataSource);
    },
    SetDefaultConfigurations: function (treeMap) {
        Helpers.Object.SetPropertyValueIfUndefined(treeMap, "tooltip", {});
        Helpers.Object.SetPropertyValueIfUndefined(treeMap.tooltip, "enabled", true);
        Helpers.Object.SetPropertyValueIfUndefined(treeMap.tooltip, "customizeTooltip", function (pointInfo) {
            let toolTip = { text: "<div class='Bold'>" + pointInfo.node.data.name + "</div><br>" + pointInfo.value };

            return toolTip;
        });

        if (treeMap.customPalette) {
            Helpers.Object.SetPropertyValueIfUndefined(treeMap, "onNodesRendering", function (e) {
                const allNodes = e.node.getAllNodes();

                allNodes.forEach(node => {
                    if (node.isLeaf()) {
                        let color = Helpers.DevExtreme.Color.GetColorForChart(node.data.name, treeMap.customPalette);
                        let colorObject = {
                            color: color.color, hoverStyle: { color: color.color }
                        }

                        node.customize(colorObject);
                    }
                });
            });
        }
    }
}
//#endregion

//#region Button
Helpers.DevExtreme.Button = {
    GetInstance: function (buttonName) {
        try {
            let buttonInstance = angular.element('#' + buttonName).dxButton('instance');

            return buttonInstance;
        }
        catch (_exception) { }
    },
    SetText: function (buttonName, value) {
        let buttonInstance = this.GetInstance(buttonName);

        if (!buttonInstance) {
            return;
        }

        buttonInstance.option('text', value);
    }
}
//#endregion

//#region Popover
Helpers.DevExtreme.Popover = {
    GetCreationInformation: function (information) {
        let popoverInformation = [{
            caption: Helpers.Translations.UsersUser,
            field: information.CreationUserName
        }, {
            caption: Helpers.Translations.CreationDatetime,
            field: Helpers.Date.ConvertToString(information.CreationDatetime, myApplication.dateTimeFormat)
        }]

        if (information.Observations) {
            let observations = {
                caption: Helpers.Translations.DocumentsAnnulledObservations,
                field: information.Observations
            }

            popoverInformation.push(observations);
        }

        return popoverInformation;
    }
};
//#endregion

//#region Radio Group Button
Helpers.DevExtreme.RadioGroupButton = {
    GetInstance: function (radioGroupButtonId) {
        try {
            let radioGroupButtonInstance = angular.element("#" + radioGroupButtonId).dxRadioGroup("instance");

            return radioGroupButtonInstance;
        } catch (_exception) { }
    }
}
//#endregion

//#region Tag Box
Helpers.DevExtreme.TagBox = {
    GetInstance: function (tagBoxName) {
        try {
            let tagBoxInstance = angular.element("#" + tagBoxName).dxTagBox("instance");

            return tagBoxInstance;
        } catch (_exception) { }
    },
    ResetInstance: function (tagBoxName) {
        let tagBoxInstance = this.GetInstance(tagBoxName);

        if (tagBoxInstance) {
            tagBoxInstance.reset();
        }
    }
};
//#endregion

//#region Text Box
Helpers.DevExtreme.TextBox = {
    GetInstance: function (textBoxId) {
        try {
            let textBoxInstance = angular.element("#" + textBoxId).dxTextBox("instance");

            return textBoxInstance;
        } catch (_exception) { }
    }
}
//#endregion

//#region Date Box
Helpers.DevExtreme.DateBox = {
    DisabledDates: function (allowedDates, data) {
        if (!data || !data.date || !data.view) {
            return false;
        }

        const date = data.date;
        const view = data.view;

        const allowedFormatted = allowedDates.map(allowedDate => this.FormatDateByView(allowedDate, view));

        const currentFormatted = this.FormatDateByView(date, view);

        let isDisabled = !allowedFormatted.includes(currentFormatted);

        return isDisabled;
    },
    FormatDateByView: function (date, view) {
        switch (view) {
            case 'century':
                return Math.floor(date.getFullYear() / 10);

            case 'decade':
                return date.getFullYear();

            case 'year':
                return `${date.getFullYear()}-${date.getMonth()}`;

            default:
                return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
        }
    }
};
//#endregion

//#region Treelist
Helpers.DevExtreme.TreeList = {
    DisableCell: function (rowIndex, treeListName, status) {
        if (treeListName) {
            var treeList = Helpers.DevExtreme.GetTreeListInstance(treeListName);
            treeList.cellValue(rowIndex, 'Disabled', status);
        }
    },
    GetCleanEditData: function (treeListData, treeList, childPropertyName, id, childId) {
        let finalObject = [];
        let editData = Helpers.DevExtreme.GetEditData(treeList);

        editData.forEach(item => {
            let itemId = item.key;

            if (item.type === "insert") {
                let newItem = angular.copy(item.data);

                finalObject.push(newItem);

                return;
            }

            if (typeof (itemId) == 'number') {
                let node = treeList.getNodeByKey(itemId);
                let treeListRowFinalObject = finalObject.find(find => (find[id] === node.parent.data[id]));

                if (!treeListRowFinalObject) {
                    treeListRowFinalObject = angular.copy(node.parent.data);

                    finalObject.push(treeListRowFinalObject);
                }

                if (!treeListRowFinalObject[childPropertyName]) {
                    treeListRowFinalObject[childPropertyName] = [];
                }

                treeListRowFinalObject[childPropertyName].push(item.data);
            }

            let treeListRow = treeListData.find(find => (find[id] === itemId));

            if (treeListRow) {
                let treeListRowFinalObject = finalObject.find(find => (find[id] === itemId));

                if (treeListRowFinalObject) {
                    Object.assign(treeListRowFinalObject, item.data);

                    return;
                }

                let treeListRowToUpdate = angular.copy(treeListRow);

                Object.assign(treeListRowToUpdate, item.data);

                treeListRowToUpdate[childPropertyName] = [];

                if (item.type == "remove") {
                    treeListRowToUpdate.Delete = true;
                } else {
                    SetPropertiesToUpdate(treeListRowToUpdate, item.data);
                }

                finalObject.push(treeListRowToUpdate);

                return;
            }

            let parentRow = treeListData.find(find => find[childPropertyName] && find[childPropertyName].some(some => (some[childId] === itemId)));

            if (!parentRow) {
                return;
            }

            let option = parentRow[childPropertyName].find(find => (find[childId] === itemId));
            let parentRowFinalObject = finalObject.find(find => (find[id] === parentRow[id]));
            let optionToUpdate;

            if (parentRowFinalObject) {
                optionToUpdate = parentRowFinalObject[childPropertyName].find(find => (find[childId] === itemId));

                if (!optionToUpdate) {
                    optionToUpdate = angular.copy(option);
                    parentRowFinalObject[childPropertyName].push(optionToUpdate);
                }
            } else {
                let parentCopy = angular.copy(parentRow);

                optionToUpdate = parentCopy[childPropertyName].find(find => (find[childId] === itemId));
                parentCopy[childPropertyName] = [optionToUpdate];

                finalObject.push(parentCopy);
            }

            if (item.type == "remove") {
                optionToUpdate.Delete = true;
            } else {
                SetPropertiesToUpdate(optionToUpdate, item.data);
            }

            Object.assign(optionToUpdate, item.data);
        });

        return finalObject;
    }
};

function SetPropertiesToUpdate(assignedObject, data) {
    let propertiesToUpdate = Object.keys(data);

    propertiesToUpdate = propertiesToUpdate.filter(function (propertyName) {
        let propertyToUpdate = assignedObject[propertyName];
        let isNotObject = !angular.isObject(propertyToUpdate);

        return isNotObject;
    });

    assignedObject.PropertiesToUpdate = propertiesToUpdate;
}

Helpers.DevExtreme.GetTreeListInstance = function (treeListName) {
    try {
        var treeListInstance = angular.element("#" + treeListName).dxTreeList("instance");

        return treeListInstance;
    } catch (_exception) { }
};

Helpers.DevExtreme.SetTreeListDataSource = function (treeListInstance, dataSource, applyRefresh) {
    treeListInstance.option('dataSource', dataSource);

    if (applyRefresh) {
        treeListInstance.refresh();
    }
};

Helpers.DevExtreme.SetTreeListDataSourceByTreeListId = function (treeListId, dataSource, applyRefresh) {
    var treeListInstance = Helpers.DevExtreme.GetTreeListInstance(treeListId);

    Helpers.DevExtreme.SetTreeListDataSource(treeListInstance, dataSource, applyRefresh);
};

Helpers.DevExtreme.TreeList.GetOldDataEditedRow = function (treeList, rowKey) {
    var oldRowData;
    var oldData = treeList.getController("editing")._internalState;

    if (oldData) {
        oldRowData = oldRowData.find(find => find.key === rowKey);
    }

    return oldRowData;
};

Helpers.DevExtreme.TreeList.ExportTreeListToExcel = function (GridName, fileName, columnFieldsToMap) {
    var treeList = Helpers.DevExtreme.GetTreeListInstance(GridName);
    var workbook = new ExcelJS.Workbook();
    var worksheet = workbook.addWorksheet(fileName);
    var columns = treeList.getVisibleColumns().filter(filter => filter.dataField);
    var header = GetHeaders(columns);

    worksheet.addRow(header);
    columnFieldsToMap = columnFieldsToMap || [];

    var rootNode = treeList.getRootNode();
    var data = GetData(rootNode, columns, columnFieldsToMap);

    data.map(row => worksheet.addRow(row));

    workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');
    });
}

function GetHeaders(columns) {
    var headers = Array();

    for (var i = 0; i < columns.length; i++) {
        headers[i] = columns[i].caption;
    }

    return headers;
}

function GetRows(node, columns, columnFieldsToMap) {
    var rows = Array();

    for (var i = 0; i < columns.length; i++) {
        var dataField = columns[i].dataField;
        var propertyToConsider = dataField.split(".");

        var findColumn = columnFieldsToMap.find(find => (find.dataField === dataField));

        if (findColumn) {
            dataField = findColumn.property;
        }

        var cell;

        if (findColumn) {
            var result;
            var propertyToConsider = findColumn.property.split(".");

            if (propertyToConsider.length > 1) {
                for (var j = 0; j < propertyToConsider.length; j++) {
                    if (j == 0) {
                        result = node.data[propertyToConsider[0]];
                    } else {
                        result = result[propertyToConsider[j]];
                    }
                }

                cell = result[findColumn.value];
            } else {
                cell = node.data[dataField][findColumn.value];
            }
        } else {
            cell = node.data[dataField];
        }

        if (i === 0) {
            cell = '   '.repeat(node.level) + cell;
        }

        rows[i] = cell;
    }

    return rows;
}

function GetData(node, columns, columnFieldsToMap) {
    var rows = Array();

    if (node.level >= 0) {
        var row = GetRows(node, columns, columnFieldsToMap);

        rows.push(row);
    }

    for (var i = 0; i < node.children.length; i++) {
        GetData(node.children[i], columns, columnFieldsToMap).map(row => rows.push(row));
    }

    return rows;
}
//#endregion

//#region NumberBox
Helpers.DevExtreme.GetNumberBoxInstance = function (numberBoxId) {
    try {
        var instance = $("#" + numberBoxId).dxNumberBox("instance");

        return instance;
    } catch (_exception) { }
}
//#endregion

//#region Column Chooser
Helpers.DevExtreme.SetColumnChooserPosition = function (element) {
    var columnChooserView = element.component.getView("columnChooserView");

    if (!columnChooserView._popupContainer) {
        var position = {
            of: element.element,
            my: "right top",
            at: "0 40",
            offset: "0 40"
        }

        columnChooserView._initializePopupContainer();
        columnChooserView.render();
    }

    columnChooserView._popupContainer.option("position", position);
}
//#endregion

//#region File Manager
Helpers.DevExtreme.FileManager = {
    GetThumbnail: function (fileSystemItem) {
        if (fileSystemItem.isDirectory) {
            return 'img/folder.svg';
        }

        const fileExtension = fileSystemItem.getFileExtension();

        let thumbnailPath = this.GetThumbnailPath(fileExtension);

        return thumbnailPath;
    },
    GetThumbnailPath: function (fileExtension) {
        switch (fileExtension) {
            case '.avi':
                return 'img/avi.svg';
            case '.csv':
                return 'img/csv.svg';
            case '.doc':
            case '.docx':
                return 'img/doc.svg';
            case '.gif':
                return 'img/gif.svg';
            case '.html':
                return 'img/html.svg';
            case '.jpg':
                return 'img/jpg.svg';
            case '.js':
                return 'img/js.svg';
            case '.mov':
                return 'img/mov.svg';
            case '.mp3':
                return 'img/mp3.svg';
            case '.mp4':
                return 'img/mp4.svg';
            case '.pdf':
                return 'img/pdf.svg';
            case '.png':
                return 'img/png.svg';
            case '.ppt':
            case '.pptx':
                return 'img/ppt.svg';

            case '.tiff':
                return 'img/tiff.svg';
            case '.txt':
                return 'img/txt.svg';
            case '.xls':
            case '.xlsx':
                return 'img/xls.svg';
            case '.zip':
            case '.rar':
                return 'img/zip.svg';
            default:
                return 'img/file.svg';
        }
    },
    GetFileInformation: function (fileName) {
        var isImage = Helpers.Files.CompareExtension(fileName, ['png', 'jpg', 'jpeg', 'gif', 'bmp']);
        var isPdf, isHtml, isVideo, isGif, blobType = null;

        if (!isImage) {
            isPdf = Helpers.Files.CompareExtension(fileName, ['pdf']);

            if (!isPdf) {
                isHtml = Helpers.Files.CompareExtension(fileName, ['html']);

                if (!isHtml) {
                    isVideo = Helpers.Files.CompareExtension(fileName, ['mp4']);

                    if (!isVideo) {
                        isGif = Helpers.Files.CompareExtension(fileName, ['gif']);
                    }
                }
            }
        }

        if (!isImage && !isPdf && !isHtml && !isVideo && !isGif) {
            return undefined;
        }

        if (isPdf) {
            blobType = 'application/pdf';
        }
        else if (isHtml) {
            blobType = 'text/html';
        }
        else if (isVideo) {
            blobType = 'video/mp4';
        }
        else if (isGif) {
            blobType = 'image/gif';
        }

        var result = {
            blobType: blobType,
            isImage: isImage,
            isPdf: isPdf,
            isHtml: isHtml,
            isVideo: isVideo,
            isGif: isGif
        }

        return result;
    },
    CustomizeItemView: function () {
        var itemView = {
            details: {
                columns: [{
                    dataField: 'thumbnail'
                }, {
                    dataField: 'name',
                    caption: Helpers.Translations.SearchName
                }, {
                    dataField: 'dateModified',
                    caption: Helpers.Translations.ModifiedDate,
                    dataType: 'date',
                    width: 200
                }, {
                    dataField: 'size',
                    caption: Helpers.Translations.Size,
                    width: 200
                }]
            }
        }

        return itemView;
    },
    CustomizeToolbar: function () {
        var toolbar = {
            fileSelectionItems: [
                {
                    name: 'download',
                    options: { text: Helpers.Translations.Download, hint: Helpers.Translations.Download }
                },
                'separator',
                {
                    name: 'move',
                    options: { text: Helpers.Translations.Move, hint: Helpers.Translations.Move }
                }, {
                    name: 'copy',
                    options: { text: Helpers.Translations.Copy, hint: Helpers.Translations.Copy }
                }, {
                    name: 'rename',
                    options: { text: Helpers.Translations.Rename, hint: Helpers.Translations.Rename }
                },
                'separator',
                {
                    name: 'delete',
                    options: { text: Helpers.Translations.Delete, hint: Helpers.Translations.Delete }
                }, {
                    name: 'clearSelection',
                    options: { text: Helpers.Translations.ClearSelection, hint: Helpers.Translations.ClearSelection }
                }, {
                    name: 'separator',
                    location: 'after'
                }, {
                    name: 'refresh',
                    options: { text: Helpers.Translations.Refresh, hint: Helpers.Translations.Refresh }
                }],
            items: [
                {
                    name: 'showNavPane',
                    options: { text: Helpers.Translations.DxFileManagerShowNavPane, hint: Helpers.Translations.DxFileManagerShowNavPane }
                }, {
                    name: 'create',
                    options: { text: Helpers.Translations.New, hint: Helpers.Translations.New }
                }, {
                    name: 'upload',
                    options: { text: Helpers.Translations.Upload, hint: Helpers.Translations.Upload }
                }, {
                    name: 'switchView',
                    options: { text: Helpers.Translations.DxFileManagerSwitchView, hint: Helpers.Translations.DxFileManagerSwitchView }
                }, {
                    name: 'separator',
                    location: 'after'
                }, {
                    name: 'refresh',
                    options: { text: Helpers.Translations.Refresh, hint: Helpers.Translations.Refresh }
                }
            ]
        }

        return toolbar;
    },
    CustomizeContextMenu: function () {
        var contextMenu = {
            items: [
                {
                    name: 'create',
                    text: Helpers.Translations.New
                }, {
                    name: 'upload',
                    text: Helpers.Translations.Upload
                }, {
                    name: 'rename',
                    text: Helpers.Translations.Rename
                }, {
                    name: 'move',
                    text: Helpers.Translations.Move
                }, {
                    name: 'copy',
                    text: Helpers.Translations.Copy
                }, {
                    name: 'delete',
                    text: Helpers.Translations.Delete
                }, {
                    name: 'refresh',
                    text: Helpers.Translations.Refresh
                }, {
                    name: 'download',
                    text: Helpers.Translations.Download
                }
            ]
        }

        return contextMenu;
    }
};
//#endregion

//#region Diagram
Helpers.DevExtreme.Diagram = {
    Destroy: function (diagramId) {
        try {
            let diagramInstance = angular.element('#' + diagramId).dxDiagram("instance");

            if (diagramInstance && (typeof diagramInstance.dispose === 'function')) {
                diagramInstance.dispose();
            }
        } catch (_exception) { }
    }
}
//#endregion

//#region Validators
Helpers.DevExtreme.Validator = {
    GetInstance: function (elementId) {
        try {
            let validatorInstance = angular.element("#" + elementId).dxValidator("instance");

            return validatorInstance;
        } catch (_exception) { }
    },
    IsValid: function (elementId) {
        let validatorInstance = this.GetInstance(elementId);

        if (!validatorInstance) {
            return false;
        }

        let isValid = validatorInstance.validate().isValid;

        return isValid;
    }
}
//#endregion

Helpers.DevExtreme.UpdateDxGridRow = function (elementId, grid, rowIndex, elementIdFieldName) {
    var editData = Helpers.DevExtreme.Grid.GetEditData(grid);

    for (var w = 0; w < editData.length; w++) {
        if (elementId === editData[w].key[elementIdFieldName]) {
            editData.splice(w, 1);
        }
    }

    grid.repaintRows(rowIndex);
};

Helpers.DevExtreme.UpdateTreeListRow = function (elementId, grid, rowIndex, elementIdFieldName) {
    var editData = Helpers.DevExtreme.GetEditData(grid);

    for (var w = 0; w < editData.length; w++) {
        if (elementId === editData[w].key[elementIdFieldName]) {
            editData.splice(w, 1);
        }
    }

    grid.repaintRows(rowIndex);
};

Helpers.DevExtreme.EncodeHtml = function (string) {
    if (!Helpers.Object.IsUndefinedEmptyOrNull(string)) {
        return string.toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/\"/g, '&quot;')
            .replace(/\'/g, '&#39;')
            .replace(/\//g, '&#x2F;');
    }

    return string;
};

Helpers.DevExtreme.CreateHiddenIdOnColumn = function (datafield, idName) {
    return function (container, options) {
        var name = "";

        if (!Helpers.Object.IsUndefinedEmptyOrNull(options.data) && !Helpers.Object.IsUndefinedEmptyOrNull(options.data[datafield])) {
            name = options.data[datafield];
        }

        angular.element('<span>' + Helpers.DevExtreme.EncodeHtml(name) + '</span>').appendTo(container);
        angular.element('<span class="' + idName + ' DisplayNone">' + Helpers.DevExtreme.EncodeHtml(options.data[idName]) + '</span>').appendTo(container);
    };
};

Helpers.DevExtreme.FindRowIndex = function (element) {
    if (angular.element(element).parents('.dx-datagrid-table').find('tbody').length > 1) {
        var rowsCount = 0;

        angular.element(element).parents('.dx-datagrid-table').find('tbody').each(function (index) {
            if (angular.element(element).closest('tbody').index() > index + 1) {
                rowsCount += angular.element(this).find('.dx-row').length;
            }
        });

        return (rowsCount + angular.element(element).closest('.dx-row').index());
    }

    return angular.element(element).closest('.dx-row').index();
};

Helpers.DevExtreme.SetDataSource = function (gridInstance, dataSource, applyRefresh) {
    gridInstance.option('dataSource.store', dataSource);

    if (applyRefresh) {
        gridInstance.refresh();
    }
};

Helpers.DevExtreme.GetDataSource = function (gridInstance) {
    let dataSource = gridInstance.getDataSource().items();

    return dataSource;
};

Helpers.DevExtreme.SetSeries = function (gridInstance, dataSource, applyRefresh) {
    gridInstance.option('series', dataSource);

    if (applyRefresh) {
        gridInstance.refresh();
    }
};

Helpers.DevExtreme.SetDataSourceByGridId = function (gridId, dataSource, applyRefresh) {
    var gridInstance = Helpers.DevExtreme.GetGridInstance(gridId);

    Helpers.DevExtreme.SetDataSource(gridInstance, dataSource, applyRefresh);
};

Helpers.DevExtreme.DisableCell = function (rowIndex, gridName, status) {
    if (gridName) {
        var grid = Helpers.DevExtreme.GetGridInstance(gridName);
        grid.cellValue(rowIndex, 'Disabled', status);
    }
};

Helpers.DevExtreme.DisableTreeListCell = function (rowIndex, treeListName, status) {
    if (treeListName) {
        var treeList = Helpers.DevExtreme.GetTreeListInstance(treeListName);
        treeList.cellValue(rowIndex, 'Disabled', status);
    }
};

Helpers.DevExtreme.CreateFilterRowObject = function (visible) {
    return {
        applyFilter: "auto",
        applyFilterText: Helpers.Translations.ApplyGridFilter,
        betweenEndText: Helpers.Translations.BetweenEnd,
        betweenStartText: Helpers.Translations.BetweenStart,
        operationDescriptions: {
            between: Helpers.Translations.Between,
            contains: Helpers.Translations.Contains,
            endsWith: Helpers.Translations.EndsWith,
            equal: Helpers.Translations.Equal,
            greaterThan: Helpers.Translations.GreaterThan,
            greaterThanOrEqual: Helpers.Translations.GreaterThanOrEqual,
            lessThan: Helpers.Translations.LessThan,
            lessThanOrEqual: Helpers.Translations.LessThanOrEqual,
            notContains: Helpers.Translations.NotContains,
            notEqual: Helpers.Translations.NotEqual,
            startsWith: Helpers.Translations.StartsWith
        },
        resetOperationText: Helpers.Translations.Reset,
        showAllText: "",
        showOperationChooser: true,
        visible: visible
    };
};

Helpers.DevExtreme.CreateEditingObject = function (allowAdding, allowUpdating, allowDeleting, newRowPosition) {
    return {
        mode: "batch",
        allowUpdating: allowUpdating,
        allowDeleting: allowDeleting,
        allowAdding: allowAdding,
        newRowPosition: newRowPosition,
        texts: {
            editRow: Helpers.Translations.EditRow,
            deleteRow: Helpers.Translations.DeleteRow,
            saveRowChanges: Helpers.Translations.SaveRowChanges,
            cancelRowChanges: Helpers.Translations.CancelRowChanges,
            undeleteRow: Helpers.Translations.UndeleteRow
        }
    };
};

Helpers.DevExtreme.GetCleanEditData = function (grid) {
    var finalObject = [];
    var editData = Helpers.DevExtreme.GetEditData(grid);

    for (var g = 0; g < editData.length; g++) {
        var item = editData[g];

        if (typeof item.type === 'undefined') {
            continue;
        }

        var data = ((item.type === "remove")) ? { Delete: true } : item.data;

        const assignedObject = {};

        if (item.type === 'insert') {
            Object.assign(assignedObject, data);
        }
        else {
            if (angular.isObject(item.key)) {
                Object.assign(assignedObject, item.key, data);
            } else {
                let keyExpr = grid.option('keyExpr');

                if (!keyExpr) {
                    let dataSource = grid.getDataSource();

                    if (dataSource) {
                        keyExpr = dataSource.key();
                    }
                }

                let rowData = null;

                if (angular.isObject(item.oldData)) {
                    rowData = item.oldData;
                }

                if (rowData) {
                    Object.assign(assignedObject, angular.copy(rowData));
                } else if (keyExpr && (typeof keyExpr === 'string')) {
                    assignedObject[keyExpr] = item.key;
                }

                Object.assign(assignedObject, data);
            }

            if (item.type === 'update') {
                let propertiesToUpdate = Object.keys(data);

                propertiesToUpdate = propertiesToUpdate.filter(function (propertyName) {
                    let isObject = !angular.isObject(assignedObject[propertyName]);

                    return isObject;
                });

                assignedObject.PropertiesToUpdate = propertiesToUpdate;
            }
        }

        finalObject.push(assignedObject);
    }

    return finalObject;
};

Helpers.DevExtreme.CreateExportToExcelButton = function (buttonName, gridName) {
    angular.element("#" + buttonName + "").dxButton({
        onClick: function () {
            Helpers.DevExtreme.ExportToExcelGrid(gridName);
        }
    });
};

Helpers.DevExtreme.CreateOpenColumnChooserButton = function (buttonName, gridName) {
    angular.element("#" + buttonName + "").dxButton({
        onClick: function () {
            Helpers.DevExtreme.OpenColumnChooser(gridName);
        }
    });
};

Helpers.DevExtreme.CreateSearchBox = function (boxName, gridName, placeholder) {
    angular.element("#" + boxName + "").dxTextBox({
        placeholder: placeholder,
        mode: 'search',
        valueChangeEvent: 'keyup',
        onValueChanged: function (e) {
            Helpers.DevExtreme.FilterGridByText(gridName, e.value);
        }
    });
};

Helpers.DevExtreme.CustomizeExportData = function (_columns, rows) {
    rows.forEach(function (row) {
        var rowValues = row.values;

        for (var i = 0; i < rowValues.length; i++) {
            var rowValue = rowValues[i];

            if (!Helpers.Object.IsUndefinedEmptyOrNull(rowValue)) {
                rowValues[i] = String(rowValue).replace(/[^\w\s]/gi, '');
            }
            else {
                rowValues[i] = '';
            }
        }
    });
};

Helpers.DevExtreme.ChangeVisibleIfForceExporting = function (grid, columns, visible) {
    var findColumns = columns.filter(where => where.forceExporting);

    for (var i = 0; i < findColumns.length; i++) {
        var column = findColumns[i];

        grid.columnOption('dataFieldToExport:' + column.dataFieldToExport, "visible", visible);
    }

    if (findColumns.length) {
        return true;
    }

    return false;
}

Helpers.DevExtreme.SetAllowHiding = function (columns, allowHiding) {
    var columnsToSet = columns.filter(filter => (filter.allowHiding !== true));

    $.each(columnsToSet, function (_, column) {
        if ((column.visible === false) || !column.caption) {
            column.allowHiding = false;
            column.showInColumnChooser = false;

            return;
        }

        if (allowHiding) {
            column.allowHiding = true;
            column.showInColumnChooser = true;

            if (column.columns) {
                Helpers.DevExtreme.SetAllowHiding(column.columns, true);
            }
        }
    });
};

Helpers.DevExtreme.CustomizeColumns = function (columns) {
    $.each(columns, function (_, column) {
        column.headerCellTemplate = function (header, info) {
            $(header)
                .html(info.column.caption)
                .addClass('DataGridHeaderCellCenter');
            $('.dx-column-indicators')
                .addClass('DataGridHeaderCellIndicatorLeft');
        };

        if (column.columns) {
            Helpers.DevExtreme.CustomizeColumns(column.columns);
        }

        if (column.allowFiltering === false) {
            Helpers.Object.SetPropertyValueIfUndefined(column, "allowSearch", false);
        }

        if (column.calculateCellValue) {
            Helpers.Object.SetPropertyValueIfUndefined(column, "allowFiltering", true);
            Helpers.Object.SetPropertyValueIfUndefined(column, "allowSorting", true);
        }
    });
};

Helpers.DevExtreme.CopyEditData = function (editedData, editedItems, elementId) {
    for (var e = 0; e < editedData.length; e++) {
        var item = editedData[e];
        var itemId = item[elementId];

        if (Helpers.Object.IsUndefinedEmptyOrNull(itemId)) {
            continue;
        }

        var indexEditedItems = Helpers.Object.GetArrayIndexByPropertyValue(itemId, editedItems, elementId);

        if (Helpers.Object.IsUndefinedEmptyOrNull(indexEditedItems)) {
            editedItems.push(Helpers.Object.AngularCopy(item));
        }
        else {
            editedItems[indexEditedItems] = Helpers.Object.AngularCopy(item);
        }
    }

    return editedItems;
};

Helpers.DevExtreme.DefineGridCustomHeight = function (value, minimum, gridId) {
    var height = Helpers.DevExtreme.GetObjectHeight(value, minimum, gridId);

    return height;
};

Helpers.DevExtreme.GetObjectHeight = function (value, minimum, gridId) {
    var height = angular.element("body").height();

    if (!minimum || isNaN(minimum)) {
        minimum = 200;
    }

    if (value && !isNaN(value)) {
        height = angular.element("body").height() - 212 - value;
    }

    if (gridId) {
        var offset = angular.element("#" + gridId).offset();

        if (offset) {
            height -= offset.top + 50;
        }
    }

    if (height < minimum) {
        height = minimum;
    }

    return height;
}

Helpers.DevExtreme.FilterGridByText = function (gridName, searchText) {
    var grid = Helpers.DevExtreme.GetGridInstance(gridName);
    grid.searchByText(searchText);
};

Helpers.DevExtreme.FilterTreeListByText = function (treeListName, searchText) {
    var treeList = Helpers.DevExtreme.GetTreeListInstance(treeListName);
    treeList.searchByText(searchText);
};

Helpers.DevExtreme.CheckIfGridHasEditData = function (gridName) {
    var grid = Helpers.DevExtreme.GetGridInstance(gridName);

    if (!grid) {
        return false;
    }

    var hasEditData = grid.hasEditData();

    return hasEditData;
};

function GetSearchEyeIcon(controller, guidName, dataSource) {
    if (!controller) {
        return;
    }

    if (myApplication.appName !== "SwebApp") {
        return;
    }

    let id = dataSource[guidName];

    if (!Helpers.Guid.HasValue(id)) {
        return;
    }

    let numberOfCharacters = "SearchController".length;
    let entityType = controller.slice(0, -numberOfCharacters);

    if (!myApplication.Routing.states.includes(entityType)) {
        return;
    }

    let parametersForPage = { id: id };

    let htmlElement = '<div class="SearchInputEyeDataGrid">' +
        '<a class="lnr lnr-eye" ng-click=\'GoToPage("' + entityType + '", ' +
        JSON.stringify(parametersForPage) +
        ', false, $event, true)\'></a>' +
        '</div>';

    let eyeIcon = {
        htmlElement: htmlElement,
        classesToAdd: "SearchInputContentWithEyeIcon",
        classesForSearch: "SearchInputContainerWithEyeIcon"
    };

    return eyeIcon;
}

Helpers.DevExtreme.CreateSearchColumn = function ($scope, $compile, primaryKeyName, guidName, objectName, required, inputValue, controller, componentDependencies, fieldsToExport, caption, parameters, editCell, apiAction, columnOptions, allowColumnUpdating, columnsToAdd, customValidationRules) {
    if (!fieldsToExport) {
        fieldsToExport = Helpers.Strings.GetStringBetweenBrackets(inputValue);

        if (fieldsToExport && (fieldsToExport.length === 1)) {
            fieldsToExport = null;
        }
    }

    let isRequiredFunction = (typeof required === 'function');
    let isParametersFunction = (typeof parameters === 'function');

    function CreateSearchComponent(mode, options, container) {
        var componentName = 'search-list-input-component';
        var allowUpdating = true;
        var searchId = Helpers.Guid.GenerateRandomIfNotHasValue(options.data[primaryKeyName]);

        $scope.Options[searchId] = options;

        if ((allowColumnUpdating !== undefined) && (allowColumnUpdating !== null)) {
            if (typeof allowColumnUpdating === 'function') {
                allowUpdating = allowColumnUpdating(options);
            } else {
                allowUpdating = allowColumnUpdating;
            }
        } else if ($scope.AllowUpdating) {
            allowUpdating = $scope.AllowUpdating(options);
        }

        if (mode === 'form') {
            $scope.Options[searchId].UpdateRowFunction = function (objectValue, id) {
                var formInstance = $(container).closest(".dx-form").dxForm("instance");

                formInstance.updateData(objectName, objectValue);
                formInstance.updateData(guidName, id);

                formInstance.repaint();
            };
        }

        apiAction = apiAction || "";
        columnsToAdd = columnsToAdd || "";

        var htmlElement = "";
        var classesToAdd = "";
        var classesForSearch = "";

        var eyeIconData = $scope.Options[searchId].data;
        var eyeIcon = GetSearchEyeIcon(controller, guidName, eyeIconData);

        if (eyeIcon) {
            htmlElement = eyeIcon.htmlElement;
            classesToAdd = eyeIcon.classesToAdd;
            classesForSearch = eyeIcon.classesForSearch;
        } else {
            classesForSearch = "SearchInputContainer";
        }

        let requiredValue, parametersToSend;

        if (isRequiredFunction) {
            requiredValue = required(options);
        } else {
            requiredValue = required;
        }

        if (isParametersFunction) {
            parametersToSend = parameters(options);
        }
        else {
            parametersToSend = parameters;
        }

        htmlElement += '<' + componentName + ' class="' + classesToAdd + '" required="' + requiredValue + '" object-to-update="' + objectName + '" object-id-to-update="' + guidName + '" options="Options[\'' + searchId + '\']" input-value="' + inputValue + '" controller="' + controller + '" parameters="' + parametersToSend + '" component-dependencies="' + componentDependencies + '" edit-cell="' + editCell + '" api-action="' + apiAction + '" check-if-is-disabled="' + !allowUpdating + '" columns-to-add="' + columnsToAdd + '" ></' + componentName + '>';
        var htmlElementCompiled = $compile(htmlElement)($scope);
        var wrapperTag = (mode === 'form') ? 'div' : 'a';

        $('<' + wrapperTag + '/>', {
            html: htmlElementCompiled,
            class: classesForSearch
        }).appendTo(container);
    }

    var columnForGuid = {
        dataField: guidName,
        caption: caption,
        allowEditing: false,
        allowExporting: !fieldsToExport,
        dataType: 'string',
        validationGroup: 'BaseGroup',
        minWidth: 180,
        editCellTemplate: function (container, options) {
            $("<div>").dxTextBox({
                value: options.value,
                visible: false,
                onValueChanged: function (e) {
                    if (options.setValue) {
                        options.setValue(e.value);
                    }
                }
            }).appendTo(container);

            CreateSearchComponent('form', options, container);
        },
        cellTemplate: function (container, options) {
            CreateSearchComponent('grid', options, container);
        },
        calculateCellValue: function (rowData) {
            let cellValue = Helpers.DevExtreme.CalculateCellValueForSearchColumn(rowData, objectName, inputValue);

            return cellValue;
        },
        calculateFilterExpression: function (filterValue, operation) {
            return Helpers.DevExtreme.CalculateFilterExpression(filterValue, operation, objectName, inputValue);
        },
        AllowEditInForm: true,
        AllowAddInForm: true
    };

    columnForGuid.validationRules = [];

    if (isRequiredFunction) {
        columnForGuid.validationRules.push({
            type: "custom",
            validationCallback: function (options) {
                if (options.data[guidName]) {
                    return true;
                }

                let requiredValue = !required(options);

                return requiredValue;
            }
        });
    } else {
        if (required) {
            columnForGuid.validationRules.push(Helpers.DevExtreme.CreateRequiredValidation());
        } else {
            columnForGuid.allowHiding = true;
        }
    }

    if (customValidationRules) {
        customValidationRules.forEach(customValidationRule =>
            columnForGuid.validationRules.push(customValidationRule)
        );
    }

    if (columnOptions) {
        for (var key in columnOptions) {
            var columnOption = columnOptions[key];

            columnForGuid[key] = columnOption;
        }
    }

    var columnForObject = {
        dataField: objectName,
        dataType: 'string',
        visible: false,
        allowFiltering: false,
        allowSearch: false,
        allowSorting: false,
        formItem: {
            visible: false
        }
    };

    var columns = [
        columnForGuid,
        columnForObject
    ];

    if (fieldsToExport) {
        var columnToExport = {
            dataFieldToExport: guidName,
            dataType: 'string',
            caption: caption,
            visible: false,
            forceExporting: true,
            columns: [],
            formItem: {
                visible: false
            }
        };

        if (columnOptions) {
            if (columnOptions.allowFiltering !== undefined) {
                columnToExport.allowFiltering = columnOptions.allowFiltering;
            }

            if (columnOptions.allowSearch !== undefined) {
                columnToExport.allowSearch = columnOptions.allowSearch;
            }

            if (columnOptions.allowSorting !== undefined) {
                columnToExport.allowSorting = columnOptions.allowSorting;
            }
        }

        columnToExport.columns = fieldsToExport.map(map => {
            var columnExport = {
                dataField: objectName + "." + (map.dataField || map),
                dataType: 'string',
                caption: map.caption,
                formItem: {
                    visible: false
                }
            };

            if (columnOptions) {
                if (columnOptions.allowFiltering !== undefined) {
                    columnExport.allowFiltering = columnOptions.allowFiltering;
                }

                if (columnOptions.allowSearch !== undefined) {
                    columnExport.allowSearch = columnOptions.allowSearch;
                }

                if (columnOptions.allowSorting !== undefined) {
                    columnExport.allowSorting = columnOptions.allowSorting;
                }
            }

            return columnExport;
        });

        columns.push(columnToExport);
    }

    return columns;
}

Helpers.DevExtreme.CreateTextColumnWithLink = function ($scope, $compile, guidName, dataField, caption, inputValue, pageToGo, columnPropertiesToAdd) {
    pageToGo = pageToGo || dataField;
    let parts = dataField.split('.');

    let textColumnWithLink = {
        dataField: dataField,
        dataType: "string",
        caption: caption,
        allowHiding: true,
        calculateCellValue: function (rowData) {
            if (parts.length === 1) {
                return;
            }

            let cellValue = Helpers.DevExtreme.CalculateCellValueForSearchColumn(rowData, dataField, inputValue);

            return cellValue;
        },
        calculateFilterExpression: function (filterValue, operation) {
            if (parts.length === 1) {
                return;
            }

            return Helpers.DevExtreme.CalculateFilterExpression(filterValue, operation, dataField, inputValue);
        },
        cellTemplate: function (container, options) {
            if (!options.value) {
                return;
            }

            let htmlElement = '<div class="DisplayFlexRow">';
            let id = null;

            if (guidName && options.data) {
                let parts = guidName.split('.');
                let current = options.data;

                for (let i = 0; i < parts.length; i++) {
                    if (current == null) {
                        break;
                    }

                    current = current[parts[i]];
                }

                id = current;
            }

            if (Helpers.Guid.HasValue(id) && myApplication.Routing.states.includes(pageToGo)) {
                let parametersForPage = { id: id };

                htmlElement = '<span><a class="lnr lnr-eye" ng-click=\'GoToPage("' + pageToGo + '", ' + JSON.stringify(parametersForPage) + ', false, $event, true)\'><span class="DevExtremeFont"> ' + options.value + '</span></a></span>';
            } else {
                htmlElement = '<span><span class="DevExtremeFont">' + options.value + '</span></span></div>';
            }

            var htmlElementCompiled = $compile(htmlElement)($scope);

            htmlElementCompiled.appendTo(container);
        }
    };

    if (parts.length === 1) {
        delete textColumnWithLink.calculateCellValue;
        delete textColumnWithLink.calculateFilterExpression;
    }

    Helpers.Object.SetObjectProperties(textColumnWithLink, columnPropertiesToAdd);

    return textColumnWithLink;
}

Helpers.DevExtreme.CreateBooleanColumn = function (fieldName, caption, calculateCellValue, columnPropertiesToAdd, trueText, falseText) {
    trueText = trueText || Helpers.Translations.Yes;
    falseText = falseText || Helpers.Translations.No;

    var columnForBoolean = {
        caption: caption,
        dataField: fieldName,
        dataType: 'boolean',
        validationGroup: 'BaseGroup',
        trueText: trueText,
        falseText: falseText,
        showEditorAlways: false,
        allowHiding: true,
        headerFilter: {
            dataSource: [
                { text: trueText, value: true },
                { text: falseText, value: false },
            ]
        },
        calculateCellValue: function (rowData) {
            if (rowData[fieldName] || Helpers.Object.GetPropertyByPath(rowData, fieldName)) {
                return true;
            }

            return false;
        },
        AllowEditInForm: true,
        AllowAddInForm: true,
        formItem: {
            editorOptions: {
                switchedOnText: trueText,
                switchedOffText: falseText
            },
            editorType: 'dxSwitch'
        }
    };

    Helpers.Object.SetObjectProperties(columnForBoolean, columnPropertiesToAdd);

    if (calculateCellValue) {
        columnForBoolean.calculateCellValue = calculateCellValue;
    }

    return columnForBoolean;
}

function SetTranslationsCellTemplate(fieldName, columnPropertiesToAdd, caption, translationComponentElement) {
    if (!columnPropertiesToAdd || !columnPropertiesToAdd.TranslationsObject) {
        return;
    }

    let translationsObj = columnPropertiesToAdd.TranslationsObject;

    delete columnPropertiesToAdd.TranslationsObject;

    return function (container, options) {
        let showWindowVarName = 'ShowTranslationUserFieldsWindow_' + fieldName;
        let registerIdVarName = 'translationRegisterId_' + fieldName;
        let registerNameVarName = 'translationRegisterName_' + fieldName;
        let registerDiscriminatorVarName = 'translationRegisterDiscriminator_' + fieldName;
        let fieldVarName = 'translationField_' + fieldName;
        let captionVarName = 'translationCaption_' + fieldName;

        let wrapper = $('<div>').css('display', 'flex').css('align-items', 'center');

        if (!options.removed && !options.row.isNewRow && !options.row.modified) {
            let iconSpan = $('<span>')
                .addClass('far fa-solid fa-globe fa-xs MarginRight5 MarginLeft5 CursorPointer')
                .on('click', function (e) {
                    e.stopPropagation();

                    let scope = angular.element(container).scope();
                    let $injector = angular.element(container).injector();
                    let $ocLazyLoad = $injector.get('$ocLazyLoad');
                    let $q = $injector.get('$q');
                    let $compile = $injector.get('$compile');

                    $q.when($ocLazyLoad.load({
                        files: RoutingDependencies.translationUserFieldsDependencies,
                        serie: true
                    })).then(function () {
                        scope[showWindowVarName] = { value: true };
                        scope[registerIdVarName] = options.data[translationsObj.RegisterId];
                        scope[registerNameVarName] = translationsObj.RegisterName;

                        if (translationsObj.RegisterDiscriminator instanceof Function) {
                            scope[registerDiscriminatorVarName] = translationsObj.RegisterDiscriminator(options);
                        } else {
                            scope[registerDiscriminatorVarName] = translationsObj.RegisterDiscriminator;
                        }

                        scope[fieldVarName] = options.text;
                        scope[captionVarName] = caption;

                        if (!translationComponentElement) {
                            let componentHtml = '<translation-user-field-component ' +
                                'ng-if="' + showWindowVarName + '.value" ' +
                                'register-id="' + registerIdVarName + '" ' +
                                'register-name="' + registerNameVarName + '" ' +
                                'register-discriminator="' + registerDiscriminatorVarName + '" ' +
                                'field="' + fieldVarName + '" ' +
                                'caption="' + captionVarName + '" ' +
                                'close-dialog="' + showWindowVarName + '">' +
                                '</translation-user-field-component>';

                            translationComponentElement = $compile(componentHtml)(scope);
                            angular.element(document.body).append(translationComponentElement);
                        }
                    }).catch(function (exception) {
                        scope.HandleResultException(exception);
                    });
                });

            wrapper.append(iconSpan);
        }

        let textSpan = $('<span>').text(options.value || '');

        wrapper.append(textSpan);
        container.append(wrapper);
    };
}

Helpers.DevExtreme.CreateTextColumn = function (fieldName, caption, required, maximumLength, calculateCellValue, cellTemplate, validationRules, columnPropertiesToAdd) {
    var validationRulesToApply = validationRules || [];

    var columnForTextField = {
        caption: caption,
        dataField: fieldName,
        dataType: 'string',
        validationGroup: 'BaseGroup',
        filterOperations: [Helpers.DevExtreme.Filters.Contains, Helpers.DevExtreme.Filters.NotContains, Helpers.DevExtreme.Filters.StartsWith, Helpers.DevExtreme.Filters.EndsWith, Helpers.DevExtreme.Filters.Equal, Helpers.DevExtreme.Filters.Different, Helpers.DevExtreme.Filters.Between],
        calculateFilterExpression: function (value, selectedFilterOperations, target) {
            if ((selectedFilterOperations === Helpers.DevExtreme.Filters.Between) && Array.isArray(value) && (value.length === 2)) {
                return [
                    [this.dataField, Helpers.DevExtreme.Filters.GreaterThanOrEqualTo, value[0]],
                    Helpers.DevExtreme.Filters.And,
                    [this.dataField, Helpers.DevExtreme.Filters.SmallerThanOrEqualTo, value[1]]
                ];
            }

            let filterExpression = this.defaultCalculateFilterExpression(value, selectedFilterOperations, target);

            return filterExpression;
        },
        AllowEditInForm: true,
        AllowAddInForm: true
    };

    var translationComponentElement = { translationComponentCreated: null };

    columnForTextField.cellTemplate = SetTranslationsCellTemplate(fieldName, columnPropertiesToAdd, caption, translationComponentElement.translationComponentCreated);

    Helpers.Object.SetObjectProperties(columnForTextField, columnPropertiesToAdd);

    if (calculateCellValue) {
        columnForTextField.calculateCellValue = calculateCellValue;
    }

    if (cellTemplate) {
        columnForTextField.cellTemplate = cellTemplate;
    }

    if (required) {
        validationRulesToApply.push(Helpers.DevExtreme.CreateRequiredValidation());
    } else {
        columnForTextField.allowHiding = true;
    }

    if (maximumLength) {
        validationRulesToApply.push(Helpers.DevExtreme.CreateStringLenghtMaxValidation(maximumLength));
    }

    if (validationRulesToApply.length) {
        columnForTextField.validationRules = validationRulesToApply;
    }

    return columnForTextField;
}

Helpers.DevExtreme.CreateMultilineColumn = function (fieldName, caption, required, maximumLength, columnPropertiesToAdd) {
    let validationRulesToApply = [];

    let column = {
        caption: caption,
        dataField: fieldName,
        dataType: 'string',
        validationGroup: 'BaseGroup',
        editorType: 'dxTextArea',
        editorOptions: {
            autoResizeEnabled: true
        },
        formItem: {
            colSpan: 2
        },
        filterOperations: [Helpers.DevExtreme.Filters.Contains, Helpers.DevExtreme.Filters.NotContains, Helpers.DevExtreme.Filters.StartsWith, Helpers.DevExtreme.Filters.EndsWith, Helpers.DevExtreme.Filters.Equal, Helpers.DevExtreme.Filters.Different, Helpers.DevExtreme.Filters.Between],
        calculateFilterExpression: function (value, selectedFilterOperations, target) {
            if ((selectedFilterOperations === Helpers.DevExtreme.Filters.Between) && Array.isArray(value) && (value.length === 2)) {
                return [
                    [this.dataField, Helpers.DevExtreme.Filters.GreaterThanOrEqualTo, value[0]],
                    Helpers.DevExtreme.Filters.And,
                    [this.dataField, Helpers.DevExtreme.Filters.SmallerThanOrEqualTo, value[1]]
                ];
            }

            let filterExpression = this.defaultCalculateFilterExpression(value, selectedFilterOperations, target);

            return filterExpression;
        },
        cellTemplate: function (container, options) {
            let text = options.value ? options.value.replace(/\n/g, '<br/>') : '';

            container.html(text).css({ 'white-space': 'normal', 'word-wrap': 'break-word' });
        },
        AllowEditInForm: true,
        AllowAddInForm: true
    };

    Helpers.Object.SetObjectProperties(column, columnPropertiesToAdd);

    if (required) {
        validationRulesToApply.push(Helpers.DevExtreme.CreateRequiredValidation());
    }

    if (maximumLength) {
        validationRulesToApply.push(Helpers.DevExtreme.CreateStringLenghtMaxValidation(maximumLength));
    }

    if (validationRulesToApply.length) {
        column.validationRules = validationRulesToApply;
    }

    return column;
};

Helpers.DevExtreme.CreatePasswordColumn = function (fieldName, caption, required, maximumLength, isReadOnly) {
    let validationRules = [];

    let columnForPasswordField = {
        caption: caption,
        dataField: fieldName,
        validationGroup: 'BaseGroup',
        editorOptions: {
            mode: "password"
        },
        customizeText: function (e) {
            if (!e.value) {
                return;
            }

            return '***************';
        }
    }

    if (isReadOnly) {
        columnForPasswordField.allowEditing = false;
    }

    if (required) {
        validationRules.push(Helpers.DevExtreme.CreateRequiredValidation());
    }

    if (maximumLength) {
        validationRules.push(Helpers.DevExtreme.CreateStringLenghtMaxValidation(maximumLength));
    }

    if (validationRules.length) {
        columnForPasswordField.validationRules = validationRules;
    }

    return columnForPasswordField;
}

Helpers.DevExtreme.CreateFloatColumn = function (fieldName, caption, minimumValue, maximumValue, decimalPlaces, format, calculateCellValue, required, validationRules, columnPropertiesToAdd) {
    let validationRulesToApply = validationRules || [];
    let formatToApply = format;

    if (!formatToApply) {
        formatToApply = Helpers.DevExtreme.FormatDecimal(decimalPlaces);
    }

    let columnForFloatField = {
        caption: caption,
        dataField: fieldName,
        dataType: 'number',
        validationGroup: 'BaseGroup',
        format: formatToApply,
        formItem: {
            editorOptions: {
                format: formatToApply,
                width: 150,
                inputAttr: {
                    style: 'text-align: right; padding-right: 5px;'
                }
            }
        },
        AllowEditInForm: true,
        AllowAddInForm: true
    };

    Helpers.Object.SetObjectProperties(columnForFloatField, columnPropertiesToAdd);

    if (calculateCellValue) {
        if (typeof calculateCellValue !== 'function') {
            throw new Error("Invalid calculateCellValue function in column '" + caption + "'.");
        }

        columnForFloatField.calculateCellValue = calculateCellValue;
    }

    if (columnForFloatField.allowEditing) {
        if ((minimumValue != null) && (maximumValue != null)) {
            validationRulesToApply.push(Helpers.DevExtreme.CreateNumericRangeMinAndMaxValidation(minimumValue, maximumValue));
        } else if (minimumValue != null) {
            validationRulesToApply.push(Helpers.DevExtreme.CreateNumericRangeMinValidation(minimumValue));
        } else if (maximumValue != null) {
            validationRulesToApply.push(Helpers.DevExtreme.CreateNumericRangeMaxValidation(maximumValue));
        }
    }

    if (required) {
        validationRulesToApply.push(Helpers.DevExtreme.CreateRequiredValidation());
    } else {
        columnForFloatField.allowHiding = true;
    }

    columnForFloatField.validationRules = validationRulesToApply;

    return columnForFloatField;
}

Helpers.DevExtreme.CreateIntColumn = function (fieldName, caption, minimumValue, maximumValue, calculateCellValue, validationRules, columnPropertiesToAdd) {
    let validationRulesToApply = validationRules || [];

    var columnForIntField = {
        caption: caption,
        dataField: fieldName,
        dataType: 'number',
        validationGroup: 'BaseGroup',
        format: Helpers.DevExtreme.FormatInteger(),
        formItem: {
            editorOptions: {
                format: Helpers.DevExtreme.FormatInteger(),
                width: 150,
                inputAttr: {
                    style: 'text-align: right; padding-right: 5px;'
                }
            }
        },
        AllowEditInForm: true,
        AllowAddInForm: true
    };

    Helpers.Object.SetObjectProperties(columnForIntField, columnPropertiesToAdd)

    if (calculateCellValue) {
        columnForIntField.calculateCellValue = calculateCellValue;
    }

    if (columnForIntField.allowEditing) {
        if ((minimumValue != null) && (maximumValue != null)) {
            validationRulesToApply.push(Helpers.DevExtreme.CreateNumericRangeMinAndMaxValidation(minimumValue, maximumValue));
        } else if (minimumValue != null) {
            validationRulesToApply.push(Helpers.DevExtreme.CreateNumericRangeMinValidation(minimumValue));
        } else if (maximumValue != null) {
            validationRulesToApply.push(Helpers.DevExtreme.CreateNumericRangeMaxValidation(maximumValue));
        }
    } else {
        columnForIntField.allowHiding = true;
    }

    columnForIntField.validationRules = validationRulesToApply;

    return columnForIntField;
}

Helpers.DevExtreme.CreatePercentColumn = function (fieldName, caption, minimumValue, maximumValue, precision, calculateCellValue, columnPropertiesToAdd) {
    var columnForPercentField = {
        caption: caption,
        dataField: fieldName,
        dataType: 'number',
        format: Helpers.DevExtreme.FormatPercent()
    };

    Helpers.Object.SetObjectProperties(columnForPercentField, columnPropertiesToAdd);

    if (columnForPercentField.allowEditing) {
        columnForPercentField.formItem = {
            editorOptions: {
                format: Helpers.DevExtreme.FormatPercent(precision),
                width: 150,
                inputAttr: {
                    style: 'text-align: right; padding-right: 5px;'
                }
            }
        };
    }

    if (columnForPercentField.allowEditing) {
        if ((minimumValue != null) && (maximumValue != null)) {
            columnForPercentField.validationRules = [Helpers.DevExtreme.CreateNumericRangeMinAndMaxValidation(minimumValue, maximumValue)];
        } else if (minimumValue != null) {
            columnForPercentField.validationRules = [Helpers.DevExtreme.CreateNumericRangeMinValidation(minimumValue)];
        } else if (maximumValue != null) {
            columnForPercentField.validationRules = [Helpers.DevExtreme.CreateNumericRangeMaxValidation(maximumValue)];
        }
    } else {
        columnForPercentField.allowHiding = true;
    }

    if (calculateCellValue) {
        columnForPercentField.calculateCellValue = calculateCellValue;
    }

    return columnForPercentField;
}

Helpers.DevExtreme.CreateDateColumn = function (fieldName, caption, format, required, dataType, validationRules, columnPropertiesToAdd, minimumValue, maximumValue) {
    let validationRulesToApply = validationRules || [];
    let formatToApply = format || myApplication.dateTimeFormatToDisplay;
    let dataTypeToApply = dataType || 'date';

    let columnForDateField = {
        caption: caption,
        dataField: fieldName,
        dataType: dataTypeToApply,
        alignment: 'center',
        format: formatToApply,
        AllowEditInForm: true,
        AllowAddInForm: true
    };

    if (minimumValue || maximumValue) {
        columnForDateField.editorOptions = {
            min: minimumValue,
            max: maximumValue,
            displayFormat: formatToApply
        }
    }

    Helpers.Object.SetObjectProperties(columnForDateField, columnPropertiesToAdd);

    if (columnForDateField.allowEditing && required) {
        validationRulesToApply.push([Helpers.DevExtreme.CreateRequiredValidation()]);
    } else {
        columnForDateField.allowHiding = true;
    }

    if (validationRulesToApply.length) {
        columnForDateField.validationRules = validationRulesToApply;
    }

    return columnForDateField;
}

Helpers.DevExtreme.CreateTimeColumn = function (fieldName, caption, format, required, isReadOnly, validationRules, columnPropertiesToAdd) {
    let formatToApply = format || myApplication.timeFormat;

    let columnForTimeField = {
        caption: caption,
        dataField: fieldName,
        dataType: 'datetime',
        format: formatToApply,
        alignment: 'center',
        editorOptions: {
            type: 'time',
            displayFormat: formatToApply,
            dateSerializationFormat: formatToApply
        }
    }

    Helpers.Object.SetObjectProperties(columnForTimeField, columnPropertiesToAdd);

    if (required) {
        columnForTimeField.validationRules = [Helpers.DevExtreme.CreateRequiredValidation()];
    } else {
        columnForTimeField.allowHiding = true;
    }

    if (validationRules) {
        if (columnForTimeField.validationRules) {
            columnForTimeField.validationRules = columnForTimeField.validationRules.concat(validationRules);
        }
        else {
            columnForTimeField.validationRules = validationRules;
        }
    }

    if (isReadOnly) {
        columnForTimeField.allowEditing = false;
        columnForTimeField.editorOptions.disabled = true;
    }

    return columnForTimeField;
}

Helpers.DevExtreme.CreateTimeSpanColumn = function (fieldName, caption, columnPropertiesToAdd, multiDayDuration, propertyToUpdate, minimumValue, maximumValue, withoutDays) {
    let withDays = multiDayDuration && !withoutDays;
    let dataTypeToApply = multiDayDuration ? 'string' : 'datetime';
    let formatToApply = multiDayDuration ? null : myApplication.timeFormat;
    let filterOperationsToApply = multiDayDuration ? ["contains", "=", "<>", "<", ">", "<=", ">="] : ["=", "<>", "<", ">", "<=", ">=", "between"];

    let editorOptionsToApply = multiDayDuration ? (withDays ? {
        mask: Helpers.DevExtreme.TimeSpanWithDaysMask(),
        maskRules: Helpers.DevExtreme.TimeSpanWithDaysMaskRules()
    } : {
        mask: Helpers.DevExtreme.TimeSpanWithMultiDayDuration(),
        maskRules: Helpers.DevExtreme.TimeSpanWithMultiDayDurationMaskRules()
    }) : {
        type: 'time',
        displayFormat: myApplication.timeFormat,
        dateSerializationFormat: myApplication.timeFormat
    }
    let minimumSeconds = minimumValue ? Helpers.Date.TimeToTotalSeconds(minimumValue) : null;
    let maximumSeconds = maximumValue ? Helpers.Date.TimeToTotalSeconds(maximumValue) : null;

    function GetValueInTimeSpanWithDays(value) {
        let timeSpanWithDays = value.padStart(8, '0');
        let days = timeSpanWithDays.substring(0, 2);
        let hours = timeSpanWithDays.substring(2, 4);
        let minutes = timeSpanWithDays.substring(4, 6);
        let seconds = timeSpanWithDays.substring(6, 8);

        timeSpanWithDays = `${days}.${hours}:${minutes}:${seconds}`;

        return timeSpanWithDays;
    }

    function GetValueInTimeSpanWithMultiDayDuration(value) {
        let timeSpanMultiDay = value.padStart(7, '0');
        let hours = timeSpanMultiDay.substring(0, 3);
        let minutes = timeSpanMultiDay.substring(3, 5);
        let seconds = timeSpanMultiDay.substring(5, 7);

        timeSpanMultiDay = `${hours}:${minutes}:${seconds}`;

        return timeSpanMultiDay;
    }

    let columnForTimeSpanField = {
        dataField: fieldName,
        caption: caption,
        dataType: dataTypeToApply,
        format: formatToApply,
        alignment: "center",
        allowEditing: (minimumValue != null) || (maximumValue != null),
        editorOptions: editorOptionsToApply,
        calculateCellValue: function (rowData) {
            let timeInSeconds = Helpers.Date.DateToSeconds(rowData[fieldName]);
            let time;

            if (withDays) {
                time = Helpers.Date.FormatSecondsToTimeSpanString(timeInSeconds, withDays);
            } else if (multiDayDuration) {
                time = Helpers.Date.FormatSecondsToTimeSpanString(timeInSeconds, null, null, null, true);
                time = ('00' + time).slice(-9);
            } else {
                time = new Date(1970, 0, 1);
                time.setSeconds(timeInSeconds);
            }

            return time;
        },
        setCellValue: function (newData, value) {
            if (withDays) {
                value = GetValueInTimeSpanWithDays(value);
            } else if (multiDayDuration) {
                value = GetValueInTimeSpanWithMultiDayDuration(value);
            }

            newData[fieldName] = value;

            if (propertyToUpdate) {
                newData[propertyToUpdate] = Helpers.TimeOperations.GetHoursFromTimeSpanWithDays(value);
            }
        },
        filterOperations: filterOperationsToApply,
        calculateFilterExpression: function (value, selectedFilterOperations, target) {
            if ((target !== 'filterRow') && !withDays && (selectedFilterOperations !== "between")) {
                let filterExpression = this.defaultCalculateFilterExpression(value, selectedFilterOperations, target);

                return filterExpression;
            }

            let currentValueInSeconds = function (data) {
                let timeInSeconds = Helpers.Date.DateToSeconds(data[fieldName]);

                return timeInSeconds;
            }

            if (selectedFilterOperations === "between") {
                let firstValueInSeconds = Helpers.Date.DateToSeconds(value[0]);
                let secondValueInSeconds = Helpers.Date.DateToSeconds(value[1]);

                return [[[currentValueInSeconds, "<", firstValueInSeconds], [currentValueInSeconds, ">", secondValueInSeconds]], "or", [[currentValueInSeconds, "<", secondValueInSeconds], [currentValueInSeconds, ">", firstValueInSeconds]]]
            }

            if (withDays) {
                value = GetValueInTimeSpanWithDays(value);
            } else if (multiDayDuration) {
                value = GetValueInTimeSpanWithMultiDayDuration(value);
            }

            let valueInSeconds = Helpers.Date.DateToSeconds(value);

            return [[currentValueInSeconds, selectedFilterOperations, valueInSeconds]];
        },
        validationRules: []
    };

    if (!withDays && !multiDayDuration) {
        columnForTimeSpanField.headerFilter = {
            dataSource(data) {
                data.dataSource.postProcess = function (results) {
                    var newResults = [];

                    if (results) {
                        newResults = results[0].items[0].items[0].items;
                    }

                    return newResults;
                };
            },
        }
    }

    if (minimumValue || maximumSeconds) {
        let minAndMaxTimeValidationRules = {
            type: 'custom',
            validationCallback: function (e) {
                var seconds = Helpers.Date.TimeToTotalSeconds(e.data.Time);

                if ((minimumSeconds != null) && (seconds < minimumSeconds)) {
                    return false;
                }

                if ((maximumSeconds != null) && (seconds > maximumSeconds)) {
                    return false;
                }

                return true;
            },
            message: Helpers.Translation.GetText('InvalidTimeSpan')
        };

        columnForTimeSpanField.validationRules.push(minAndMaxTimeValidationRules);
    }

    Helpers.Object.SetObjectProperties(columnForTimeSpanField, columnPropertiesToAdd);

    return columnForTimeSpanField;
};

Helpers.DevExtreme.CreateLinkColumn = function (fieldName, caption, objectName, id, propertyValue, page, state, sortOrder, dataType, textToShow) {
    if (dataType == null) {
        dataType = 'string';
    }

    var columnForLink = {
        caption: caption,
        dataField: fieldName,
        dataType: dataType,
        sortOrder: sortOrder,
        cellTemplate: function (container, options) {
            if (objectName != null) {
                if (options.data[objectName]) {
                    var text = textToShow || options.data[objectName][propertyValue];

                    var textElement = angular.element('<span>')
                        .addClass('DevExtremeFont')
                        .text(' ' + text);

                    var template = angular.element('<a>')
                        .on('dxclick', function (e) {
                            if (e.ctrlKey || e.shiftKey) {
                                var url = state.href(page, { id: options.data[objectName][id] });

                                if (e.ctrlKey) {
                                    Helpers.Page.OpenInNewTab(url);
                                }
                                else {
                                    Helpers.Page.OpenInNewPage(url);
                                }

                                return;
                            }

                            state.go(page, { id: options.data[objectName][id] });
                        })
                        .appendTo(container);

                    angular.element('<span>')
                        .addClass('lnr lnr-eye')
                        .appendTo(template);

                    textElement.appendTo(template);
                }
            } else {
                var text = textToShow || options.data[propertyValue];

                var textElement = angular.element('<span>')
                    .addClass('DevExtremeFont')
                    .text(' ' + text);

                var template = angular.element('<a>')
                    .on('dxclick', function (e) {
                        if (e.ctrlKey || e.shiftKey) {
                            var url = state.href(page, { id: options.data[id] });

                            if (e.ctrlKey) {
                                Helpers.Page.OpenInNewTab(url);
                            }
                            else {
                                Helpers.Page.OpenInNewPage(url);
                            }

                            return;
                        }

                        state.go(page, { id: options.data[id] });
                    })
                    .appendTo(container);

                angular.element('<span>')
                    .addClass('lnr lnr-eye')
                    .appendTo(template);

                textElement.appendTo(template);
            }
        }
    }

    return columnForLink;
}

Helpers.DevExtreme.CreateEnableDisableColumn = function (scope, gridName, isReadOnly, dataField, filterDisabled) {
    dataField = dataField || 'Disabled';

    let allowEditing = scope.FormUpdating;

    let columnForEnableDisable = {
        dataField: dataField,
        caption: Helpers.Translations.State,
        dataType: 'boolean',
        allowEditing: allowEditing,
        width: 105,
        trueText: Helpers.Translations.Disabled,
        falseText: Helpers.Translations.Enabled,
        headerFilter: {
            dataSource: [
                { text: Helpers.Translations.Disabled, value: true },
                { text: Helpers.Translations.Enabled, value: false },
            ]
        },
        filterType: filterDisabled ? "exclude" : null,
        filterValues: filterDisabled ? [true] : null,
        calculateCellValue: function (rowData) {
            const val = Helpers.Object.GetPropertyByPath(rowData, dataField);

            return !!val;
        },
        cellTemplate: function (container, options) {
            let allowUpdating = isReadOnly;

            if (!allowUpdating && scope.AllowUpdating) {
                allowUpdating = !scope.AllowUpdating(options);
            }

            if (scope.GenerateDisableEnableField) {
                scope.GenerateDisableEnableField(gridName, options.data, dataField, container, allowUpdating);
            }
            else {
                Helpers.DevExtreme.GenerateEnableDisableCellTemplate(scope, gridName, options, container, allowUpdating);
            }
        },
        calculateFilterExpression: function (value, selectedFilterOperation) {
            if ((selectedFilterOperation === "=") && dataField.includes(".")) {
                return function (rowData) {
                    const current = Helpers.Object.GetPropertyByPath(rowData, dataField);

                    return value === true ? current === true : current !== true;
                };
            }

            return this.defaultCalculateFilterExpression ? this.defaultCalculateFilterExpression(value, selectedFilterOperation) : null;
        },
        AllowEditInForm: true,
        AllowAddInForm: true,
        formItem: {
            editorOptions: {
                switchedOnText: Helpers.Translations.Disabled,
                switchedOffText: Helpers.Translations.Enabled,
                width: 90
            },
            editorType: 'dxSwitch'
        }
    }

    return columnForEnableDisable;
};

Helpers.DevExtreme.GenerateEnableDisableCellTemplate = function (scope, gridName, options, container, isReadOnly) {
    const isEnabled = !options.value;
    const disabledClass = isReadOnly ? 'Disabled' : '';

    const stateText = isEnabled ? Helpers.Translations.Enabled : Helpers.Translations.Disabled;
    const stateIcon = isEnabled ? 'lnr-checkmark-circle' : 'lnr-cross-circle';
    const stateStyle = isEnabled ? '' : 'style="color:red;"';
    const attrDisabled = isEnabled ? '' : 'disabled';

    const htmlContent = `<span class="pull-left ${disabledClass}" ${attrDisabled} ${stateStyle}>${stateText}</span><i class="lnr ${stateIcon}"></i>`;

    const linkElement = angular.element('<a>').addClass(disabledClass).html(htmlContent);

    if (isReadOnly) {
        linkElement.appendTo(container);

        return;
    }

    const clickHandler = scope.EnableDisableClickFunction ? scope.EnableDisableClickFunction(gridName, options.value, options.data) : Helpers.DevExtreme.GenerateEnableDisableFunction(gridName, options.value);

    linkElement.on('dxclick', clickHandler).appendTo(container);
};

Helpers.DevExtreme.GenerateEnableDisableFunction = function (gridName, disabled) {
    return function () {
        let index = Helpers.DevExtreme.FindRowIndex(this);

        if (angular.element(this).hasClass("LinkDisabled") || angular.element(this).parent().hasClass("Disabled")) {
            return;
        }

        Helpers.DevExtreme.DisableCell(index, gridName, (disabled ? false : true));

        let grid = Helpers.DevExtreme.GetGridInstance(gridName);

        if (typeof grid !== 'undefined') {
            grid.refresh();
        }
    };
};

Helpers.DevExtreme.CreateColorColumn = function (fieldName) {
    var column = {
        dataField: fieldName,
        width: '140px',
        showEditorAlways: true,
        alignment: 'center',
        editCellTemplate: function (cellElement, cellInfo) {
            if (cellInfo.rowType !== "data") {
                return;
            }

            var color = cellInfo.value;

            $('<input type="color" class="MarginTop4" value="' + color + '" />').change(function (event) {
                cellInfo.setValue(event.target.value);
            }
            ).appendTo(cellElement);
        }
    };

    return column;
}

Helpers.DevExtreme.CreateImageColumn = function (fieldName, caption, width, calculateCellValue, cellTemplate, $scope, $compile, $q, alwaysShowFallBackImage, imageClasses) {
    let cellValueToApply = calculateCellValue || Helpers.DevExtreme.CreateImageCellValue(alwaysShowFallBackImage);
    let cellTemplateToApply = cellTemplate || Helpers.DevExtreme.CreateImageCellTemplate($scope, $compile, $q, imageClasses);
    let widthToApply = width || 'auto';

    let column = {
        dataField: fieldName,
        dataType: 'string',
        caption: caption,
        width: widthToApply,
        isPicture: true,
        alignment: 'center',
        allowFiltering: false,
        allowGrouping: false,
        allowEditing: false,
        cellTemplate: cellTemplateToApply,
        calculateCellValue: cellValueToApply
    };

    return column;
}

Helpers.DevExtreme.CreateImageCellTemplate = function ($scope, $compile, $q, imageClasses) {
    if ($scope) {
        $scope.DataGridColumnImageUploadBox = Helpers.Upload.GetUploadBox('image/*', '1MB', true);
    }

    let cellTemplate = function (container, options) {
        let value = options.value;

        if (!value) {
            if (!$scope) {
                return;
            }
        }

        let caption = options.column.caption;
        let src = value ? value : ($scope ? 'Application/Images/FallBackImage.1781708645000.png' : null);

        let imageClassesToAdd = { width: '80px', height: 'auto', cursor: 'pointer' };

        if (imageClasses) {
            Object.assign(imageClassesToAdd, imageClasses);
        }

        $('<img>')
            .attr('src', src)
            .css(imageClassesToAdd)
            .on('click', function () {
                let popupContainer = $('<div>').appendTo('body');
                let popupInstance;

                popupContainer.dxPopup({
                    title: caption,
                    showCloseButton: true,
                    width: 'auto',
                    height: 'auto',
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    closeOnOutsideClick: true,
                    visible: true,
                    onInitialized: function (e) {
                        popupInstance = e.component;
                    },
                    onHidden: function () {
                        popupContainer.remove();

                        if ($scope) {
                            delete $scope.DataGridColumnFile;
                            delete $scope.DataGridColumnImageRemoveImage;
                            delete $scope.DataGridColumnImageInsertImage;
                        }
                    },
                    contentTemplate: function (contentElement) {
                        if (!$scope) {
                            return $('<img>')
                                .attr('src', value)
                                .css({
                                    width: '100%',
                                    maxHeight: '80vh',
                                    display: 'block',
                                    margin: '0 auto'
                                });
                        }

                        $scope.DataGridColumnFile = value;

                        $scope.DataGridColumnImageRemoveImage = function () {
                            let grid = options.component;
                            let index = options.rowIndex;

                            grid.cellValue(index, options.column.dataField, '');

                            if (popupInstance) {
                                popupInstance.hide();
                            }
                        }

                        $scope.DataGridColumnImageInsertImage = function () {
                            if (!$scope.DataGridColumnFile) {
                                return;
                            }

                            $q.when(Helpers.Upload.ConvertBlobImages($scope.DataGridColumnFile, 0, '')).then(function (result) {
                                let processedImage = Helpers.Upload.GetImageFromBase64(result.Image);

                                let grid = options.component;
                                let index = grid.getRowIndexByKey(options.key);

                                grid.cellValue(index, options.column.dataField, processedImage);
                            }).finally(function () {
                                if (popupInstance) {
                                    popupInstance.hide();
                                }
                            });
                        }

                        const wrapper = angular.element(`
                            <div style="text-align:center">
                            </div>
                        `);

                        const uploadBox = angular.element(`
                            <div ngf-select ngf-drop ng-model="DataGridColumnFile" 
                                    ngf-model-options="DataGridColumnImageUploadBox.Options"
                                    ngf-multiple="DataGridColumnImageUploadBox.Multiple" 
                                    ngf-pattern="DataGridColumnImageUploadBox.Pattern"
                                    ngf-accept="DataGridColumnImageUploadBox.Accept" 
                                    ngf-capture="DataGridColumnImageUploadBox.Capture"
                                    ngf-drag-over-class="DataGridColumnImageUploadBox.DragOverClass"
                                    ngf-validate="DataGridColumnImageUploadBox.Validate"
                                    ngf-resize="DataGridColumnImageUploadBox.Resize"
                                    ngf-resize-if="DataGridColumnImageUploadBox.ResizeIf"
                                    ngf-dimensions="DataGridColumnImageUploadBox.Dimensions"
                                    ngf-enable-firefox-paste="DataGridColumnImageUploadBox.FirefoxPaste"
                                    class="FileDropBox">

                                <span ng-hide="!DataGridColumnFile.$error && DataGridColumnFile">
                                    {{Helpers.Translations.AnnexesSelectOrDrag}}
                                </span>

                                <img ngf-src="!DataGridColumnFile.$error && DataGridColumnFile" />
                            </div>
                        `);

                        const buttonsContainer = angular.element(`
                            <div class="TextAlignCenter MarginTop10">
                                <button id="ButtonUploadImageRemove" 
                                        class="btn btn-danger MarginRight10"
                                        ng-click="DataGridColumnImageRemoveImage()">
                                    ${Helpers.Translations.Delete}
                                </button>

                                <button id="ButtonUploadSubmit" 
                                        class="btn btn-primary"
                                        ng-click="DataGridColumnImageInsertImage()">
                                    ${Helpers.Translations.Save}
                                </button>
                            </div>
                        `);

                        wrapper.append(uploadBox);
                        wrapper.append(buttonsContainer);

                        const compiled = $compile(wrapper)($scope);

                        contentElement.append(compiled);
                    }
                });
            }).appendTo(container);
    };

    return cellTemplate;
};


Helpers.DevExtreme.CreateImageCellValue = function (alwaysShowFallBackImage) {
    let calculateCellValue = function (rowData) {
        let value = rowData[this.dataField];

        if (!value) {
            if (!alwaysShowFallBackImage) {
                return;
            }

            return 'Application/Images/FallBackImage.1781708645000.png';
        }

        if (!value.startsWith('data:image/jpeg;base64,')) {
            value = 'data:image/jpeg;base64,' + value;
        }

        return value;
    }

    return calculateCellValue;
};

Helpers.DevExtreme.CreateEmailCellTemplate = function () {
    var cellTemplate = function (container, options) {
        if (options.text) {
            var textElement = $('<span>').addClass('IconSendEmail').appendTo(container);

            $('<span>').text(options.text).addClass('EmailText').appendTo(textElement);

            $('<i>').addClass('lnr lnr-envelope').addClass('EmailIcon').on('click', function (_e) {
                var rowData = options.text.trim();

                Helpers.EmailOperations.OpenWindowToSendEmail(rowData);
            }).appendTo(textElement);
        }
    };

    return cellTemplate;
}

Helpers.DevExtreme.CalculateCellValueForSearchColumn = function (data, objectName, inputValue) {
    let objectToUpdate = Helpers.DevExtreme.GetObjectForSearchColumn(data, objectName);

    if (!objectToUpdate) {
        return;
    }

    let objectFields = [];
    let fields = Helpers.Strings.GetStringBetweenBrackets(inputValue) || [];

    for (let i = 0; i < fields.length; i++) {
        let fieldName = fields[i];
        let fieldValue = Helpers.Object.GetValueInArraySplited(objectToUpdate, fieldName, '.');

        if (!Helpers.Object.IsUndefinedEmptyOrNull(fieldValue)) {
            objectFields.push(fieldValue);
        }
    }

    let cellValue;

    if (objectFields.length) {
        let inputValueConverted = Helpers.Strings.ConvertStringBetweenBracketsToNumbers(inputValue);

        cellValue = String.prototype.format.apply(inputValueConverted, objectFields);
    }

    return cellValue;
}

Helpers.DevExtreme.CalculateFilterExpression = function (filterValue, operation, objectName, inputValue) {
    let fields = Helpers.Strings.GetStringBetweenBrackets(inputValue) || [];
    let filterValues = Helpers.DevExtreme.GetSearchColumnFilterValues(filterValue, fields.length);
    let operationToConsider = operation || Helpers.DevExtreme.Filters.Contains;
    let mustNegateExpression = false;

    switch (operationToConsider) {
        case Helpers.DevExtreme.Filters.NotContains:
            operationToConsider = Helpers.DevExtreme.Filters.Contains;
            mustNegateExpression = true;

            break;

        case Helpers.DevExtreme.Filters.Different:
            operationToConsider = Helpers.DevExtreme.Filters.Equal;
            mustNegateExpression = true;

            break;
    }

    let expressions = Helpers.DevExtreme.CreateSearchColumnFilterExpressions(filterValues, operationToConsider, objectName, inputValue);
    let filterExpression = Helpers.DevExtreme.CombineSearchColumnFilterExpressions(expressions, Helpers.DevExtreme.Filters.Or);

    if (mustNegateExpression && filterExpression) {
        filterExpression = ['!', filterExpression];
    }

    return filterExpression;
}

Helpers.DevExtreme.CreateSearchColumnFilterExpressions = function (filterValues, operation, objectName, inputValue) {
    let fields = Helpers.Strings.GetStringBetweenBrackets(inputValue) || [];
    let expressions = [];

    if (!filterValues.length) {
        return expressions;
    }

    if (filterValues.length === 1) {
        for (let i = 0; i < fields.length; i++) {
            let fieldPath = objectName + '.' + fields[i];
            let expression = [fieldPath, operation, filterValues[0]];

            expressions.push(expression);
        }

        return expressions;
    }

    let maximumIndex = fields.length - filterValues.length;

    for (let index = 0; index <= maximumIndex; index++) {
        let currentExpressions = [];

        for (let i = 0; i < filterValues.length; i++) {
            let fieldPath = objectName + '.' + fields[index + i];
            let currentExpression = [fieldPath, operation, filterValues[i]];

            currentExpressions.push(currentExpression);
        }

        let combinedCurrentExpression = Helpers.DevExtreme.CombineSearchColumnFilterExpressions(currentExpressions, Helpers.DevExtreme.Filters.And);

        expressions.push(combinedCurrentExpression);
    }

    return expressions;
}

Helpers.DevExtreme.GetObjectForSearchColumn = function (data, objectName) {
    let objectToUpdate = data;
    let objectsToUpdate = objectName.split('.');

    for (let i = 0; i < objectsToUpdate.length; i++) {
        objectToUpdate = objectToUpdate[objectsToUpdate[i]];

        if (!objectToUpdate) {
            return;
        }
    }

    return objectToUpdate;
}

Helpers.DevExtreme.GetSearchColumnFilterValues = function (filterValue, maximumAmountOfFields) {
    let filterValueToConsider = filterValue || '';
    let filterValues = filterValueToConsider.split(/\s+-\s*|\s*-\s+/).map(map => map.trim()).filter(filter => filter);

    if (!filterValues.length && filterValueToConsider) {
        filterValues = [filterValueToConsider.trim()];
    }

    if (maximumAmountOfFields && (filterValues.length > maximumAmountOfFields)) {
        let simplifiedFilterValue = filterValues.join(' ').trim();

        filterValues = [simplifiedFilterValue];
    }

    return filterValues;
}

Helpers.DevExtreme.CombineSearchColumnFilterExpressions = function (expressions, operation) {
    if (!expressions || !expressions.length) {
        return null;
    }

    let combinedExpression = expressions[0];

    for (let i = 1; i < expressions.length; i++) {
        combinedExpression = [combinedExpression, operation, expressions[i]];
    }

    return combinedExpression;
}

Helpers.DevExtreme.Color = {
    GetPaletteColor: function (numberOfColors) {
        let palette = DevExpress.viz.generateColors('Material', numberOfColors, { baseColorSet: 'simpleSet' }).map(color => { return { color, arg: null } });

        return palette;
    },
    GetColorForChart: function (arg, palette) {
        let colorData = palette.find(find => (find.arg === arg));

        if (!colorData) {
            colorData = palette.find(find => !find.arg);
            colorData.arg = arg;
        }

        let colorForChart = { color: colorData.color };

        return colorForChart;
    }
}

//#region Scroll
Helpers.DevExtreme.Scroll = {};

Helpers.DevExtreme.Scroll.Horizontal = {
    direction: "horizontal",
    showScrollbar: "always"
};

Helpers.DevExtreme.Scroll.Vertical = {
    direction: "vertical",
    showScrollbar: "always"
};

Helpers.DevExtreme.Scroll.RefreshById = function (elementId) {
    try {
        let scrollViewInstance = $("#" + elementId).dxScrollView("instance");

        scrollViewInstance.refresh();
    } catch (_exception) { }
};

Helpers.DevExtreme.Scroll.Refresh = function (element) {
    try {
        angular.element(element).each(function () {
            var scrollViewInstance = angular.element(this).dxScrollView('instance');

            scrollViewInstance.update();
        })
    } catch (_exception) { }
};
//#endregion

//#region Validations
Helpers.DevExtreme.CreateRequiredValidation = function () {
    var validation = {
        type: 'required',
        message: Helpers.Translations.FieldRequired
    };

    return validation;
};

Helpers.DevExtreme.CreateStringLenghtMaxValidation = function (max) {
    var validation = {
        type: 'stringLength',
        trim: false,
        max: max,
        message: Helpers.Translation.GetText('StringLenghtMax', { max: max })
    };

    return validation;
};

Helpers.DevExtreme.CreateNumericRangeMinAndMaxValidation = function (min, max) {
    var validation = {
        type: 'range',
        min: min,
        max: max,
        message: Helpers.Translation.GetText('NumericRangeMinAndMax', { min: min, max: max })
    };

    return validation;
};

Helpers.DevExtreme.CreateNumericRangeMinValidation = function (min) {
    var validation = {
        type: 'range',
        min: min,
        message: Helpers.Translation.GetText('NumericRangeMin', { min: min })
    };

    return validation;
};

Helpers.DevExtreme.CreateNumericRangeMaxValidation = function (max) {
    var validation = {
        type: 'range',
        max: max,
        message: Helpers.Translation.GetText('NumericRangeMax', { max: max })
    };

    return validation;
};

Helpers.DevExtreme.CreatePortuguesePostalCodeValidation = function () {
    var validation = {
        type: 'pattern',
        pattern: /^\d{4}-\d{3}?$/,
        message: Helpers.Translations.PortuguesePostalCodeInvalidFormat
    }

    return validation;
};

Helpers.DevExtreme.CreateIntegerValidation = function () {
    var validation = {
        type: 'pattern',
        pattern: /^\d+$/,
        message: Helpers.Translations.NumericNoDecimalPlaces
    }

    return validation;
};

Helpers.DevExtreme.CreateDateRangeMinValidation = function (min, considerTime) {
    min = min || new Date();

    if (!considerTime) {
        min.setHours(0, 0, 0);
    }

    let validation = {
        type: 'range',
        min: min,
        message: Helpers.Translation.GetText('DateRangeMin', { min: min.toLocaleString() })
    };

    return validation;
};

Helpers.DevExtreme.CreateDateRangeMaxValidation = function (max, considerTime) {
    max = max || new Date();

    if (!considerTime) {
        max.setHours(23, 59, 59);
    }

    let validation = {
        type: 'range',
        max: max,
        message: Helpers.Translation.GetText('DateRangeMax', { max: max.toLocaleString() })
    };

    return validation;
};

Helpers.DevExtreme.CreateDateRangeMinAndMaxValidation = function (min, max, considerTime) {
    if (!considerTime) {
        min.setHours(0, 0, 0);
        max.setHours(23, 59, 59);
    }

    let validation = {
        type: 'range',
        min: min,
        max: max,
        message: Helpers.Translation.GetText('DateRangeMinAndMax', { min: min.toLocaleString(), max: max.toLocaleString() })
    };

    return validation;
};

Helpers.DevExtreme.CreateTimeSpanWithDaysValidation = function (withoutSeconds) {
    let message, pattern;

    if (withoutSeconds) {
        pattern = '^\\d{2}\\.(?:[01]?\\d|2[0-3]):[0-5]\\d$';
        message = Helpers.Translations.InvalidTimeSpanWithDaysWithoutSeconds;
    } else {
        pattern = '^\\d{2}\\.(?:[01]?\\d|2[0-3]):[0-5]\\d:[0-5]\\d$';
        message = Helpers.Translations.InvalidTimeSpanWithDays;
    }

    let validation = {
        type: 'pattern',
        pattern,
        message
    }

    return validation;
};

Helpers.DevExtreme.CreateTimeSpanWithMultiDayDurationValidation = function (withoutSeconds) {
    let message, pattern;

    if (withoutSeconds) {
        pattern = '^(?:\\d{1,3}):[0-5]\\d$';
        message = Helpers.Translations.InvalidTimeSpanWithoutSeconds;
    } else {
        pattern = '^(?:\\d{1,3}):[0-5]\\d:[0-5]\\d$';
        message = Helpers.Translations.InvalidTimeSpan;
    }

    let validation = {
        type: 'pattern',
        pattern,
        message
    }

    return validation;
};
//#endregion

//#region Formats
Helpers.DevExtreme.FormatCurrency = function (minimumFractionDigits) {
    if (!minimumFractionDigits) {
        minimumFractionDigits = 2;
    }

    var format = {
        currency: "EUR",
        minimumFractionDigits: minimumFractionDigits
    }

    return format;
};

Helpers.DevExtreme.FormatInteger = function () {
    var format = {
        type: "fixedPoint",
    }

    return format;
};

Helpers.DevExtreme.FormatDecimal = function (precision) {
    if (!precision) {
        precision = 2;
    }

    var format = {
        type: "fixedPoint",
        precision: precision
    }

    return format;
};

Helpers.DevExtreme.FormatIntegerToDxInput = "#,##0";

Helpers.DevExtreme.FormatPercentToDxInput = "#0.00%";

Helpers.DevExtreme.FormatTwoDecimalCasesToDxInput = "#0.00";

Helpers.DevExtreme.FormatThreeDecimalCasesToDxInput = "#0.000";

Helpers.DevExtreme.FormatFiveDecimalCasesToDxInput = "#0.00000";

Helpers.DevExtreme.FormatCurrencyTwoDecimalCasesToDxInput = "#,##0.00 €";

Helpers.DevExtreme.FormatCurrencyFiveDecimalCasesToDxInput = "#,##0.00000 €";

Helpers.DevExtreme.FormatPercent = function (precision) {
    if (!precision) {
        precision = 2;
    }

    var format = {
        type: "percent",
        precision: precision
    }

    return format;
};

Helpers.DevExtreme.PortuguesePostalCodeMask = function () {
    var portuguesePostalCodeMask = "0000-000";

    return portuguesePostalCodeMask;
};

Helpers.DevExtreme.ExtendedTimeMask = function (includeSeconds) {
    let extendedTimeMask = includeSeconds ? "000:N0:N0" : "000:N0";

    return extendedTimeMask;
};

Helpers.DevExtreme.ExtendedTimeMaskRules = function () {
    let rules = {
        N: ['0', '1', '2', '3', '4', '5']
    }

    return rules;
}

Helpers.DevExtreme.TimeSpanWithDaysMask = function (withoutSeconds) {
    if (withoutSeconds) {
        return '00.D0:N0';
    }

    return '00.D0:N0:N0';
};

Helpers.DevExtreme.TimeSpanWithDaysMaskRules = function () {
    let rules = {
        N: ['0', '1', '2', '3', '4', '5'],
        D: ['0', '1', '2'],
    }

    return rules;
};

Helpers.DevExtreme.TimeSpanWithMultiDayDuration = function (withoutSeconds) {
    if (withoutSeconds) {
        return '000:N0';
    }

    return '000:N0:N0';
};

Helpers.DevExtreme.TimeSpanWithMultiDayDurationMaskRules = function () {
    let rules = {
        N: ['0', '1', '2', '3', '4', '5']
    }

    return rules;
};
//#endregion

//#region Filters
Helpers.DevExtreme.Filters = {};

Helpers.DevExtreme.Filters.Contains = 'contains';
Helpers.DevExtreme.Filters.NotContains = 'notcontains';
Helpers.DevExtreme.Filters.StartsWith = 'startswith';
Helpers.DevExtreme.Filters.EndsWith = 'endswith';
Helpers.DevExtreme.Filters.Equal = '=';
Helpers.DevExtreme.Filters.Different = '<>';
Helpers.DevExtreme.Filters.Between = 'between';
Helpers.DevExtreme.Filters.And = 'and';
Helpers.DevExtreme.Filters.Or = 'or';
Helpers.DevExtreme.Filters.GreaterThanOrEqualTo = '>=';
Helpers.DevExtreme.Filters.SmallerThanOrEqualTo = '<=';
//#endregion
"use strict";

var Helpers = Helpers || {};
Helpers.Dialog = {};

Helpers.Dialog.OpenSwebModal = function (data, $timeout, $compile, $scope) {
    if (typeof data === 'string') {
        data = { Element: data };
    }

    var id = data.Element;

    if (angular.element("#" + id + "Content").length) {
        var number = 0;

        if (angular.element(".SwebActiveModal").length) {
            angular.element(".SwebActiveModal").each(function () {
                if (parseInt(angular.element(this).attr('data-target').substr(9)) >= number) {
                    number = parseInt(angular.element(this).attr('data-target').substr(9)) + 1;
                }
            });
        }

        angular.element("body").append("<div class=\"SwebModal\" id=\"" + id + "\"></div>");
        angular.element("#" + id).html("" + angular.element('#' + id + "Content").html() + "");
        angular.element("#" + id).find("[ng-non-bindable]").each(function () {
            angular.element(this).removeAttr('ng-non-bindable');
        });

        angular.element('#' + id + "Content").find("[id]").each(function () {
            angular.element(this).attr('id', (angular.element(this).attr('id') + "SwebModelInContent"));
        });

        angular.element("#" + id).removeClass("animated fadeOut");
        angular.element("#" + id).addClass("SwebActiveModal animated fadeIn");
        angular.element("#" + id).attr("data-target", "SwebModal" + number + "");
        angular.element("#" + id).attr("draggable-modal", "");

        if (data.NgClass) {
            angular.element("#" + id).attr("ng-class", data.NgClass);
        }

        if (data.Class) {
            angular.element("#" + id).addClass(data.Class);
        }

        if (data.Width) {
            var modal = angular.element("#" + id);

            modal.css('width', data.Width);

            var fileDropBox = modal.find(".FileDropBox");

            if (fileDropBox) {
                fileDropBox.css('width', data.Width - 40);
            }
        }

        if (data.Height) {
            angular.element("#" + id).css('height', data.Height);
        }

        var backgroundDiv = angular.element('<div class="BackgroundSwebModal animated fadeIn"></div>');

        if (data.BackgroundClass) {
            backgroundDiv.addClass(data.BackgroundClass);
        }

        backgroundDiv.attr("data-target", "SwebBackgroundModal" + number);

        angular.element("body").append(backgroundDiv);

        if (data.BackgroundClass) {
            angular.element("#" + id).addClass(data.BackgroundClass);
        }

        if (number > 0) {
            angular.element("#" + id).css('z-index', (parseInt(angular.element(".SwebActiveModal[data-target=\"SwebModal" + (number - 1) + "\"]").css('z-index')) + 20));
            angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").css('z-index', (parseInt(angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + (number - 1) + "\"]").css('z-index')) + 20));
        }

        if (data.ClickOutsideToClose) {
            angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").on('click', function () {
                Helpers.Dialog.CloseSwebModal(id);
            });
        }
    }

    $timeout(function () {
        $compile(angular.element("#" + id))($scope);

        if (Helpers.Object.IsUndefinedEmptyOrNull(data.OnComplete)) {
            return;
        }

        data.OnComplete();
        var pageHeight = angular.element(window).height();
        var height = ((80 * pageHeight) / 100);
        var findElements = angular.element('.ModalContent');

        for (var a = 0; a < findElements.length; a++) {
            var findElement = findElements[a];

            if (angular.element(findElement).parents('#TicketDialog').length) {
                continue;
            }

            angular.element('.ModalContent.scroll-wrapper').css('max-height', height - 90 + "px");

            $timeout(function () {
                angular.element('.ModalContent.scroll-content').css('max-height', height - 130 + "px");
            }, 200);
        }
    });
}

Helpers.Dialog.CloseSwebModal = function (data) {
    if (typeof data === 'string') {
        data = { Element: data };
    }

    var id = data.Element;
    var findElement = angular.element("#" + id);

    findElement.addClass("animated fadeOut");

    if (typeof findElement.attr('data-target') === 'undefined') {
        return;
    }

    var number = findElement.attr('data-target').substr(9);

    angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").addClass("animated fadeOut");
    findElement.removeClass("SwebActiveModal");
    angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").remove();
    findElement.attr("data-target", "");

    if (!Helpers.Object.IsUndefinedEmptyOrNull(data.OnComplete)) {
        data.OnComplete();
    }

    angular.element('#' + id + "Content").find("[id]").each(function () {
        if (angular.element(this).attr('id').indexOf('SwebModelInContent') > -1) {
            angular.element(this).attr('id', (angular.element(this).attr('id').substr(0, (angular.element(this).attr('id').length - 18))));
        }
    });

    angular.element("#" + id + ".SwebModal").remove();
};
"use strict";

var Helpers = Helpers || {};
Helpers.Download = {};

Helpers.Download.DownloadFiles = function (_scope, newWindow, result) {
    newWindow.document.write('<div id="Loading" class="NoHeight">' + Helpers.Translations.Loading + '</div><div id="LoadingBackground"></div>');
    $(newWindow.document).find("head").append('<link rel="stylesheet" type="text/css" href="./Application/Content/Bundles/GeneralBundle.min.css?v=0.0.0">');

    if (result.FileType === 'pdf') {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result.BlobObject, result.FileName);
            newWindow.close();
        }
        else {
            var blob = result.BlobObject.slice(0, result.BlobObject.size, 'application/pdf');
            newWindow.location.href = URL.createObjectURL(blob);
        }
    }
    else {
        var a = document.createElement("a");

        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        a.href = result.Blob;
        a.download = result.FileName;
        a.click();
        window.URL.revokeObjectURL(a.href);
        a.remove();
        newWindow.close();
    }
};

Helpers.Download.DownloadResultBlob = function (result) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(result.BlobObject, result.FileName);

        return;
    }

    var url = result.Blob;

    var a = document.createElement("a");
    document.body.appendChild(a);

    a.style.display = "none";
    a.href = url;
    a.download = result.FileName;

    a.click();

    window.URL.revokeObjectURL(a.href);
    a.remove();
};

Helpers.Download.DownloadResultBlobToBrowser = function (result) {
    var a = document.createElement("a");

    document.body.appendChild(a);
    a.style.display = "none";
    a.href = result.Blob;
    a.target = "_blank";
    a.click();
    a.remove();
};
"use strict";

var Helpers = Helpers || {};
Helpers.EmailOperations = {};

Helpers.EmailOperations.IsEmail = function (email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var isEmail = regex.test(email);

    return isEmail;
};

Helpers.EmailOperations.OpenWindowToSendEmail = function (email) {
    var linkToSendEmail = 'mailto:' + encodeURIComponent(email);

    window.location.href = linkToSendEmail;
};

(function () {
    "use strict";
    myApp.factory('EmailOperations', function () {

        function EmailOperations(scope) {
            scope.generalModel.IsEmail = function (email) {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            };

            scope.generalModel.ValidateSemicolonSeparatedEmails = function (emails) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(emails)) {
                    return false;
                }

                var emailsSplit = emails.split(";");

                var noEmails = true;

                for (var a = 0; a < emailsSplit.length; a++) {
                    emailsSplit[a] = emailsSplit[a].trim();
                    if (emailsSplit[a].length) {
                        if (!scope.generalModel.IsEmail(emailsSplit[a])) {
                            return false;
                        }
                        noEmails = false;
                    }
                }

                if (noEmails) {
                    return false;
                }

                return true;
            };
        }

        return EmailOperations;
    });
})();
"use strict";

var Helpers = Helpers || {};
Helpers.ExportFiles = {};

Helpers.ExportFiles.ReadXmlFile = function (fileName, xmlFile) {
    var byteArray = new Uint8Array(xmlFile);
    var dataToBase64 = new TextDecoder("utf-8").decode(byteArray);

    dataToBase64 = JSON.parse(dataToBase64).FileArray;
    dataToBase64 = dataToBase64.replace(/[\'\"]/g, '');

    var byteCharacters = atob(dataToBase64);
    var blob = new Blob([byteCharacters], {
        type: 'text/xml'
    });

    saveAs(blob, '' + fileName + '.xml');
};
"use strict";

var Helpers = Helpers || {};

Helpers.Files = {};

//#region File Extension
Helpers.Files.CompareExtension = function (file, validExtensions) {
    var fileExtension = file.split('.').pop().toLowerCase();

    var exists = validExtensions.includes(fileExtension);

    return exists;
}
//#endregion

//#region Csv
Helpers.Files.Csv = {};

Helpers.Files.Csv.GetData = function (csvContent) {
    let lines = [];
    const linesArray = csvContent.split('\n');

    // for trimming and deleting extra space 
    linesArray.forEach((e) => {
        const row = e.replace(/[\s]+[,]+|[,]+[\s]+/g, ',').trim();

        lines.push(row);
    });

    // for removing empty record
    while (lines[lines.length - 1] === '') {
        lines.splice(lines.length - 1, 1);
    }

    const result = [];
    const headers = lines[0].split(";");

    for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentline = lines[i].split(";");

        for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j];
        }

        result.push(obj);
    }

    return result;
}

Helpers.Files.Csv.ImportCsvFileToObject = function (file, columns, functionAfterLoad) {
    if (!file || !columns.length) {
        return;
    }

    const fileReader = new FileReader();

    fileReader.readAsText(file, 'UTF-8');

    fileReader.onload = () => {
        var csvText = fileReader.result;
        var csvRows = Helpers.Files.Csv.GetData(csvText);
        var rows = [];

        AddCsvDataIntoObject(csvRows, columns, rows);

        functionAfterLoad(rows);
    };
};

function AddCsvDataIntoObject(csvRows, columns, rows) {
    if (!csvRows || !csvRows.length) {
        return;
    }

    csvRows.forEach(function (csvRow) {
        var rowToAdd = {};

        Object.entries(csvRow).forEach(([key, value]) => {
            var captionToFind = key.toUpperCase();
            var column = columns.find(find => find.caption && (find.caption.toUpperCase() === captionToFind));

            if (column) {
                var dataField = column.dataField;

                rowToAdd[dataField] = value;
            }
        });

        if (rowToAdd) {
            rows.push(rowToAdd);
        }
    });
};
//#endregion
"use strict";

var Helpers = Helpers || {};
Helpers.FormatOperations = {};

Helpers.FormatOperations.ToPercentage = function (value) {
    var valueInPercentage = value.toLocaleString('default', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true });

    return valueInPercentage;
}
"use strict";

var Helpers = Helpers || {};
Helpers.Forms = {};

Helpers.Forms.CheckIfIsInvalidField = function (elementId, submittedField, element) {
    if (!Helpers.Object.IsUndefinedEmptyOrNull(elementId)) {
        element = angular.element('#' + elementId);
    }

    let inputElementInvalid = element.find('.ng-invalid');

    if (inputElementInvalid.length && submittedField) {
        return true;
    }

    return false;
};

Helpers.Forms.RemoveAllControls = function (form) {
    if (!form || !form.$$controls.length) {
        return;
    }

    let controls = form.$$controls;

    controls.forEach((control) => {
        form.$removeControl(control);
    });
};
'use strict';

var Helpers = Helpers || {};

Helpers.GoogleMaps = {};

Helpers.GoogleMaps.Search = function (textToSearch) {
    let url = "http://maps.google.com/?q=" + encodeURIComponent(textToSearch);

    window.open(url, '_blank');
};
"use strict";

var Helpers = Helpers || {};

Helpers.Guid = {};

Helpers.Guid.GuidEmpty = '00000000-0000-0000-0000-000000000000';

Helpers.Guid.HasValue = function (value) {
    var result = (!Helpers.Object.IsUndefinedEmptyOrNull(value) && (value !== Helpers.Guid.GuidEmpty));

    return result;
};

Helpers.Guid.GenerateRandom = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);

        return v.toString(16);
    });
};

Helpers.Guid.GenerateRandomIfNotHasValue = function (value) {
    var result;

    if (Helpers.Guid.HasValue(value)) {
        result = value;
    }
    else {
        result = Helpers.Guid.GenerateRandom();
    }

    return result;
};

"use strict";

var Helpers = Helpers || {};
Helpers.HTML = {};
Helpers.HTML.Style = {};

Helpers.HTML.AddClassToElement = function (parent, findQuery, classToAdd) {
    var findElement = parent.find(findQuery);
    findElement.addClass(classToAdd);
};

Helpers.HTML.RemoveClassToElement = function (parent, findQuery, classToRemove) {
    var findElement = parent.find(findQuery);
    findElement.removeClass(classToRemove);
};

Helpers.HTML.GetElementByText = function (text, findQuery) {
    var findElements = angular.element(findQuery);

    if (!findElements.length) {
        return;
    }

    for (var e = 0; e < findElements.length; e++) {
        var findElement = findElements[e];

        if (findElement.innerText === text) {
            return findElement;
        }
    }
};

Helpers.HTML.GetHeight = function (elementId, minimum) {
    var height = angular.element('#' + elementId).height();

    if (!minimum || isNaN(minimum)) {
        minimum = 300;
    }

    if (height === undefined) {
        return minimum;
    }

    if (height < minimum) {
        height = minimum;
    }

    return height;
}

Helpers.HTML.GetOuterHeight = function (elementId, minimum, maximum) {
    var height = angular.element('#' + elementId).outerHeight();

    if (!minimum || isNaN(minimum)) {
        minimum = 0;
    }

    if (height === undefined) {
        return minimum;
    }

    if (height < minimum) {
        height = minimum;
    } else if (maximum && (height > maximum)) {
        height = maximum;
    }

    return height;
}

Helpers.HTML.IsDisabled = function (event) {
    var element = $(event.currentTarget);

    if (element.attr('disabled') || element.hasClass('Disabled')) {
        return true;
    }

    var parentElement = element[0].offsetParent;

    if (parentElement && (parentElement.tagName.toLowerCase() === "td") && parentElement.classList.contains('Disabled')) {
        return true;
    }

    return false;
};

Helpers.HTML.PreventKeyPress = function (event, keyCode) {
    if (!event) {
        return;
    }

    if (!keyCode) {
        keyCode = 13;
    }

    if (event.keyCode == keyCode) {
        event.preventDefault();
    }
};

Helpers.HTML.CloseOpenedModals = function () {
    var modals = angular.element('.SwebActiveModal');

    for (var i = 0; i < modals.length; i++) {
        var modalId = $(modals[i]).attr('id');

        Helpers.Dialog.CloseSwebModal(modalId);
    }
}

Helpers.HTML.Style.GetBackgroundColorStyle = function (color) {
    var style = {
        'background-color': "'" + color + "'"
    }

    return style;
};

Helpers.HTML.ScrollToElement = function (elementId, scrollOptions) {
    var htmlElement = document.getElementById(elementId);

    if (htmlElement) {
        htmlElement.scrollIntoView(scrollOptions);
    }
}

Helpers.HTML.FocusElement = function (elementId) {
    var htmlElement = document.getElementById(elementId);

    if (htmlElement) {
        htmlElement.focus();
    }
}

Helpers.HTML.FocusFirstInputElement = function (elementId, elementType) {
    let htmlElement = Helpers.HTML.GetFirstInputElement(elementId, elementType);

    if (!htmlElement) {
        return;
    }

    htmlElement.focus();
}

Helpers.HTML.ClickFirstInputElement = function (elementId, elementType) {
    let htmlElement = Helpers.HTML.GetFirstInputElement(elementId, elementType);

    if (!htmlElement) {
        return;
    }

    htmlElement.click();
}

Helpers.HTML.GetFirstInputElement = function (elementId, elementType) {
    let container = document.getElementById(elementId);

    if (!container) {
        return null;
    }

    let element = elementType || 'input';
    let htmlElement = container.querySelector(element);

    return htmlElement;
}

Helpers.HTML.CopyToClipboard = function (textToCopy, setSpacesToUrl) {
    if (!textToCopy) {
        return;
    }

    if (setSpacesToUrl) {
        textToCopy = textToCopy.replace(/_/g, ' ');
    }

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy);

        return;
    }

    let temporaryElement = document.createElement('textarea');

    temporaryElement.value = textToCopy;
    document.body.appendChild(temporaryElement);
    temporaryElement.select();
    document.execCommand('Copy');
    document.body.removeChild(temporaryElement);
}

Helpers.HTML.SetFocusOutOfAnyInput = function () {
    const activeElement = document.activeElement;

    if (activeElement) {
        activeElement.blur();
    }
}
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}
"use strict";

var Helpers = Helpers || {};

Helpers.Object = {};

const VALUE_CREATED = 'created';
const VALUE_UPDATED = 'updated';
const VALUE_DELETED = 'deleted';
const VALUE_UNCHANGED = 'unchanged';

Helpers.Object.IsNotUndefinedEmptyOrNull = function (value) {
    var result = (!angular.isUndefined(value)) && (value !== null) && (value !== '') && (value !== 'null') && (value !== 'undefined');

    return result;
};

Helpers.Object.IsNotUndefinedEmptyNullOrZero = function (value) {
    var result = (Helpers.Object.IsNotUndefinedEmptyOrNull(value) && (value !== 0));

    return result;
};

Helpers.Object.IsNotUndefinedEmptyOrNullObject = function (value) {
    if (!angular.isUndefined(value) && (value !== null) && (value !== '') && (value !== 'null') && (value !== 'undefined')) {
        if (value instanceof Date) {
            return true;
        }

        if ((typeof value === 'object') && !(value instanceof Date)) {
            return Object.keys(value).length !== 0;
        }
    }

    return false;
};

Helpers.Object.IsUndefinedEmptyOrNull = function (value) {
    var result = (!this.IsNotUndefinedEmptyOrNull(value));

    return result;
};

Helpers.Object.IsUndefinedEmptyNullOrZero = function (value) {
    var result = (!this.IsNotUndefinedEmptyNullOrZero(value));

    return result;
}

Helpers.Object.IsUndefinedEmptyOrNullObject = function (value) {
    return (!this.IsNotUndefinedEmptyOrNullObject(value));
};

Helpers.Object.GetObjectByString = function (object, string) {
    if (!angular.isObject(object) || this.IsUndefinedEmptyOrNull(string)) {
        return object;
    }

    string = string.replace(/\[(\w+)\]/g, '.$1');
    string = string.replace(/^\./, '');
    var divisions = string.split('.');

    for (var i = 0, n = divisions.length; i < n; ++i) {
        var division = divisions[i];

        if (object === null) {
            return;
        }

        if (division in object) {
            object = object[division];
        }
        else {
            return;
        }
    }

    return object;
};

Helpers.Object.GetPropertyByPath = function (object, path) {
    return path.split('.').reduce((current, key) => {
        let property = current ? current[key] : undefined;

        return property;
    }, object);
}

Helpers.Object.SetObjectValueByString = function (object, string, value) {
    var stringArray = [];
    var cutedString = Helpers.Object.AngularCopy(string);
    var total = 1;

    total += string.replace(/[^.]/g, "").length;
    total += string.replace(/[^[]/g, "").length;

    for (var n = 0; n < total; n++) {
        if ((cutedString.indexOf('.') > -1) && ((cutedString.indexOf('.') < cutedString.indexOf('[')) || (cutedString.indexOf('[') === -1))) {
            stringArray[n] = cutedString.split('.')[0];
            if (cutedString.split('.')[0].substring(cutedString.split('.')[0].length - 1) === ']') {
                stringArray[n] = cutedString.split('.')[0].substring(0, cutedString.split('.')[0].length - 1);
            }
            cutedString = cutedString.substr(cutedString.split('.')[0].length + 1);
        }
        else if ((cutedString.indexOf('[') > -1) && ((cutedString.indexOf('[') < cutedString.indexOf('.')) || (cutedString.indexOf('.') === -1))) {
            stringArray[n] = cutedString.split('[')[0];
            if (cutedString.split('[')[0].substring(cutedString.split('[')[0].length - 1) === ']') {
                stringArray[n] = cutedString.split('.')[0].substring(0, cutedString.split('.')[0].length - 1);
            }
            cutedString = cutedString.substr(cutedString.split('[')[0].length + 1);
        }
        else {
            stringArray[n] = Helpers.Object.AngularCopy(cutedString);
            break;
        }
    }

    for (var i = 0; i < stringArray.length - 1; i++) {
        object = object[stringArray[i]];
    }

    object[stringArray[i]] = Helpers.Object.AngularCopy(value);
};

Helpers.Object.SetPropertyValueIfUndefined = function (object, property, value) {
    if (object[property] !== undefined) {
        return;
    }

    object[property] = value;
};

Helpers.Object.SetPropertyValueIfUndefinedOrNull = function (object, property, valueToSet) {
    if ((object[property] === null) || (object[property] === undefined)) {
        object[property] = valueToSet;
    }
};

Helpers.Object.SetPropertyValue = function (object, propertyName, valueToSet) {
    if (!object || !propertyName) {
        return;
    }

    if (!(propertyName in object)) {
        return;
    }

    try {
        let convertedValue = valueToSet;
        const targetType = typeof object[propertyName];

        if (targetType === 'number') {
            const valueInNumber = Number(valueToSet);

            if (isNaN(valueInNumber)) {
                return;
            }

            convertedValue = valueInNumber;
        } else if (targetType === 'boolean') {
            if (valueToSet === 'true') {
                convertedValue = true;
            }
            else if (valueToSet === 'false') {
                convertedValue = false;
            }
            else {
                return;
            }
        } else if ((targetType === 'object') && (object[propertyName] instanceof Date)) {
            const date = new Date(valueToSet);

            if (isNaN(date.getTime())) {
                return;
            }

            convertedValue = date;
        }

        object[propertyName] = convertedValue;
    } catch (_exception) { }
};

Helpers.Object.SetObjectProperties = function (objectToUpdate, objectPropertiesToAdd) {
    if (objectPropertiesToAdd) {
        for (let property in objectPropertiesToAdd) {
            objectToUpdate[property] = objectPropertiesToAdd[property];
        }
    }
}

Helpers.Object.AngularCopy = function (object) {
    const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;

    function reviver(key, value) {
        if ((typeof value === "string") && dateFormat.test(value)) {
            return new Date(value);
        }

        return value;
    }

    if ((typeof object === 'undefined') || (object === null)) {
        return object;
    }

    return JSON.parse(JSON.stringify(object), reviver);
};

Helpers.Object.CheckIfObjectsAreEqual = function (mainObject, secondaryObject, propertiesToIgnore) {
    var isBasic = Helpers.Object.IsBasic(secondaryObject);

    if (isBasic) {
        return true;
    }

    if (angular.equals(mainObject, secondaryObject)) {
        return true;
    }

    if (!(mainObject instanceof Object) || !(secondaryObject instanceof Object)) {
        return false;
    }

    if (typeof mainObject !== typeof secondaryObject) {
        return false;
    }

    if (Array.isArray(mainObject) && (mainObject.length !== secondaryObject.length)) {
        return false;
    }

    for (var property in mainObject) {
        if (propertiesToIgnore && propertiesToIgnore.includes(property)) {
            continue;
        }

        if (!mainObject.hasOwnProperty(property)) {
            continue;
        }

        if (!secondaryObject.hasOwnProperty(property)) {
            if ((mainObject[property] === null) || (mainObject[property] === undefined)) {
                continue;
            }

            return false;
        }

        var mainValue = mainObject[property];
        var secondaryValue = secondaryObject[property];

        if (mainValue === secondaryValue) {
            continue;
        }

        if (!mainValue || !secondaryValue) {
            return false;
        }

        if ((typeof mainValue.getMonth === 'function') || (typeof secondaryValue.getMonth === 'function')) {
            if (typeof (mainValue) === "string") {
                mainValue = new Date(mainValue);
            }

            if (typeof (secondaryValue) === "string") {
                secondaryValue = new Date(secondaryValue);
            }

            var mainDate = mainValue.toISOString();
            var secondaryDate = secondaryValue.toISOString();

            if (mainDate !== secondaryDate) {
                return false;
            }

            continue;
        }

        if (typeof (mainValue) !== "object") {
            return false;
        }

        if (!Helpers.Object.CheckIfObjectsAreEqual(mainValue, secondaryValue)) {
            return false;
        }
    }

    return true;
};

Helpers.Object.IsBasic = function (object) {
    var result = (!Helpers.Object.IsUndefinedEmptyOrNull(object) && !Helpers.Object.IsUndefinedEmptyOrNull(object.Id));

    return result;
};

function GetRecursiveDifferences(differencesMapped, differences, previousKey) {
    for (var key in differencesMapped) {
        var difference = differencesMapped[key];

        if (Helpers.Object.IsUndefinedEmptyOrNull(difference)) {
            continue;
        }

        if (Helpers.Object.IsUndefinedEmptyOrNull(difference.type) && !Helpers.Object.IsUndefinedEmptyOrNullObject(difference)) {
            GetRecursiveDifferences(difference, differences, (!Helpers.Object.IsUndefinedEmptyOrNull(previousKey) ? previousKey + "." + key : key));
        }
        else if ((Object.prototype.toString.call(difference.data) === '[object Object]') && (difference.type !== VALUE_UNCHANGED) && !Helpers.Object.IsUndefinedEmptyOrNullObject(difference.data)) {
            GetRecursiveDifferences(difference.data, differences, (!Helpers.Object.IsUndefinedEmptyOrNull(previousKey) ? previousKey + "." + key : key));
        }

        else if (difference.type !== VALUE_UNCHANGED) {
            if (Helpers.Object.IsUndefinedEmptyOrNull(previousKey)) {
                differences.push({ datafield: key, data: difference.data });
            }
            else if (!Helpers.Object.IsUndefinedEmptyOrNull(difference.data)) {
                differences.push({ datafield: previousKey + "." + key, data: difference.data });
            }
            else {
                differences.push({ datafield: previousKey + "." + key, data: difference });
            }
        }
    }

    return differences;
}

Helpers.Object.GetObjectDifferences = function (object1, object2) {
    var differencesMapped = DeepDifferenceMapper.map(object1, object2);
    var differences = [];

    differences = GetRecursiveDifferences(differencesMapped, differences);

    return differences;
};

Helpers.Object.FillServerDataContent = function (listOfConcurrencyFields, differences) {
    var serverDataContent = [];

    for (var l = 0; l < listOfConcurrencyFields.length; l++) {
        for (var d = 0; d < differences.length; d++) {
            if (listOfConcurrencyFields[l]["dataField"] === differences[d]["datafield"]) {
                serverDataContent.push({ datafield: differences[d]["dataField"], data: differences[d]["data"], caption: listOfConcurrencyFields[l]["caption"] });
                break;
            }
        }
    }

    return serverDataContent;
};

Helpers.Object.CopyObjectToAnother = function (originalObject, destinationObject) {
    if (typeof originalObject !== "object" || typeof destinationObject !== "object") {
        return;
    }

    for (var property in originalObject) {
        if (!destinationObject.hasOwnProperty(property)) {
            return;
        }

        destinationObject[property] = Helpers.Object.AngularCopy(originalObject[property]);
    }
};

var DeepDifferenceMapper = function () {
    return {
        VALUE_CREATED: 'created',
        VALUE_UPDATED: 'updated',
        VALUE_DELETED: 'deleted',
        VALUE_UNCHANGED: 'unchanged',
        map: function (obj1, obj2) {
            if (this.isFunction(obj1) || this.isFunction(obj2)) {
                throw 'Invalid argument. Function given, object expected.';
            }
            if (this.isValue(obj1) || this.isValue(obj2)) {
                return {
                    type: this.compareValues(obj1, obj2),
                    data: obj1 === undefined ? obj2 : obj1
                };
            }

            var diff = {};

            for (var key in obj1) {
                if (this.isFunction(obj1[key])) {
                    continue;
                }

                var value2 = undefined;

                if (obj2[key] !== undefined) {
                    value2 = obj2[key];
                }

                diff[key] = this.map(obj1[key], value2);
            }
            for (var key2 in obj2) {
                if (this.isFunction(obj2[key2]) || diff[key2] !== undefined) {
                    continue;
                }

                diff[key2] = this.map(undefined, obj2[key2]);
            }

            return diff;
        },
        compareValues: function (value1, value2) {
            if (value1 === value2) {
                return VALUE_UNCHANGED;
            }
            if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
                return VALUE_UNCHANGED;
            }
            if (value1 === undefined) {
                return VALUE_CREATED;
            }
            if (value2 === undefined) {
                return VALUE_DELETED;
            }
            return VALUE_UPDATED;
        },
        isFunction: function (x) {
            return Object.prototype.toString.call(x) === '[object Function]';
        },
        isArray: function (x) {
            return Object.prototype.toString.call(x) === '[object Array]';
        },
        isDate: function (x) {
            return Object.prototype.toString.call(x) === '[object Date]';
        },
        isObject: function (x) {
            return Object.prototype.toString.call(x) === '[object Object]';
        },
        isValue: function (x) {
            return !this.isObject(x) && !this.isArray(x);
        }
    };
}();

Helpers.Object.GetArrayIndexByPropertyValue = function (value, array, property) {
    if (!Array.isArray(array) || !array.length) {
        return;
    }

    for (var i = 0; i < array.length; i++) {
        var arrayValue = GetParameterCaseInsensitive(array[i], property);

        if (Helpers.Object.IsUndefinedEmptyOrNull(arrayValue) || (typeof array[i][property] === "object")) {
            return;
        }

        if (arrayValue === value) {
            return i;
        }
    }

    function GetParameterCaseInsensitive(object, key) {
        return object[Object.keys(object).filter(function (k) {
            return k.toLowerCase() === key.toLowerCase();
        })[0]];
    }
};

Helpers.Object.CheckIfValueExistsInArraySplited = function (stringToSplit, splitChar, value, indexToFind) {
    var resultSplit = stringToSplit.split(splitChar);

    for (var i = 0; i < resultSplit.length; i++) {
        if (!Helpers.Object.IsUndefinedEmptyOrNull(indexToFind) && (i === indexToFind) && (resultSplit[i].toLowerCase() === value.toLowerCase())) {
            return true;
        }
        else if (resultSplit[i].toLowerCase() === value.toLowerCase()) {
            return true;
        }
    }

    return false;
};

Helpers.Object.GetValueInArraySplited = function (object, stringToSplit, splitChar) {
    var value = object;
    var arrayOfFields = stringToSplit.split(splitChar);

    for (var i = 0; i < arrayOfFields.length; i++) {
        var fieldValue = arrayOfFields[i];

        value = value[fieldValue];

        if (Helpers.Object.IsUndefinedEmptyOrNull(value)) {
            break;
        }
    }

    return value;
};

Helpers.Object.Parameterfy = (function () {
    var pattern = /function[^(]*\(([^)]*)\)/;

    return function (func) {
        var args = func.toString().match(pattern)[1].split(/,\s*/);

        return function () {
            var namedParams = arguments[arguments.length - 1];

            if (typeof namedParams === 'object') {
                var params = [].slice.call(arguments, 0, -1);

                if (params.length < args.length) {
                    for (var i = params.length, l = args.length; i < l; i++) {
                        let argument = args[i];
                        let parameter = namedParams[argument.split('=')[0].trim()];

                        params.push(parameter);
                    }

                    return func.apply(this, params);
                }
            }

            return func.apply(this, arguments);
        };
    };
}());

Helpers.Object.RemoveNullProperties = function (object) {
    let objectWithoutNulls = Object.fromEntries(Object.entries(object).filter(([_, value]) => (value !== null)));

    return objectWithoutNulls;
}
"use strict";

var Helpers = Helpers || {};
Helpers.Page = {};

Helpers.Page.GetLoginPage = function (currentStateName) {
    if (myApplication.differentLoginPages.length && (myApplication.differentLoginPages.indexOf(currentStateName) > -1)) {
        return myApplication.differentLogin;
    }

    return myApplication.loginPage;
};

Helpers.Page.RefreshPage = function () {
    window.location.reload();
};

Helpers.Page.OpenInNewTab = function (url) {
    window.open(url, '_blank');
};

Helpers.Page.OpenInNewPage = function (url) {
    var windowFeatures = 'width=' + screen.width + ',height=' + screen.height + ',top=0,left=0,toolbar=yes,directories=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes';

    window.open(url, windowFeatures);
};
"use strict";

var Helpers = Helpers || {};
Helpers.Regex = {};

Helpers.Regex.GetPattern = function (patternName) {
    switch (patternName.toLowerCase()) {
        case "numberwithtwodecimalcases":
            return /^[0-9]+(\.[0-9]{1,2})?$/;
        case "number":
            return /^[0-9]+$/;
        case "portuguesepostalcode":
            return /^\d{4}-\d{3}?$/;
        case "extendedtimemask":
            return /^\d{1,3}:[0-5]\d$/;
        default:
            return;
    }
};

Helpers.Regex.IsValid = function (value, patternName) {
    let pattern = Helpers.Regex.GetPattern(patternName);

    if (!pattern) {
        return true;
    }

    let isValid = pattern.test(value);

    return isValid;
};
"use strict";

var Helpers = Helpers || {};
Helpers.Search = {};

Helpers.Search.WildCardMatchRule = function (textArray, expression) {
    if (expression === '') {
        return true;
    }

    var equalExpression = false;

    if (expression.charAt(0) === '=') {
        equalExpression = true;
    }

    for (var t = 0; t < textArray.length; t++) {
        if (equalExpression) {
            if (textArray[t] === expression.substring(1, expression.length)) {
                return true;
            }
        } else if (new RegExp("^" + expression.split("*").join(".*") + "$").test(textArray[t])) {
            return true;
        }
    }

    return false;
};

Helpers.Search.SearchContainsSplitWildCard = function (textArray, expression) {
    if (expression === '') {
        return true;
    }

    var wordArray = [];
    var found = false;

    if (expression.charAt(0) === '=') {
        wordArray = expression.split('=');
    } else {
        wordArray = expression.split('*');
    }

    for (var t = 0; t < textArray.length; t++) {
        for (var w = 0; w < wordArray.length; w++) {
            if (!Helpers.Object.IsUndefinedEmptyOrNull(textArray[t]) && (wordArray[w] !== '')) {
                if (expression.charAt(0) === '=') {
                    if (textArray[t].toUpperCase() === wordArray[w].toUpperCase()) {
                        found = true;
                        break;
                    }
                } else if (textArray[t].toUpperCase().indexOf(wordArray[w].toUpperCase()) !== -1) {
                    found = true;
                    break;
                }
            }
        }

        if (found) {
            break;
        }
    }

    return found;
};
"use strict";

var Helpers = Helpers || {};
Helpers.LocalStorage = {};

Helpers.LocalStorage.Get = function (item) {
    var value = localStorage.getItem(item);

    if (!value) {
        return null;
    }

    if (typeof value !== "string") {
        return value;
    }

    try {
        return JSON.parse(value);
    } catch (_exception) {
        return value;
    }
};

Helpers.LocalStorage.Set = function (item, value) {
    if (item && (value !== null) && (value !== undefined)) {
        localStorage.setItem(item, value);
    }
};

Helpers.LocalStorage.Remove = function (item) {
    if (item) {
        localStorage.removeItem(item);
    }
};
"use strict";

var Helpers = Helpers || {};
Helpers.SessionStorage = {};

Helpers.SessionStorage.GetSessionStorageItem = function (item) {
    var sessionStorageItem = sessionStorage.getItem(item);

    if (!sessionStorageItem) {
        return null;
    }

    if (typeof sessionStorageItem !== "string") {
        return sessionStorageItem;
    }

    try {
        return JSON.parse(sessionStorageItem);
    } catch (_exception) {
        return sessionStorageItem;
    }
};

Helpers.SessionStorage.SetSessionStorageItem = function (item, value) {
    if (item && value) {
        sessionStorage.setItem(item, value);
    }
};

Helpers.SessionStorage.RemoveSessionStorageItem = function (item) {
    sessionStorage.removeItem(item);
};

Helpers.SessionStorage.CheckIfExists = function (item) {
    let sessionStorageItem = Helpers.SessionStorage.GetSessionStorageItem(item);

    if (sessionStorageItem === null) {
        return false;
    }

    return true;
}
"use strict";

var Helpers = Helpers || {};
Helpers.SideBar = {};

Helpers.SideBar.CloseOpenSideBarArea = function (area) {
    var open;
    var element = angular.element('.' + area);

    if (element.hasClass('DisplayNone')) {
        open = true;
        angular.element('#IconOpenClose' + area).text('-');
        element.removeClass('DisplayNone');
    }
    else {
        open = false;
        angular.element('#IconOpenClose' + area).text('+');
        element.addClass('DisplayNone');
    }

    Helpers.LocalStorage.Set(area, open);

    if (area === 'SideBarFilters') {
        RefreshFilterSideBarHeight();
    }

    function RefreshFilterSideBarHeight() {
        var sideBarHeight = parseInt(angular.element('#SideBar').css('height'));
        $timeout(angular.element('#FilterArea > .SideBarFilters').css('height', '' + (sideBarHeight - 250) + 'px'), 100);
    }
};
"use strict";

var Helpers = Helpers || {};
Helpers.Singest = {};

Helpers.Singest.SetDocumentNumber = function (documentKey) {
    if (documentKey.length === 20) {
        documentKey = documentKey.substring(4, 6) + " " + documentKey.substring(6, 9) + "/" + documentKey.substring(9, 17).trim() + '.' + documentKey.slice(-3);
    }
    else {
        documentKey = documentKey.substring(4, 6) + " " + documentKey.substring(6, 9) + "/" + documentKey.slice(-8).trim();
    }
    
    return documentKey;
};
"use strict";

var Helpers = Helpers || {};
Helpers.Strings = {};

Helpers.Strings.GetStringBetweenBrackets = function (string) {
    var matches = [];

    if (Helpers.Object.IsUndefinedEmptyOrNull(string)) {
        return matches;
    }

    var fields = string.split('{');

    for (var i = 1; i < fields.length; i++) {
        matches.push(fields[i].split('}')[0]);
    }

    return matches;
};

Helpers.Strings.ConvertStringBetweenBracketsToNumbers = function (string) {
    var counter = 0;

    if (Helpers.Object.IsUndefinedEmptyOrNull(string)) {
        return;
    }

    return string.replace(/(\{.*?\})/g, function () {
        var match = "{" + counter + "}";

        counter++;

        return match;
    });
};

Helpers.Strings.RemoveAccents = function (string) {
    let stringUpdated = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    return stringUpdated;
}

Helpers.Strings.CheckContains = function (searchText, texts, caseSensitive, accentSensitive) {
    if (!searchText) {
        return true;
    }

    if (!Array.isArray(texts)) {
        texts = [texts];
    }

    if (!caseSensitive) {
        searchText = searchText.toUpperCase();
    }

    if (!accentSensitive) {
        searchText = Helpers.Strings.RemoveAccents(searchText);
    }

    let isContained = texts.some(text => {
        if (!text) {
            return false;
        }

        if (!caseSensitive) {
            text = text.toUpperCase();
        }

        if (!accentSensitive) {
            text = Helpers.Strings.RemoveAccents(text);
        }

        let contains = text.includes(searchText);

        return contains;
    });

    return isContained;
}
"use strict";

var Helpers = Helpers || {};
Helpers.Translation = {};

Helpers.Translations = Helpers.SessionStorage.GetSessionStorageItem('ngStorage-Translations') || [];

Helpers.Translation.SetTranslations = function ($sessionStorage, translations) {
    Helpers.Translations = {};

    if (!translations) {
        translations = [];
    }

    if (!translations.length) {
        if (webTranslations) {
            translations.pushRange(webTranslations);
        }

        if (sharedTranslations) {
            translations.pushRange(sharedTranslations);
        }
    }

    for (var i = 0; i < translations.length; i++) {
        var translation = translations[i];

        Helpers.Translations[translation.Code] = translation.Text || translation.OriginalText;
    }

    $sessionStorage.Translations = Helpers.Translations;
}

Helpers.Translation.GetText = function (code, replaceObject) {
    var text = Helpers.Translations[code];

    if (!text) {
        text = code;
    }

    function ReplaceDynamicInformation(translation, replaceObject) {
        for (var key in replaceObject) {
            if (translation.indexOf('{' + key + '}') !== -1) {
                translation = translation.replace('{' + key + '}', replaceObject[key]);
            }
        }

        return translation;
    }

    if (replaceObject) {
        text = ReplaceDynamicInformation(text, replaceObject);
    }

    return text;
}


"use strict";

var Helpers = Helpers || {};
Helpers.Upload = {};

Helpers.Upload.GetUploadBox = function (accept, maxSize, firefoxPaste) {
    accept = accept || '';
    maxSize = maxSize || myApplication.maxLimitFile;
    firefoxPaste = firefoxPaste || false;

    var uploadBox = {
        Multiple: false,
        Pattern: accept,
        Accept: accept,
        Capture: 'camera',
        Validate: {
            size: {
                min: '1B',
                max: maxSize
            },
            height: {
                max: 12000
            },
            width: {
                max: 12000
            }
        },
        DragOverClass: {
            accept: 'dragover',
            reject: 'dragover-err',
            pattern: accept
        },
        Options: {
            debounce: 100
        },
        Resize: {
            width: 400,
            height: 400,
            centerCrop: false
        },
        ResizeIf: '$width > 400 || $height > 400',
        FirefoxPaste: false
    };

    return uploadBox;
}

Helpers.Upload.Base64ToBlob = function (base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = atob(base64Data);
    var byteArrays = [];
    var byteArray;
    var byteNumbers;
    var slice;

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        slice = byteCharacters.slice(offset, offset + sliceSize);

        byteNumbers = new Array(slice.length);

        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });

    return blob;
};

Helpers.Upload.ConvertBlobImages = function (blobFile, listIndex, list) {
    var deferred = Helpers.AngularModules.GetAngularModules().$q.defer();
    var response;
    var base64data;
    var reader = new window.FileReader();

    reader.readAsDataURL(blobFile);
    reader.onloadend = function () {
        base64data = reader.result;
        response = { Image: base64data, Index: listIndex, List: list };
        deferred.resolve(response);
    };

    return deferred.promise;
};

Helpers.Upload.CheckIfIsBase64String = function (src) {
    if ((src.indexOf("data:image/") === 0) && (src.indexOf(";base64") > 0)) {
        return true;
    }

    return false;
};

Helpers.Upload.GetImageFromBase64 = function (src) {
    var image = src.split(";base64,")[1];

    return image;
};

Helpers.Upload.GetImageTypeFromBase64 = function (src) {
    var imageType = src.substring(5, src.indexOf(";base64"));

    return imageType;
};

Helpers.Upload.AddBase64ToImage = function (image) {
    if (!Helpers.Object.IsUndefinedEmptyOrNull(image) && (image.indexOf(';base64,') < 0)) {
        return 'data:image/gif;base64,' + image;
    }

    return image;
};

Helpers.Upload.GetDefaultImage = function (defaultImage, defaultImageIsUser) {
    var image = 'Application/Images/';

    if (Helpers.Object.IsUndefinedEmptyOrNull(defaultImage)) {
        if (defaultImageIsUser) {
            image += 'FallBackUser.1781708645000.png';
        }
        else {
            image += 'FallBackImage.1781708645000.png';
        }
    }
    else {
        image += defaultImage;
    }

    return image;
};
"use strict";

var Helpers = Helpers || {};

Helpers.Validations = {
    ValidationsParameters: function (originalObject) {
        var newObject;

        if ((originalObject === null) || (typeof originalObject === "undefined")) {
            newObject = originalObject;
        }
        else {
            newObject = JSON.parse(JSON.stringify(originalObject));
        }

        (function filter(originalObject) {
            $.each(originalObject, function (key, value) {
                if (value === "" || value === null) {
                    delete originalObject[key];
                } else if (Object.prototype.toString.call(value) === '[object Object]') {
                    filter(value);
                } else if ($.isArray(value)) {
                    var indexToRemove = [];

                    $.each(value, function (k, v) {
                        if ((v === "") || (v === null)) {
                            indexToRemove.push(k);
                        } else if (typeof v === "object") {
                            filter(v);
                        }
                    });

                    if (indexToRemove.length) {
                        originalObject[key] = value.filter(function (v, index) {
                            return (indexToRemove.indexOf(index) < 0);
                        });
                    }
                }
            });
        })(newObject);

        newObject = RemoveBase64InitialInformation(newObject);

        return newObject;

        function RemoveBase64InitialInformation(newObject) {
            Object.keys(newObject).forEach(function (key) {
                var position;

                if (typeof newObject[key] === 'object' && newObject[key] !== null) {
                    if (newObject[key].length === undefined)
                        newObject[key].length = 0;

                    if (!newObject[key].length) {
                        if (CheckIfIsBase64(newObject[key])) {
                            position = newObject[key].indexOf(',');
                            newObject[key] = newObject[key].substr(position + 1);
                        }
                    }
                    else {
                        for (var i = 0; i < newObject[key].length; i++) {
                            RemoveBase64InitialInformation(newObject[key][i]);
                        }
                    }
                }
                else if (CheckIfIsBase64(newObject[key])) {
                    position = newObject[key].indexOf(',');
                    newObject[key] = newObject[key].substr(position + 1);
                }
            });

            return newObject;
        }

        function CheckIfIsBase64(data) {
            var isBase64 = false;

            try {
                var position = data.indexOf(',');

                if (position !== -1) {
                    window.atob(data.substr(position + 1));
                    isBase64 = true;
                }
            } catch (_exception) {
                return isBase64;
            }
        }
    }
};
"use strict";

var Helpers = Helpers || {};

Helpers.Number = {};

Helpers.Number.ApplyYield = function (value, yieldValue) {
    if (yieldValue <= 0) {
        return 0;
    }

    var result = value * (1 / yieldValue);

    return result;
};

Helpers.Number.FormatNumberDecimalPlaces = function (number, decimalPlaces) {
    if (Number.isInteger(number)) {
        return Math.round(number);
    }

    return number.toFixed(decimalPlaces);
};
"use strict";

var Helpers = Helpers || {};
Helpers.TimeOperations = {};

Helpers.TimeOperations.NumberToTimeInString = function (number) {
    const hours = Math.floor(number);
    let minutes = number - hours;

    minutes = Math.floor(minutes * 0.6 * 100);

    const minutesWithTwoDigits = minutes.toString().padStart(2, "0");

    const timeString = `${hours}:${minutesWithTwoDigits}`;

    return timeString;
};

Helpers.TimeOperations.HoursToTimeSpan = function (hours, removeSeconds, hoursPadStart) {
    let isNegative = false;

    if (hours < 0) {
        isNegative = true;
        hours = Math.abs(hours);
    }

    const totalSeconds = Math.floor(hours * 3600);
    const hh = Math.floor(totalSeconds / 3600);
    const mm = Math.floor((totalSeconds % 3600) / 60);
    const ss = totalSeconds % 60;

    hoursPadStart = hoursPadStart || 3;

    let timeSpan = `${hh.toString().padStart(hoursPadStart, "0")}:${mm.toString().padStart(2, "0")}:${ss.toString().padStart(2, "0")}`;

    if (removeSeconds) {
        timeSpan = timeSpan.slice(0, -3);
    }

    if (isNegative) {
        timeSpan = `-${timeSpan}`;
    }

    return timeSpan;
};

Helpers.TimeOperations.TimeSpanToHours = function (timeSpan) {
    if (!timeSpan) {
        return 0;
    }

    const parts = timeSpan.split(":");

    if ((parts.length < 2) || (parts.length > 3)) {
        return 0;
    }

    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    let seconds = 0;

    if (parts.length === 3) {
        seconds = parseInt(parts[2]);
    }

    const totalHours = (hours + (minutes / 60) + (seconds / 3600));

    return totalHours;
};

Helpers.TimeOperations.GetTimeWithDaysStringFromHours = function (hours) {
    hours = hours || 0;

    const parts = [
        24, 1, (1 / 60), (1 / 3600)
    ];
    const timeParts = [];

    parts.forEach(part => {
        timeParts.push((Math.floor(hours / part) + "").padStart(2, 0));
        hours = hours % part;
    });

    const finalTime = timeParts[0] + "." + timeParts.splice(1).join(":");

    return finalTime;
};

Helpers.TimeOperations.GetHoursFromTimeSpanWithDays = function (timeSpan) {
    const totalSeconds = Helpers.Date.DateToSeconds(timeSpan);
    const totalHours = (totalSeconds / 3600);

    return totalHours;
};
"use strict";

var Helpers = Helpers || {};

Helpers.Workers = {};

Helpers.Workers.CountDownTime = `
    let running = false;
    let timeInSeconds = 0;
    let countingDown = true;

    onmessage = function (e) {
        const data = e.data;

        if (data.command === "start") {
            timeInSeconds = data.timeInSeconds;
            countingDown = data.countingDown;
            running = true;

            Tick();
        } else if (data.command === "stop") {
            running = false;
        } else if (data.command === "update") {
            timeInSeconds = data.timeInSeconds;
        }
    };

    function Tick() {
        if (!running) {
            return
        };

        setTimeout(() => {
            if (countingDown) {
                timeInSeconds--;
            }
            else {
                timeInSeconds++;
            }

            let timeInTimeSpan = GetTimeInTimeSpan(timeInSeconds);

            let dataToSend = {
                TimeInSeconds: timeInSeconds,
                TimeInTimeSpan: timeInTimeSpan,
                CountingDown: countingDown
            }

            postMessage(dataToSend);

            if (timeInSeconds === 0) {
                countingDown = false;
            }

            Tick();
        }, 1000);
    }

    function GetTimeInTimeSpan(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        let timeToDisplay = (hours > 9) ? hours : ('0' + hours);

        let timeInTimeSpan =
                timeToDisplay + ':' +
                ('0' + minutes).slice(-2) + ':' +
                ('0' + seconds).slice(-2);

        return timeInTimeSpan;
    }
`;

Helpers.Workers.CreateCountDownWorker = function () {
    const blob = new Blob([Helpers.Workers.CountDownTime], { type: "application/javascript" });
    const workerURL = URL.createObjectURL(blob);

    let webWorker = new Worker(workerURL);

    return webWorker;
};
"use strict";

var Helpers = Helpers || {};

Helpers.YoutubeOperations = {};

Helpers.YoutubeOperations.GetEmbeddedUrl = function (url) {
    if (!url) {
        return url;
    }

    if ((url.indexOf("youtube.com") < 0) && (url.indexOf("youtu.be") < 0)) {
        return url;
    }

    const videoId = GetVideoId(url);

    if (!videoId) {
        return url;
    }

    const queryStringIndex = url.indexOf("?");
    const queryString = (queryStringIndex >= 0) ? url.substring(queryStringIndex + 1) : "";
    var parameters = GetVideoQueryParameters(queryString);

    if ((parameters.loop === "1") && !parameters.playlist) {
        parameters.playlist = videoId;
    }

    if (!parameters.origin) {
        parameters.origin = GetVideoOrigin();
    }

    const parameterKeys = Object.keys(parameters);
    var embeddedVideoUrl = `https://www.youtube.com/embed/${videoId}`;

    if (parameterKeys.length) {
        const queryParameters = parameterKeys.map(function (key) {
            const parameter = key + "=" + encodeURIComponent(parameters[key]);

            return parameter;
        }).join("&");

        embeddedVideoUrl += `?${queryParameters}`;
    }

    return embeddedVideoUrl;
};

function GetVideoId(url) {
    const embedMarker = "youtube.com/embed/";
    const shortMarker = "youtu.be/";
    const watchMarker = "v=";
    var videoId = "";

    if (url.indexOf(embedMarker) >= 0) {
        videoId = url.split(embedMarker)[1] || "";
    } else if (url.indexOf(shortMarker) >= 0) {
        videoId = url.split(shortMarker)[1] || "";
    } else if (url.indexOf(watchMarker) >= 0) {
        videoId = url.split(watchMarker)[1] || "";
    }

    if (!videoId) {
        return null;
    }

    videoId = videoId.split("?")[0].split("&")[0].split("/")[0] || null;

    return videoId;
}

function GetVideoQueryParameters(queryString) {
    var parameters = {};

    if (!queryString) {
        return parameters;
    }

    queryString.split("&").forEach(function (parameter) {
        if (!parameter) {
            return;
        }

        const parameterParts = parameter.split("=");
        const key = parameterParts[0];

        if (!key) {
            return;
        }

        const value = (parameterParts.length > 1) ? decodeURIComponent(parameterParts.slice(1).join("=")) : "";

        parameters[key] = value;
    });

    return parameters;
}

function GetVideoOrigin() {
    const currentLocation = window.location;
    const origin = currentLocation.protocol + "//" + currentLocation.host;

    return origin;
}